
      var $parcel$global = globalThis;
    /*
 * @TODO IMPORTANT
 * THIS APP'S AUTH IS NOT FULLY readyState
 * When using any of the available Social Identity Providers, you need to register
 * your application with the relevant Identity Provider in order to obtain
 * a Client ID and Client Secret.
 * https://auth0.com/docs/connections/social/devkeys
 */ /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $c5aa5a6035c47210$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
var $c5aa5a6035c47210$var$e = function(t, n) {
    return $c5aa5a6035c47210$var$e = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(e, t) {
        e.__proto__ = t;
    } || function(e, t) {
        for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }, $c5aa5a6035c47210$var$e(t, n);
};
function $c5aa5a6035c47210$var$t(t, n) {
    if ("function" != typeof n && null !== n) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    function r() {
        this.constructor = t;
    }
    $c5aa5a6035c47210$var$e(t, n), t.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r);
}
var $c5aa5a6035c47210$var$n = function() {
    return $c5aa5a6035c47210$var$n = Object.assign || function(e) {
        for(var t, n = 1, r = arguments.length; n < r; n++)for(var o in t = arguments[n])Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
    }, $c5aa5a6035c47210$var$n.apply(this, arguments);
};
function $c5aa5a6035c47210$var$r(e, t) {
    var n = {};
    for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;
        for(r = Object.getOwnPropertySymbols(e); o < r.length; o++)t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
    }
    return n;
}
function $c5aa5a6035c47210$var$o(e, t, n, r) {
    return new (n || (n = Promise))(function(o, i) {
        function c(e) {
            try {
                s(r.next(e));
            } catch (e) {
                i(e);
            }
        }
        function a(e) {
            try {
                s(r.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function s(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(c, a);
        }
        s((r = r.apply(e, t || [])).next());
    });
}
function $c5aa5a6035c47210$var$i(e, t) {
    var n, r, o, i, c = {
        label: 0,
        sent: function() {
            if (1 & o[0]) throw o[1];
            return o[1];
        },
        trys: [],
        ops: []
    };
    return i = {
        next: a(0),
        throw: a(1),
        return: a(2)
    }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
        return this;
    }), i;
    function a(i) {
        return function(a) {
            return function(i) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; c;)try {
                    if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                    switch(r = 0, o && (i = [
                        2 & i[0],
                        o.value
                    ]), i[0]){
                        case 0:
                        case 1:
                            o = i;
                            break;
                        case 4:
                            return c.label++, {
                                value: i[1],
                                done: !1
                            };
                        case 5:
                            c.label++, r = i[1], i = [
                                0
                            ];
                            continue;
                        case 7:
                            i = c.ops.pop(), c.trys.pop();
                            continue;
                        default:
                            if (!(o = c.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                c = 0;
                                continue;
                            }
                            if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                                c.label = i[1];
                                break;
                            }
                            if (6 === i[0] && c.label < o[1]) {
                                c.label = o[1], o = i;
                                break;
                            }
                            if (o && c.label < o[2]) {
                                c.label = o[2], c.ops.push(i);
                                break;
                            }
                            o[2] && c.ops.pop(), c.trys.pop();
                            continue;
                    }
                    i = t.call(e, c);
                } catch (e) {
                    i = [
                        6,
                        e
                    ], r = 0;
                } finally{
                    n = o = 0;
                }
                if (5 & i[0]) throw i[1];
                return {
                    value: i[0] ? i[1] : void 0,
                    done: !0
                };
            }([
                i,
                a
            ]);
        };
    }
}
function $c5aa5a6035c47210$var$c(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var r, o, i = n.call(e), c = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(r = i.next()).done;)c.push(r.value);
    } catch (e) {
        o = {
            error: e
        };
    } finally{
        try {
            r && !r.done && (n = i.return) && n.call(i);
        } finally{
            if (o) throw o.error;
        }
    }
    return c;
}
function $c5aa5a6035c47210$var$a(e, t, n) {
    if (n || 2 === arguments.length) for(var r, o = 0, i = t.length; o < i; o++)!r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
    return e.concat(r || Array.prototype.slice.call(t));
}
var $c5aa5a6035c47210$var$s = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
function $c5aa5a6035c47210$var$u(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function $c5aa5a6035c47210$var$l(e, t) {
    return e(t = {
        exports: {}
    }, t.exports), t.exports;
}
var $c5aa5a6035c47210$var$f, $c5aa5a6035c47210$var$d, $c5aa5a6035c47210$var$h = function(e) {
    return e && e.Math == Math && e;
}, $c5aa5a6035c47210$var$p = $c5aa5a6035c47210$var$h("object" == typeof globalThis && globalThis) || $c5aa5a6035c47210$var$h("object" == typeof window && window) || $c5aa5a6035c47210$var$h("object" == typeof self && self) || $c5aa5a6035c47210$var$h("object" == typeof $c5aa5a6035c47210$var$s && $c5aa5a6035c47210$var$s) || function() {
    return this;
}() || Function("return this")(), $c5aa5a6035c47210$var$y = function(e) {
    try {
        return !!e();
    } catch (e) {
        return !0;
    }
}, $c5aa5a6035c47210$var$v = !$c5aa5a6035c47210$var$y(function() {
    return 7 != Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1];
}), $c5aa5a6035c47210$var$m = !$c5aa5a6035c47210$var$y(function() {
    var e = (function() {}).bind();
    return "function" != typeof e || e.hasOwnProperty("prototype");
}), $c5aa5a6035c47210$var$b = Function.prototype.call, $c5aa5a6035c47210$var$g = $c5aa5a6035c47210$var$m ? $c5aa5a6035c47210$var$b.bind($c5aa5a6035c47210$var$b) : function() {
    return $c5aa5a6035c47210$var$b.apply($c5aa5a6035c47210$var$b, arguments);
}, $c5aa5a6035c47210$var$w = {}.propertyIsEnumerable, $c5aa5a6035c47210$var$S = Object.getOwnPropertyDescriptor, $c5aa5a6035c47210$var$k = $c5aa5a6035c47210$var$S && !$c5aa5a6035c47210$var$w.call({
    1: 2
}, 1) ? function(e) {
    var t = $c5aa5a6035c47210$var$S(this, e);
    return !!t && t.enumerable;
} : $c5aa5a6035c47210$var$w, $c5aa5a6035c47210$var$_ = {
    f: $c5aa5a6035c47210$var$k
}, $c5aa5a6035c47210$var$I = function(e, t) {
    return {
        enumerable: !(1 & e),
        configurable: !(2 & e),
        writable: !(4 & e),
        value: t
    };
}, $c5aa5a6035c47210$var$O = Function, $c5aa5a6035c47210$var$x = $c5aa5a6035c47210$var$O.prototype, $c5aa5a6035c47210$var$T = $c5aa5a6035c47210$var$x.bind, $c5aa5a6035c47210$var$C = $c5aa5a6035c47210$var$x.call, $c5aa5a6035c47210$var$j = $c5aa5a6035c47210$var$m && $c5aa5a6035c47210$var$T.bind($c5aa5a6035c47210$var$C, $c5aa5a6035c47210$var$C), $c5aa5a6035c47210$var$L = function(e) {
    return e instanceof $c5aa5a6035c47210$var$O ? $c5aa5a6035c47210$var$m ? $c5aa5a6035c47210$var$j(e) : function() {
        return $c5aa5a6035c47210$var$C.apply(e, arguments);
    } : void 0;
}, $c5aa5a6035c47210$var$R = $c5aa5a6035c47210$var$L({}.toString), $c5aa5a6035c47210$var$W = $c5aa5a6035c47210$var$L("".slice), $c5aa5a6035c47210$var$Z = function(e) {
    return $c5aa5a6035c47210$var$W($c5aa5a6035c47210$var$R(e), 8, -1);
}, $c5aa5a6035c47210$var$E = Object, $c5aa5a6035c47210$var$G = $c5aa5a6035c47210$var$L("".split), $c5aa5a6035c47210$var$A = $c5aa5a6035c47210$var$y(function() {
    return !$c5aa5a6035c47210$var$E("z").propertyIsEnumerable(0);
}) ? function(e) {
    return "String" == $c5aa5a6035c47210$var$Z(e) ? $c5aa5a6035c47210$var$G(e, "") : $c5aa5a6035c47210$var$E(e);
} : $c5aa5a6035c47210$var$E, $c5aa5a6035c47210$var$P = function(e) {
    return null == e;
}, $c5aa5a6035c47210$var$X = TypeError, $c5aa5a6035c47210$var$F = function(e) {
    if ($c5aa5a6035c47210$var$P(e)) throw $c5aa5a6035c47210$var$X("Can't call method on " + e);
    return e;
}, $c5aa5a6035c47210$var$K = function(e) {
    return $c5aa5a6035c47210$var$A($c5aa5a6035c47210$var$F(e));
}, $c5aa5a6035c47210$var$N = "object" == typeof document && document.all, $c5aa5a6035c47210$var$U = {
    all: $c5aa5a6035c47210$var$N,
    IS_HTMLDDA: void 0 === $c5aa5a6035c47210$var$N && void 0 !== $c5aa5a6035c47210$var$N
}, $c5aa5a6035c47210$var$D = $c5aa5a6035c47210$var$U.all, $c5aa5a6035c47210$var$H = $c5aa5a6035c47210$var$U.IS_HTMLDDA ? function(e) {
    return "function" == typeof e || e === $c5aa5a6035c47210$var$D;
} : function(e) {
    return "function" == typeof e;
}, $c5aa5a6035c47210$var$Y = $c5aa5a6035c47210$var$U.all, $c5aa5a6035c47210$var$J = $c5aa5a6035c47210$var$U.IS_HTMLDDA ? function(e) {
    return "object" == typeof e ? null !== e : $c5aa5a6035c47210$var$H(e) || e === $c5aa5a6035c47210$var$Y;
} : function(e) {
    return "object" == typeof e ? null !== e : $c5aa5a6035c47210$var$H(e);
}, $c5aa5a6035c47210$var$V = function(e) {
    return $c5aa5a6035c47210$var$H(e) ? e : void 0;
}, $c5aa5a6035c47210$var$z = function(e, t) {
    return arguments.length < 2 ? $c5aa5a6035c47210$var$V($c5aa5a6035c47210$var$p[e]) : $c5aa5a6035c47210$var$p[e] && $c5aa5a6035c47210$var$p[e][t];
}, $c5aa5a6035c47210$var$M = $c5aa5a6035c47210$var$L({}.isPrototypeOf), $c5aa5a6035c47210$var$B = $c5aa5a6035c47210$var$z("navigator", "userAgent") || "", $c5aa5a6035c47210$var$Q = $c5aa5a6035c47210$var$p.process, $c5aa5a6035c47210$var$q = $c5aa5a6035c47210$var$p.Deno, $c5aa5a6035c47210$var$$ = $c5aa5a6035c47210$var$Q && $c5aa5a6035c47210$var$Q.versions || $c5aa5a6035c47210$var$q && $c5aa5a6035c47210$var$q.version, $c5aa5a6035c47210$var$ee = $c5aa5a6035c47210$var$$ && $c5aa5a6035c47210$var$$.v8;
$c5aa5a6035c47210$var$ee && ($c5aa5a6035c47210$var$d = ($c5aa5a6035c47210$var$f = $c5aa5a6035c47210$var$ee.split("."))[0] > 0 && $c5aa5a6035c47210$var$f[0] < 4 ? 1 : +($c5aa5a6035c47210$var$f[0] + $c5aa5a6035c47210$var$f[1])), !$c5aa5a6035c47210$var$d && $c5aa5a6035c47210$var$B && (!($c5aa5a6035c47210$var$f = $c5aa5a6035c47210$var$B.match(/Edge\/(\d+)/)) || $c5aa5a6035c47210$var$f[1] >= 74) && ($c5aa5a6035c47210$var$f = $c5aa5a6035c47210$var$B.match(/Chrome\/(\d+)/)) && ($c5aa5a6035c47210$var$d = +$c5aa5a6035c47210$var$f[1]);
var $c5aa5a6035c47210$var$te = $c5aa5a6035c47210$var$d, $c5aa5a6035c47210$var$ne = !!Object.getOwnPropertySymbols && !$c5aa5a6035c47210$var$y(function() {
    var e = Symbol();
    return !String(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && $c5aa5a6035c47210$var$te && $c5aa5a6035c47210$var$te < 41;
}), $c5aa5a6035c47210$var$re = $c5aa5a6035c47210$var$ne && !Symbol.sham && "symbol" == typeof Symbol.iterator, $c5aa5a6035c47210$var$oe = Object, $c5aa5a6035c47210$var$ie = $c5aa5a6035c47210$var$re ? function(e) {
    return "symbol" == typeof e;
} : function(e) {
    var t = $c5aa5a6035c47210$var$z("Symbol");
    return $c5aa5a6035c47210$var$H(t) && $c5aa5a6035c47210$var$M(t.prototype, $c5aa5a6035c47210$var$oe(e));
}, $c5aa5a6035c47210$var$ce = String, $c5aa5a6035c47210$var$ae = function(e) {
    try {
        return $c5aa5a6035c47210$var$ce(e);
    } catch (e) {
        return "Object";
    }
}, $c5aa5a6035c47210$var$se = TypeError, $c5aa5a6035c47210$var$ue = function(e) {
    if ($c5aa5a6035c47210$var$H(e)) return e;
    throw $c5aa5a6035c47210$var$se($c5aa5a6035c47210$var$ae(e) + " is not a function");
}, $c5aa5a6035c47210$var$le = function(e, t) {
    var n = e[t];
    return $c5aa5a6035c47210$var$P(n) ? void 0 : $c5aa5a6035c47210$var$ue(n);
}, $c5aa5a6035c47210$var$fe = TypeError, $c5aa5a6035c47210$var$de = Object.defineProperty, $c5aa5a6035c47210$var$he = function(e, t) {
    try {
        $c5aa5a6035c47210$var$de($c5aa5a6035c47210$var$p, e, {
            value: t,
            configurable: !0,
            writable: !0
        });
    } catch (n) {
        $c5aa5a6035c47210$var$p[e] = t;
    }
    return t;
}, $c5aa5a6035c47210$var$pe = $c5aa5a6035c47210$var$p["__core-js_shared__"] || $c5aa5a6035c47210$var$he("__core-js_shared__", {}), $c5aa5a6035c47210$var$ye = $c5aa5a6035c47210$var$l(function(e) {
    (e.exports = function(e, t) {
        return $c5aa5a6035c47210$var$pe[e] || ($c5aa5a6035c47210$var$pe[e] = void 0 !== t ? t : {});
    })("versions", []).push({
        version: "3.25.4",
        mode: "global",
        copyright: "\xa9 2014-2022 Denis Pushkarev (zloirock.ru)",
        license: "https://github.com/zloirock/core-js/blob/v3.25.4/LICENSE",
        source: "https://github.com/zloirock/core-js"
    });
}), $c5aa5a6035c47210$var$ve = Object, $c5aa5a6035c47210$var$me = function(e) {
    return $c5aa5a6035c47210$var$ve($c5aa5a6035c47210$var$F(e));
}, $c5aa5a6035c47210$var$be = $c5aa5a6035c47210$var$L({}.hasOwnProperty), $c5aa5a6035c47210$var$ge = Object.hasOwn || function(e, t) {
    return $c5aa5a6035c47210$var$be($c5aa5a6035c47210$var$me(e), t);
}, $c5aa5a6035c47210$var$we = 0, $c5aa5a6035c47210$var$Se = Math.random(), $c5aa5a6035c47210$var$ke = $c5aa5a6035c47210$var$L(1..toString), $c5aa5a6035c47210$var$_e = function(e) {
    return "Symbol(" + (void 0 === e ? "" : e) + ")_" + $c5aa5a6035c47210$var$ke(++$c5aa5a6035c47210$var$we + $c5aa5a6035c47210$var$Se, 36);
}, $c5aa5a6035c47210$var$Ie = $c5aa5a6035c47210$var$ye("wks"), $c5aa5a6035c47210$var$Oe = $c5aa5a6035c47210$var$p.Symbol, $c5aa5a6035c47210$var$xe = $c5aa5a6035c47210$var$Oe && $c5aa5a6035c47210$var$Oe.for, $c5aa5a6035c47210$var$Te = $c5aa5a6035c47210$var$re ? $c5aa5a6035c47210$var$Oe : $c5aa5a6035c47210$var$Oe && $c5aa5a6035c47210$var$Oe.withoutSetter || $c5aa5a6035c47210$var$_e, $c5aa5a6035c47210$var$Ce = function(e) {
    if (!$c5aa5a6035c47210$var$ge($c5aa5a6035c47210$var$Ie, e) || !$c5aa5a6035c47210$var$ne && "string" != typeof $c5aa5a6035c47210$var$Ie[e]) {
        var t = "Symbol." + e;
        $c5aa5a6035c47210$var$ne && $c5aa5a6035c47210$var$ge($c5aa5a6035c47210$var$Oe, e) ? $c5aa5a6035c47210$var$Ie[e] = $c5aa5a6035c47210$var$Oe[e] : $c5aa5a6035c47210$var$Ie[e] = $c5aa5a6035c47210$var$re && $c5aa5a6035c47210$var$xe ? $c5aa5a6035c47210$var$xe(t) : $c5aa5a6035c47210$var$Te(t);
    }
    return $c5aa5a6035c47210$var$Ie[e];
}, $c5aa5a6035c47210$var$je = TypeError, $c5aa5a6035c47210$var$Le = $c5aa5a6035c47210$var$Ce("toPrimitive"), $c5aa5a6035c47210$var$Re = function(e, t) {
    if (!$c5aa5a6035c47210$var$J(e) || $c5aa5a6035c47210$var$ie(e)) return e;
    var n, r = $c5aa5a6035c47210$var$le(e, $c5aa5a6035c47210$var$Le);
    if (r) {
        if (void 0 === t && (t = "default"), n = $c5aa5a6035c47210$var$g(r, e, t), !$c5aa5a6035c47210$var$J(n) || $c5aa5a6035c47210$var$ie(n)) return n;
        throw $c5aa5a6035c47210$var$je("Can't convert object to primitive value");
    }
    return void 0 === t && (t = "number"), function(e, t) {
        var n, r;
        if ("string" === t && $c5aa5a6035c47210$var$H(n = e.toString) && !$c5aa5a6035c47210$var$J(r = $c5aa5a6035c47210$var$g(n, e))) return r;
        if ($c5aa5a6035c47210$var$H(n = e.valueOf) && !$c5aa5a6035c47210$var$J(r = $c5aa5a6035c47210$var$g(n, e))) return r;
        if ("string" !== t && $c5aa5a6035c47210$var$H(n = e.toString) && !$c5aa5a6035c47210$var$J(r = $c5aa5a6035c47210$var$g(n, e))) return r;
        throw $c5aa5a6035c47210$var$fe("Can't convert object to primitive value");
    }(e, t);
}, $c5aa5a6035c47210$var$We = function(e) {
    var t = $c5aa5a6035c47210$var$Re(e, "string");
    return $c5aa5a6035c47210$var$ie(t) ? t : t + "";
}, $c5aa5a6035c47210$var$Ze = $c5aa5a6035c47210$var$p.document, $c5aa5a6035c47210$var$Ee = $c5aa5a6035c47210$var$J($c5aa5a6035c47210$var$Ze) && $c5aa5a6035c47210$var$J($c5aa5a6035c47210$var$Ze.createElement), $c5aa5a6035c47210$var$Ge = function(e) {
    return $c5aa5a6035c47210$var$Ee ? $c5aa5a6035c47210$var$Ze.createElement(e) : {};
}, $c5aa5a6035c47210$var$Ae = !$c5aa5a6035c47210$var$v && !$c5aa5a6035c47210$var$y(function() {
    return 7 != Object.defineProperty($c5aa5a6035c47210$var$Ge("div"), "a", {
        get: function() {
            return 7;
        }
    }).a;
}), $c5aa5a6035c47210$var$Pe = Object.getOwnPropertyDescriptor, $c5aa5a6035c47210$var$Xe = {
    f: $c5aa5a6035c47210$var$v ? $c5aa5a6035c47210$var$Pe : function(e, t) {
        if (e = $c5aa5a6035c47210$var$K(e), t = $c5aa5a6035c47210$var$We(t), $c5aa5a6035c47210$var$Ae) try {
            return $c5aa5a6035c47210$var$Pe(e, t);
        } catch (e) {}
        if ($c5aa5a6035c47210$var$ge(e, t)) return $c5aa5a6035c47210$var$I(!$c5aa5a6035c47210$var$g($c5aa5a6035c47210$var$_.f, e, t), e[t]);
    }
}, $c5aa5a6035c47210$var$Fe = $c5aa5a6035c47210$var$v && $c5aa5a6035c47210$var$y(function() {
    return 42 != Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: !1
    }).prototype;
}), $c5aa5a6035c47210$var$Ke = String, $c5aa5a6035c47210$var$Ne = TypeError, $c5aa5a6035c47210$var$Ue = function(e) {
    if ($c5aa5a6035c47210$var$J(e)) return e;
    throw $c5aa5a6035c47210$var$Ne($c5aa5a6035c47210$var$Ke(e) + " is not an object");
}, $c5aa5a6035c47210$var$De = TypeError, $c5aa5a6035c47210$var$He = Object.defineProperty, $c5aa5a6035c47210$var$Ye = Object.getOwnPropertyDescriptor, $c5aa5a6035c47210$var$Je = {
    f: $c5aa5a6035c47210$var$v ? $c5aa5a6035c47210$var$Fe ? function(e, t, n) {
        if ($c5aa5a6035c47210$var$Ue(e), t = $c5aa5a6035c47210$var$We(t), $c5aa5a6035c47210$var$Ue(n), "function" == typeof e && "prototype" === t && "value" in n && "writable" in n && !n.writable) {
            var r = $c5aa5a6035c47210$var$Ye(e, t);
            r && r.writable && (e[t] = n.value, n = {
                configurable: "configurable" in n ? n.configurable : r.configurable,
                enumerable: "enumerable" in n ? n.enumerable : r.enumerable,
                writable: !1
            });
        }
        return $c5aa5a6035c47210$var$He(e, t, n);
    } : $c5aa5a6035c47210$var$He : function(e, t, n) {
        if ($c5aa5a6035c47210$var$Ue(e), t = $c5aa5a6035c47210$var$We(t), $c5aa5a6035c47210$var$Ue(n), $c5aa5a6035c47210$var$Ae) try {
            return $c5aa5a6035c47210$var$He(e, t, n);
        } catch (e) {}
        if ("get" in n || "set" in n) throw $c5aa5a6035c47210$var$De("Accessors not supported");
        return "value" in n && (e[t] = n.value), e;
    }
}, $c5aa5a6035c47210$var$Ve = $c5aa5a6035c47210$var$v ? function(e, t, n) {
    return $c5aa5a6035c47210$var$Je.f(e, t, $c5aa5a6035c47210$var$I(1, n));
} : function(e, t, n) {
    return e[t] = n, e;
}, $c5aa5a6035c47210$var$ze = Function.prototype, $c5aa5a6035c47210$var$Me = $c5aa5a6035c47210$var$v && Object.getOwnPropertyDescriptor, $c5aa5a6035c47210$var$Be = $c5aa5a6035c47210$var$ge($c5aa5a6035c47210$var$ze, "name"), $c5aa5a6035c47210$var$Qe = {
    EXISTS: $c5aa5a6035c47210$var$Be,
    PROPER: $c5aa5a6035c47210$var$Be && "something" === (function() {}).name,
    CONFIGURABLE: $c5aa5a6035c47210$var$Be && (!$c5aa5a6035c47210$var$v || $c5aa5a6035c47210$var$v && $c5aa5a6035c47210$var$Me($c5aa5a6035c47210$var$ze, "name").configurable)
}, $c5aa5a6035c47210$var$qe = $c5aa5a6035c47210$var$L(Function.toString);
$c5aa5a6035c47210$var$H($c5aa5a6035c47210$var$pe.inspectSource) || ($c5aa5a6035c47210$var$pe.inspectSource = function(e) {
    return $c5aa5a6035c47210$var$qe(e);
});
var $c5aa5a6035c47210$var$$e, $c5aa5a6035c47210$var$et, $c5aa5a6035c47210$var$tt, $c5aa5a6035c47210$var$nt = $c5aa5a6035c47210$var$pe.inspectSource, $c5aa5a6035c47210$var$rt = $c5aa5a6035c47210$var$p.WeakMap, $c5aa5a6035c47210$var$ot = $c5aa5a6035c47210$var$H($c5aa5a6035c47210$var$rt) && /native code/.test(String($c5aa5a6035c47210$var$rt)), $c5aa5a6035c47210$var$it = $c5aa5a6035c47210$var$ye("keys"), $c5aa5a6035c47210$var$ct = function(e) {
    return $c5aa5a6035c47210$var$it[e] || ($c5aa5a6035c47210$var$it[e] = $c5aa5a6035c47210$var$_e(e));
}, $c5aa5a6035c47210$var$at = {}, $c5aa5a6035c47210$var$st = $c5aa5a6035c47210$var$p.TypeError, $c5aa5a6035c47210$var$ut = $c5aa5a6035c47210$var$p.WeakMap;
if ($c5aa5a6035c47210$var$ot || $c5aa5a6035c47210$var$pe.state) {
    var $c5aa5a6035c47210$var$lt = $c5aa5a6035c47210$var$pe.state || ($c5aa5a6035c47210$var$pe.state = new $c5aa5a6035c47210$var$ut), $c5aa5a6035c47210$var$ft = $c5aa5a6035c47210$var$L($c5aa5a6035c47210$var$lt.get), $c5aa5a6035c47210$var$dt = $c5aa5a6035c47210$var$L($c5aa5a6035c47210$var$lt.has), $c5aa5a6035c47210$var$ht = $c5aa5a6035c47210$var$L($c5aa5a6035c47210$var$lt.set);
    $c5aa5a6035c47210$var$$e = function(e, t) {
        if ($c5aa5a6035c47210$var$dt($c5aa5a6035c47210$var$lt, e)) throw $c5aa5a6035c47210$var$st("Object already initialized");
        return t.facade = e, $c5aa5a6035c47210$var$ht($c5aa5a6035c47210$var$lt, e, t), t;
    }, $c5aa5a6035c47210$var$et = function(e) {
        return $c5aa5a6035c47210$var$ft($c5aa5a6035c47210$var$lt, e) || {};
    }, $c5aa5a6035c47210$var$tt = function(e) {
        return $c5aa5a6035c47210$var$dt($c5aa5a6035c47210$var$lt, e);
    };
} else {
    var $c5aa5a6035c47210$var$pt = $c5aa5a6035c47210$var$ct("state");
    $c5aa5a6035c47210$var$at[$c5aa5a6035c47210$var$pt] = !0, $c5aa5a6035c47210$var$$e = function(e, t) {
        if ($c5aa5a6035c47210$var$ge(e, $c5aa5a6035c47210$var$pt)) throw $c5aa5a6035c47210$var$st("Object already initialized");
        return t.facade = e, $c5aa5a6035c47210$var$Ve(e, $c5aa5a6035c47210$var$pt, t), t;
    }, $c5aa5a6035c47210$var$et = function(e) {
        return $c5aa5a6035c47210$var$ge(e, $c5aa5a6035c47210$var$pt) ? e[$c5aa5a6035c47210$var$pt] : {};
    }, $c5aa5a6035c47210$var$tt = function(e) {
        return $c5aa5a6035c47210$var$ge(e, $c5aa5a6035c47210$var$pt);
    };
}
var $c5aa5a6035c47210$var$yt = {
    set: $c5aa5a6035c47210$var$$e,
    get: $c5aa5a6035c47210$var$et,
    has: $c5aa5a6035c47210$var$tt,
    enforce: function(e) {
        return $c5aa5a6035c47210$var$tt(e) ? $c5aa5a6035c47210$var$et(e) : $c5aa5a6035c47210$var$$e(e, {});
    },
    getterFor: function(e) {
        return function(t) {
            var n;
            if (!$c5aa5a6035c47210$var$J(t) || (n = $c5aa5a6035c47210$var$et(t)).type !== e) throw $c5aa5a6035c47210$var$st("Incompatible receiver, " + e + " required");
            return n;
        };
    }
}, $c5aa5a6035c47210$var$vt = $c5aa5a6035c47210$var$l(function(e) {
    var t = $c5aa5a6035c47210$var$Qe.CONFIGURABLE, n = $c5aa5a6035c47210$var$yt.enforce, r = $c5aa5a6035c47210$var$yt.get, o = Object.defineProperty, i = $c5aa5a6035c47210$var$v && !$c5aa5a6035c47210$var$y(function() {
        return 8 !== o(function() {}, "length", {
            value: 8
        }).length;
    }), c = String(String).split("String"), a = e.exports = function(e, r, a) {
        "Symbol(" === String(r).slice(0, 7) && (r = "[" + String(r).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), a && a.getter && (r = "get " + r), a && a.setter && (r = "set " + r), (!$c5aa5a6035c47210$var$ge(e, "name") || t && e.name !== r) && ($c5aa5a6035c47210$var$v ? o(e, "name", {
            value: r,
            configurable: !0
        }) : e.name = r), i && a && $c5aa5a6035c47210$var$ge(a, "arity") && e.length !== a.arity && o(e, "length", {
            value: a.arity
        });
        try {
            a && $c5aa5a6035c47210$var$ge(a, "constructor") && a.constructor ? $c5aa5a6035c47210$var$v && o(e, "prototype", {
                writable: !1
            }) : e.prototype && (e.prototype = void 0);
        } catch (e) {}
        var s = n(e);
        return $c5aa5a6035c47210$var$ge(s, "source") || (s.source = c.join("string" == typeof r ? r : "")), e;
    };
    Function.prototype.toString = a(function() {
        return $c5aa5a6035c47210$var$H(this) && r(this).source || $c5aa5a6035c47210$var$nt(this);
    }, "toString");
}), $c5aa5a6035c47210$var$mt = function(e, t, n, r) {
    r || (r = {});
    var o = r.enumerable, i = void 0 !== r.name ? r.name : t;
    if ($c5aa5a6035c47210$var$H(n) && $c5aa5a6035c47210$var$vt(n, i, r), r.global) o ? e[t] = n : $c5aa5a6035c47210$var$he(t, n);
    else {
        try {
            r.unsafe ? e[t] && (o = !0) : delete e[t];
        } catch (e) {}
        o ? e[t] = n : $c5aa5a6035c47210$var$Je.f(e, t, {
            value: n,
            enumerable: !1,
            configurable: !r.nonConfigurable,
            writable: !r.nonWritable
        });
    }
    return e;
}, $c5aa5a6035c47210$var$bt = Math.ceil, $c5aa5a6035c47210$var$gt = Math.floor, $c5aa5a6035c47210$var$wt = Math.trunc || function(e) {
    var t = +e;
    return (t > 0 ? $c5aa5a6035c47210$var$gt : $c5aa5a6035c47210$var$bt)(t);
}, $c5aa5a6035c47210$var$St = function(e) {
    var t = +e;
    return t != t || 0 === t ? 0 : $c5aa5a6035c47210$var$wt(t);
}, $c5aa5a6035c47210$var$kt = Math.max, $c5aa5a6035c47210$var$_t = Math.min, $c5aa5a6035c47210$var$It = function(e, t) {
    var n = $c5aa5a6035c47210$var$St(e);
    return n < 0 ? $c5aa5a6035c47210$var$kt(n + t, 0) : $c5aa5a6035c47210$var$_t(n, t);
}, $c5aa5a6035c47210$var$Ot = Math.min, $c5aa5a6035c47210$var$xt = function(e) {
    return e > 0 ? $c5aa5a6035c47210$var$Ot($c5aa5a6035c47210$var$St(e), 9007199254740991) : 0;
}, $c5aa5a6035c47210$var$Tt = function(e) {
    return $c5aa5a6035c47210$var$xt(e.length);
}, $c5aa5a6035c47210$var$Ct = function(e) {
    return function(t, n, r) {
        var o, i = $c5aa5a6035c47210$var$K(t), c = $c5aa5a6035c47210$var$Tt(i), a = $c5aa5a6035c47210$var$It(r, c);
        if (e && n != n) {
            for(; c > a;)if ((o = i[a++]) != o) return !0;
        } else for(; c > a; a++)if ((e || a in i) && i[a] === n) return e || a || 0;
        return !e && -1;
    };
}, $c5aa5a6035c47210$var$jt = {
    includes: $c5aa5a6035c47210$var$Ct(!0),
    indexOf: $c5aa5a6035c47210$var$Ct(!1)
}, $c5aa5a6035c47210$var$Lt = $c5aa5a6035c47210$var$jt.indexOf, $c5aa5a6035c47210$var$Rt = $c5aa5a6035c47210$var$L([].push), $c5aa5a6035c47210$var$Wt = function(e, t) {
    var n, r = $c5aa5a6035c47210$var$K(e), o = 0, i = [];
    for(n in r)!$c5aa5a6035c47210$var$ge($c5aa5a6035c47210$var$at, n) && $c5aa5a6035c47210$var$ge(r, n) && $c5aa5a6035c47210$var$Rt(i, n);
    for(; t.length > o;)$c5aa5a6035c47210$var$ge(r, n = t[o++]) && (~$c5aa5a6035c47210$var$Lt(i, n) || $c5aa5a6035c47210$var$Rt(i, n));
    return i;
}, $c5aa5a6035c47210$var$Zt = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
], $c5aa5a6035c47210$var$Et = $c5aa5a6035c47210$var$Zt.concat("length", "prototype"), $c5aa5a6035c47210$var$Gt = {
    f: Object.getOwnPropertyNames || function(e) {
        return $c5aa5a6035c47210$var$Wt(e, $c5aa5a6035c47210$var$Et);
    }
}, $c5aa5a6035c47210$var$At = {
    f: Object.getOwnPropertySymbols
}, $c5aa5a6035c47210$var$Pt = $c5aa5a6035c47210$var$L([].concat), $c5aa5a6035c47210$var$Xt = $c5aa5a6035c47210$var$z("Reflect", "ownKeys") || function(e) {
    var t = $c5aa5a6035c47210$var$Gt.f($c5aa5a6035c47210$var$Ue(e)), n = $c5aa5a6035c47210$var$At.f;
    return n ? $c5aa5a6035c47210$var$Pt(t, n(e)) : t;
}, $c5aa5a6035c47210$var$Ft = function(e, t, n) {
    for(var r = $c5aa5a6035c47210$var$Xt(t), o = $c5aa5a6035c47210$var$Je.f, i = $c5aa5a6035c47210$var$Xe.f, c = 0; c < r.length; c++){
        var a = r[c];
        $c5aa5a6035c47210$var$ge(e, a) || n && $c5aa5a6035c47210$var$ge(n, a) || o(e, a, i(t, a));
    }
}, $c5aa5a6035c47210$var$Kt = /#|\.prototype\./, $c5aa5a6035c47210$var$Nt = function(e, t) {
    var n = $c5aa5a6035c47210$var$Dt[$c5aa5a6035c47210$var$Ut(e)];
    return n == $c5aa5a6035c47210$var$Yt || n != $c5aa5a6035c47210$var$Ht && ($c5aa5a6035c47210$var$H(t) ? $c5aa5a6035c47210$var$y(t) : !!t);
}, $c5aa5a6035c47210$var$Ut = $c5aa5a6035c47210$var$Nt.normalize = function(e) {
    return String(e).replace($c5aa5a6035c47210$var$Kt, ".").toLowerCase();
}, $c5aa5a6035c47210$var$Dt = $c5aa5a6035c47210$var$Nt.data = {}, $c5aa5a6035c47210$var$Ht = $c5aa5a6035c47210$var$Nt.NATIVE = "N", $c5aa5a6035c47210$var$Yt = $c5aa5a6035c47210$var$Nt.POLYFILL = "P", $c5aa5a6035c47210$var$Jt = $c5aa5a6035c47210$var$Nt, $c5aa5a6035c47210$var$Vt = $c5aa5a6035c47210$var$Xe.f, $c5aa5a6035c47210$var$zt = function(e, t) {
    var n, r, o, i, c, a = e.target, s = e.global, u = e.stat;
    if (n = s ? $c5aa5a6035c47210$var$p : u ? $c5aa5a6035c47210$var$p[a] || $c5aa5a6035c47210$var$he(a, {}) : ($c5aa5a6035c47210$var$p[a] || {}).prototype) for(r in t){
        if (i = t[r], o = e.dontCallGetSet ? (c = $c5aa5a6035c47210$var$Vt(n, r)) && c.value : n[r], !$c5aa5a6035c47210$var$Jt(s ? r : a + (u ? "." : "#") + r, e.forced) && void 0 !== o) {
            if (typeof i == typeof o) continue;
            $c5aa5a6035c47210$var$Ft(i, o);
        }
        (e.sham || o && o.sham) && $c5aa5a6035c47210$var$Ve(i, "sham", !0), $c5aa5a6035c47210$var$mt(n, r, i, e);
    }
}, $c5aa5a6035c47210$var$Mt = {};
$c5aa5a6035c47210$var$Mt[$c5aa5a6035c47210$var$Ce("toStringTag")] = "z";
var $c5aa5a6035c47210$var$Bt, $c5aa5a6035c47210$var$Qt = "[object z]" === String($c5aa5a6035c47210$var$Mt), $c5aa5a6035c47210$var$qt = $c5aa5a6035c47210$var$Ce("toStringTag"), $c5aa5a6035c47210$var$$t = Object, $c5aa5a6035c47210$var$en = "Arguments" == $c5aa5a6035c47210$var$Z(function() {
    return arguments;
}()), $c5aa5a6035c47210$var$tn = $c5aa5a6035c47210$var$Qt ? $c5aa5a6035c47210$var$Z : function(e) {
    var t, n, r;
    return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (n = function(e, t) {
        try {
            return e[t];
        } catch (e) {}
    }(t = $c5aa5a6035c47210$var$$t(e), $c5aa5a6035c47210$var$qt)) ? n : $c5aa5a6035c47210$var$en ? $c5aa5a6035c47210$var$Z(t) : "Object" == (r = $c5aa5a6035c47210$var$Z(t)) && $c5aa5a6035c47210$var$H(t.callee) ? "Arguments" : r;
}, $c5aa5a6035c47210$var$nn = String, $c5aa5a6035c47210$var$rn = function(e) {
    if ("Symbol" === $c5aa5a6035c47210$var$tn(e)) throw TypeError("Cannot convert a Symbol value to a string");
    return $c5aa5a6035c47210$var$nn(e);
}, $c5aa5a6035c47210$var$on = $c5aa5a6035c47210$var$Ce("match"), $c5aa5a6035c47210$var$cn = TypeError, $c5aa5a6035c47210$var$an = function(e) {
    if (function(e) {
        var t;
        return $c5aa5a6035c47210$var$J(e) && (void 0 !== (t = e[$c5aa5a6035c47210$var$on]) ? !!t : "RegExp" == $c5aa5a6035c47210$var$Z(e));
    }(e)) throw $c5aa5a6035c47210$var$cn("The method doesn't accept regular expressions");
    return e;
}, $c5aa5a6035c47210$var$sn = $c5aa5a6035c47210$var$Ce("match"), $c5aa5a6035c47210$var$un = function(e) {
    var t = /./;
    try {
        "/./"[e](t);
    } catch (n) {
        try {
            return t[$c5aa5a6035c47210$var$sn] = !1, "/./"[e](t);
        } catch (e) {}
    }
    return !1;
}, $c5aa5a6035c47210$var$ln = $c5aa5a6035c47210$var$Xe.f, $c5aa5a6035c47210$var$fn = $c5aa5a6035c47210$var$L("".startsWith), $c5aa5a6035c47210$var$dn = $c5aa5a6035c47210$var$L("".slice), $c5aa5a6035c47210$var$hn = Math.min, $c5aa5a6035c47210$var$pn = $c5aa5a6035c47210$var$un("startsWith"), $c5aa5a6035c47210$var$yn = !($c5aa5a6035c47210$var$pn || ($c5aa5a6035c47210$var$Bt = $c5aa5a6035c47210$var$ln(String.prototype, "startsWith"), !$c5aa5a6035c47210$var$Bt || $c5aa5a6035c47210$var$Bt.writable));
$c5aa5a6035c47210$var$zt({
    target: "String",
    proto: !0,
    forced: !$c5aa5a6035c47210$var$yn && !$c5aa5a6035c47210$var$pn
}, {
    startsWith: function(e) {
        var t = $c5aa5a6035c47210$var$rn($c5aa5a6035c47210$var$F(this));
        $c5aa5a6035c47210$var$an(e);
        var n = $c5aa5a6035c47210$var$xt($c5aa5a6035c47210$var$hn(arguments.length > 1 ? arguments[1] : void 0, t.length)), r = $c5aa5a6035c47210$var$rn(e);
        return $c5aa5a6035c47210$var$fn ? $c5aa5a6035c47210$var$fn(t, r, n) : $c5aa5a6035c47210$var$dn(t, n, n + r.length) === r;
    }
});
var $c5aa5a6035c47210$var$vn = function(e, t) {
    return $c5aa5a6035c47210$var$L($c5aa5a6035c47210$var$p[e].prototype[t]);
};
$c5aa5a6035c47210$var$vn("String", "startsWith");
var $c5aa5a6035c47210$var$mn = Array.isArray || function(e) {
    return "Array" == $c5aa5a6035c47210$var$Z(e);
}, $c5aa5a6035c47210$var$bn = TypeError, $c5aa5a6035c47210$var$gn = function(e) {
    if (e > 9007199254740991) throw $c5aa5a6035c47210$var$bn("Maximum allowed index exceeded");
    return e;
}, $c5aa5a6035c47210$var$wn = function(e, t, n) {
    var r = $c5aa5a6035c47210$var$We(t);
    r in e ? $c5aa5a6035c47210$var$Je.f(e, r, $c5aa5a6035c47210$var$I(0, n)) : e[r] = n;
}, $c5aa5a6035c47210$var$Sn = function() {}, $c5aa5a6035c47210$var$kn = [], $c5aa5a6035c47210$var$_n = $c5aa5a6035c47210$var$z("Reflect", "construct"), $c5aa5a6035c47210$var$In = /^\s*(?:class|function)\b/, $c5aa5a6035c47210$var$On = $c5aa5a6035c47210$var$L($c5aa5a6035c47210$var$In.exec), $c5aa5a6035c47210$var$xn = !$c5aa5a6035c47210$var$In.exec($c5aa5a6035c47210$var$Sn), $c5aa5a6035c47210$var$Tn = function(e) {
    if (!$c5aa5a6035c47210$var$H(e)) return !1;
    try {
        return $c5aa5a6035c47210$var$_n($c5aa5a6035c47210$var$Sn, $c5aa5a6035c47210$var$kn, e), !0;
    } catch (e) {
        return !1;
    }
}, $c5aa5a6035c47210$var$Cn = function(e) {
    if (!$c5aa5a6035c47210$var$H(e)) return !1;
    switch($c5aa5a6035c47210$var$tn(e)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return !1;
    }
    try {
        return $c5aa5a6035c47210$var$xn || !!$c5aa5a6035c47210$var$On($c5aa5a6035c47210$var$In, $c5aa5a6035c47210$var$nt(e));
    } catch (e) {
        return !0;
    }
};
$c5aa5a6035c47210$var$Cn.sham = !0;
var $c5aa5a6035c47210$var$jn, $c5aa5a6035c47210$var$Ln = !$c5aa5a6035c47210$var$_n || $c5aa5a6035c47210$var$y(function() {
    var e;
    return $c5aa5a6035c47210$var$Tn($c5aa5a6035c47210$var$Tn.call) || !$c5aa5a6035c47210$var$Tn(Object) || !$c5aa5a6035c47210$var$Tn(function() {
        e = !0;
    }) || e;
}) ? $c5aa5a6035c47210$var$Cn : $c5aa5a6035c47210$var$Tn, $c5aa5a6035c47210$var$Rn = $c5aa5a6035c47210$var$Ce("species"), $c5aa5a6035c47210$var$Wn = Array, $c5aa5a6035c47210$var$Zn = function(e, t) {
    return new (function(e) {
        var t;
        return $c5aa5a6035c47210$var$mn(e) && (t = e.constructor, ($c5aa5a6035c47210$var$Ln(t) && (t === $c5aa5a6035c47210$var$Wn || $c5aa5a6035c47210$var$mn(t.prototype)) || $c5aa5a6035c47210$var$J(t) && null === (t = t[$c5aa5a6035c47210$var$Rn])) && (t = void 0)), void 0 === t ? $c5aa5a6035c47210$var$Wn : t;
    }(e))(0 === t ? 0 : t);
}, $c5aa5a6035c47210$var$En = $c5aa5a6035c47210$var$Ce("species"), $c5aa5a6035c47210$var$Gn = $c5aa5a6035c47210$var$Ce("isConcatSpreadable"), $c5aa5a6035c47210$var$An = $c5aa5a6035c47210$var$te >= 51 || !$c5aa5a6035c47210$var$y(function() {
    var e = [];
    return e[$c5aa5a6035c47210$var$Gn] = !1, e.concat()[0] !== e;
}), $c5aa5a6035c47210$var$Pn = ($c5aa5a6035c47210$var$jn = "concat", $c5aa5a6035c47210$var$te >= 51 || !$c5aa5a6035c47210$var$y(function() {
    var e = [];
    return (e.constructor = {})[$c5aa5a6035c47210$var$En] = function() {
        return {
            foo: 1
        };
    }, 1 !== e[$c5aa5a6035c47210$var$jn](Boolean).foo;
})), $c5aa5a6035c47210$var$Xn = function(e) {
    if (!$c5aa5a6035c47210$var$J(e)) return !1;
    var t = e[$c5aa5a6035c47210$var$Gn];
    return void 0 !== t ? !!t : $c5aa5a6035c47210$var$mn(e);
};
$c5aa5a6035c47210$var$zt({
    target: "Array",
    proto: !0,
    arity: 1,
    forced: !$c5aa5a6035c47210$var$An || !$c5aa5a6035c47210$var$Pn
}, {
    concat: function(e) {
        var t, n, r, o, i, c = $c5aa5a6035c47210$var$me(this), a = $c5aa5a6035c47210$var$Zn(c, 0), s = 0;
        for(t = -1, r = arguments.length; t < r; t++)if ($c5aa5a6035c47210$var$Xn(i = -1 === t ? c : arguments[t])) for(o = $c5aa5a6035c47210$var$Tt(i), $c5aa5a6035c47210$var$gn(s + o), n = 0; n < o; n++, s++)n in i && $c5aa5a6035c47210$var$wn(a, s, i[n]);
        else $c5aa5a6035c47210$var$gn(s + 1), $c5aa5a6035c47210$var$wn(a, s++, i);
        return a.length = s, a;
    }
});
var $c5aa5a6035c47210$var$Fn = $c5aa5a6035c47210$var$Qt ? ({}).toString : function() {
    return "[object " + $c5aa5a6035c47210$var$tn(this) + "]";
};
$c5aa5a6035c47210$var$Qt || $c5aa5a6035c47210$var$mt(Object.prototype, "toString", $c5aa5a6035c47210$var$Fn, {
    unsafe: !0
});
var $c5aa5a6035c47210$var$Kn, $c5aa5a6035c47210$var$Nn = Object.keys || function(e) {
    return $c5aa5a6035c47210$var$Wt(e, $c5aa5a6035c47210$var$Zt);
}, $c5aa5a6035c47210$var$Un = $c5aa5a6035c47210$var$v && !$c5aa5a6035c47210$var$Fe ? Object.defineProperties : function(e, t) {
    $c5aa5a6035c47210$var$Ue(e);
    for(var n, r = $c5aa5a6035c47210$var$K(t), o = $c5aa5a6035c47210$var$Nn(t), i = o.length, c = 0; i > c;)$c5aa5a6035c47210$var$Je.f(e, n = o[c++], r[n]);
    return e;
}, $c5aa5a6035c47210$var$Dn = {
    f: $c5aa5a6035c47210$var$Un
}, $c5aa5a6035c47210$var$Hn = $c5aa5a6035c47210$var$z("document", "documentElement"), $c5aa5a6035c47210$var$Yn = $c5aa5a6035c47210$var$ct("IE_PROTO"), $c5aa5a6035c47210$var$Jn = function() {}, $c5aa5a6035c47210$var$Vn = function(e) {
    return "<script>" + e + "<\/script>";
}, $c5aa5a6035c47210$var$zn = function(e) {
    e.write($c5aa5a6035c47210$var$Vn("")), e.close();
    var t = e.parentWindow.Object;
    return e = null, t;
}, $c5aa5a6035c47210$var$Mn = function() {
    try {
        $c5aa5a6035c47210$var$Kn = new ActiveXObject("htmlfile");
    } catch (e) {}
    var e, t;
    $c5aa5a6035c47210$var$Mn = "undefined" != typeof document ? document.domain && $c5aa5a6035c47210$var$Kn ? $c5aa5a6035c47210$var$zn($c5aa5a6035c47210$var$Kn) : ((t = $c5aa5a6035c47210$var$Ge("iframe")).style.display = "none", $c5aa5a6035c47210$var$Hn.appendChild(t), t.src = String("javascript:"), (e = t.contentWindow.document).open(), e.write($c5aa5a6035c47210$var$Vn("document.F=Object")), e.close(), e.F) : $c5aa5a6035c47210$var$zn($c5aa5a6035c47210$var$Kn);
    for(var n = $c5aa5a6035c47210$var$Zt.length; n--;)delete $c5aa5a6035c47210$var$Mn.prototype[$c5aa5a6035c47210$var$Zt[n]];
    return $c5aa5a6035c47210$var$Mn();
};
$c5aa5a6035c47210$var$at[$c5aa5a6035c47210$var$Yn] = !0;
var $c5aa5a6035c47210$var$Bn = Object.create || function(e, t) {
    var n;
    return null !== e ? ($c5aa5a6035c47210$var$Jn.prototype = $c5aa5a6035c47210$var$Ue(e), n = new $c5aa5a6035c47210$var$Jn, $c5aa5a6035c47210$var$Jn.prototype = null, n[$c5aa5a6035c47210$var$Yn] = e) : n = $c5aa5a6035c47210$var$Mn(), void 0 === t ? n : $c5aa5a6035c47210$var$Dn.f(n, t);
}, $c5aa5a6035c47210$var$Qn = Array, $c5aa5a6035c47210$var$qn = Math.max, $c5aa5a6035c47210$var$$n = $c5aa5a6035c47210$var$Gt.f, $c5aa5a6035c47210$var$er = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], $c5aa5a6035c47210$var$tr = function(e) {
    try {
        return $c5aa5a6035c47210$var$$n(e);
    } catch (e) {
        return function(e, t, n) {
            for(var r = $c5aa5a6035c47210$var$Tt(e), o = $c5aa5a6035c47210$var$It(t, r), i = $c5aa5a6035c47210$var$It(void 0 === n ? r : n, r), c = $c5aa5a6035c47210$var$Qn($c5aa5a6035c47210$var$qn(i - o, 0)), a = 0; o < i; o++, a++)$c5aa5a6035c47210$var$wn(c, a, e[o]);
            return c.length = a, c;
        }($c5aa5a6035c47210$var$er);
    }
}, $c5aa5a6035c47210$var$nr = {
    f: function(e) {
        return $c5aa5a6035c47210$var$er && "Window" == $c5aa5a6035c47210$var$Z(e) ? $c5aa5a6035c47210$var$tr(e) : $c5aa5a6035c47210$var$$n($c5aa5a6035c47210$var$K(e));
    }
}, $c5aa5a6035c47210$var$rr = {
    f: $c5aa5a6035c47210$var$Ce
}, $c5aa5a6035c47210$var$or = $c5aa5a6035c47210$var$p, $c5aa5a6035c47210$var$ir = $c5aa5a6035c47210$var$Je.f, $c5aa5a6035c47210$var$cr = function(e) {
    var t = $c5aa5a6035c47210$var$or.Symbol || ($c5aa5a6035c47210$var$or.Symbol = {});
    $c5aa5a6035c47210$var$ge(t, e) || $c5aa5a6035c47210$var$ir(t, e, {
        value: $c5aa5a6035c47210$var$rr.f(e)
    });
}, $c5aa5a6035c47210$var$ar = function() {
    var e = $c5aa5a6035c47210$var$z("Symbol"), t = e && e.prototype, n = t && t.valueOf, r = $c5aa5a6035c47210$var$Ce("toPrimitive");
    t && !t[r] && $c5aa5a6035c47210$var$mt(t, r, function(e) {
        return $c5aa5a6035c47210$var$g(n, this);
    }, {
        arity: 1
    });
}, $c5aa5a6035c47210$var$sr = $c5aa5a6035c47210$var$Je.f, $c5aa5a6035c47210$var$ur = $c5aa5a6035c47210$var$Ce("toStringTag"), $c5aa5a6035c47210$var$lr = function(e, t, n) {
    e && !n && (e = e.prototype), e && !$c5aa5a6035c47210$var$ge(e, $c5aa5a6035c47210$var$ur) && $c5aa5a6035c47210$var$sr(e, $c5aa5a6035c47210$var$ur, {
        configurable: !0,
        value: t
    });
}, $c5aa5a6035c47210$var$fr = $c5aa5a6035c47210$var$L($c5aa5a6035c47210$var$L.bind), $c5aa5a6035c47210$var$dr = function(e, t) {
    return $c5aa5a6035c47210$var$ue(e), void 0 === t ? e : $c5aa5a6035c47210$var$m ? $c5aa5a6035c47210$var$fr(e, t) : function() {
        return e.apply(t, arguments);
    };
}, $c5aa5a6035c47210$var$hr = $c5aa5a6035c47210$var$L([].push), $c5aa5a6035c47210$var$pr = function(e) {
    var t = 1 == e, n = 2 == e, r = 3 == e, o = 4 == e, i = 6 == e, c = 7 == e, a = 5 == e || i;
    return function(s, u, l, f) {
        for(var d, h, p = $c5aa5a6035c47210$var$me(s), y = $c5aa5a6035c47210$var$A(p), v = $c5aa5a6035c47210$var$dr(u, l), m = $c5aa5a6035c47210$var$Tt(y), b = 0, g = f || $c5aa5a6035c47210$var$Zn, w = t ? g(s, m) : n || c ? g(s, 0) : void 0; m > b; b++)if ((a || b in y) && (h = v(d = y[b], b, p), e)) {
            if (t) w[b] = h;
            else if (h) switch(e){
                case 3:
                    return !0;
                case 5:
                    return d;
                case 6:
                    return b;
                case 2:
                    $c5aa5a6035c47210$var$hr(w, d);
            }
            else switch(e){
                case 4:
                    return !1;
                case 7:
                    $c5aa5a6035c47210$var$hr(w, d);
            }
        }
        return i ? -1 : r || o ? o : w;
    };
}, $c5aa5a6035c47210$var$yr = {
    forEach: $c5aa5a6035c47210$var$pr(0),
    map: $c5aa5a6035c47210$var$pr(1),
    filter: $c5aa5a6035c47210$var$pr(2),
    some: $c5aa5a6035c47210$var$pr(3),
    every: $c5aa5a6035c47210$var$pr(4),
    find: $c5aa5a6035c47210$var$pr(5),
    findIndex: $c5aa5a6035c47210$var$pr(6),
    filterReject: $c5aa5a6035c47210$var$pr(7)
}.forEach, $c5aa5a6035c47210$var$vr = $c5aa5a6035c47210$var$ct("hidden"), $c5aa5a6035c47210$var$mr = $c5aa5a6035c47210$var$yt.set, $c5aa5a6035c47210$var$br = $c5aa5a6035c47210$var$yt.getterFor("Symbol"), $c5aa5a6035c47210$var$gr = Object.prototype, $c5aa5a6035c47210$var$wr = $c5aa5a6035c47210$var$p.Symbol, $c5aa5a6035c47210$var$Sr = $c5aa5a6035c47210$var$wr && $c5aa5a6035c47210$var$wr.prototype, $c5aa5a6035c47210$var$kr = $c5aa5a6035c47210$var$p.TypeError, $c5aa5a6035c47210$var$_r = $c5aa5a6035c47210$var$p.QObject, $c5aa5a6035c47210$var$Ir = $c5aa5a6035c47210$var$Xe.f, $c5aa5a6035c47210$var$Or = $c5aa5a6035c47210$var$Je.f, $c5aa5a6035c47210$var$xr = $c5aa5a6035c47210$var$nr.f, $c5aa5a6035c47210$var$Tr = $c5aa5a6035c47210$var$_.f, $c5aa5a6035c47210$var$Cr = $c5aa5a6035c47210$var$L([].push), $c5aa5a6035c47210$var$jr = $c5aa5a6035c47210$var$ye("symbols"), $c5aa5a6035c47210$var$Lr = $c5aa5a6035c47210$var$ye("op-symbols"), $c5aa5a6035c47210$var$Rr = $c5aa5a6035c47210$var$ye("wks"), $c5aa5a6035c47210$var$Wr = !$c5aa5a6035c47210$var$_r || !$c5aa5a6035c47210$var$_r.prototype || !$c5aa5a6035c47210$var$_r.prototype.findChild, $c5aa5a6035c47210$var$Zr = $c5aa5a6035c47210$var$v && $c5aa5a6035c47210$var$y(function() {
    return 7 != $c5aa5a6035c47210$var$Bn($c5aa5a6035c47210$var$Or({}, "a", {
        get: function() {
            return $c5aa5a6035c47210$var$Or(this, "a", {
                value: 7
            }).a;
        }
    })).a;
}) ? function(e, t, n) {
    var r = $c5aa5a6035c47210$var$Ir($c5aa5a6035c47210$var$gr, t);
    r && delete $c5aa5a6035c47210$var$gr[t], $c5aa5a6035c47210$var$Or(e, t, n), r && e !== $c5aa5a6035c47210$var$gr && $c5aa5a6035c47210$var$Or($c5aa5a6035c47210$var$gr, t, r);
} : $c5aa5a6035c47210$var$Or, $c5aa5a6035c47210$var$Er = function(e, t) {
    var n = $c5aa5a6035c47210$var$jr[e] = $c5aa5a6035c47210$var$Bn($c5aa5a6035c47210$var$Sr);
    return $c5aa5a6035c47210$var$mr(n, {
        type: "Symbol",
        tag: e,
        description: t
    }), $c5aa5a6035c47210$var$v || (n.description = t), n;
}, $c5aa5a6035c47210$var$Gr = function(e, t, n) {
    e === $c5aa5a6035c47210$var$gr && $c5aa5a6035c47210$var$Gr($c5aa5a6035c47210$var$Lr, t, n), $c5aa5a6035c47210$var$Ue(e);
    var r = $c5aa5a6035c47210$var$We(t);
    return $c5aa5a6035c47210$var$Ue(n), $c5aa5a6035c47210$var$ge($c5aa5a6035c47210$var$jr, r) ? (n.enumerable ? ($c5aa5a6035c47210$var$ge(e, $c5aa5a6035c47210$var$vr) && e[$c5aa5a6035c47210$var$vr][r] && (e[$c5aa5a6035c47210$var$vr][r] = !1), n = $c5aa5a6035c47210$var$Bn(n, {
        enumerable: $c5aa5a6035c47210$var$I(0, !1)
    })) : ($c5aa5a6035c47210$var$ge(e, $c5aa5a6035c47210$var$vr) || $c5aa5a6035c47210$var$Or(e, $c5aa5a6035c47210$var$vr, $c5aa5a6035c47210$var$I(1, {})), e[$c5aa5a6035c47210$var$vr][r] = !0), $c5aa5a6035c47210$var$Zr(e, r, n)) : $c5aa5a6035c47210$var$Or(e, r, n);
}, $c5aa5a6035c47210$var$Ar = function(e, t) {
    $c5aa5a6035c47210$var$Ue(e);
    var n = $c5aa5a6035c47210$var$K(t), r = $c5aa5a6035c47210$var$Nn(n).concat($c5aa5a6035c47210$var$Kr(n));
    return $c5aa5a6035c47210$var$yr(r, function(t) {
        $c5aa5a6035c47210$var$v && !$c5aa5a6035c47210$var$g($c5aa5a6035c47210$var$Pr, n, t) || $c5aa5a6035c47210$var$Gr(e, t, n[t]);
    }), e;
}, $c5aa5a6035c47210$var$Pr = function(e) {
    var t = $c5aa5a6035c47210$var$We(e), n = $c5aa5a6035c47210$var$g($c5aa5a6035c47210$var$Tr, this, t);
    return !(this === $c5aa5a6035c47210$var$gr && $c5aa5a6035c47210$var$ge($c5aa5a6035c47210$var$jr, t) && !$c5aa5a6035c47210$var$ge($c5aa5a6035c47210$var$Lr, t)) && (!(n || !$c5aa5a6035c47210$var$ge(this, t) || !$c5aa5a6035c47210$var$ge($c5aa5a6035c47210$var$jr, t) || $c5aa5a6035c47210$var$ge(this, $c5aa5a6035c47210$var$vr) && this[$c5aa5a6035c47210$var$vr][t]) || n);
}, $c5aa5a6035c47210$var$Xr = function(e, t) {
    var n = $c5aa5a6035c47210$var$K(e), r = $c5aa5a6035c47210$var$We(t);
    if (n !== $c5aa5a6035c47210$var$gr || !$c5aa5a6035c47210$var$ge($c5aa5a6035c47210$var$jr, r) || $c5aa5a6035c47210$var$ge($c5aa5a6035c47210$var$Lr, r)) {
        var o = $c5aa5a6035c47210$var$Ir(n, r);
        return !o || !$c5aa5a6035c47210$var$ge($c5aa5a6035c47210$var$jr, r) || $c5aa5a6035c47210$var$ge(n, $c5aa5a6035c47210$var$vr) && n[$c5aa5a6035c47210$var$vr][r] || (o.enumerable = !0), o;
    }
}, $c5aa5a6035c47210$var$Fr = function(e) {
    var t = $c5aa5a6035c47210$var$xr($c5aa5a6035c47210$var$K(e)), n = [];
    return $c5aa5a6035c47210$var$yr(t, function(e) {
        $c5aa5a6035c47210$var$ge($c5aa5a6035c47210$var$jr, e) || $c5aa5a6035c47210$var$ge($c5aa5a6035c47210$var$at, e) || $c5aa5a6035c47210$var$Cr(n, e);
    }), n;
}, $c5aa5a6035c47210$var$Kr = function(e) {
    var t = e === $c5aa5a6035c47210$var$gr, n = $c5aa5a6035c47210$var$xr(t ? $c5aa5a6035c47210$var$Lr : $c5aa5a6035c47210$var$K(e)), r = [];
    return $c5aa5a6035c47210$var$yr(n, function(e) {
        !$c5aa5a6035c47210$var$ge($c5aa5a6035c47210$var$jr, e) || t && !$c5aa5a6035c47210$var$ge($c5aa5a6035c47210$var$gr, e) || $c5aa5a6035c47210$var$Cr(r, $c5aa5a6035c47210$var$jr[e]);
    }), r;
};
$c5aa5a6035c47210$var$ne || ($c5aa5a6035c47210$var$Sr = ($c5aa5a6035c47210$var$wr = function() {
    if ($c5aa5a6035c47210$var$M($c5aa5a6035c47210$var$Sr, this)) throw $c5aa5a6035c47210$var$kr("Symbol is not a constructor");
    var e = arguments.length && void 0 !== arguments[0] ? $c5aa5a6035c47210$var$rn(arguments[0]) : void 0, t = $c5aa5a6035c47210$var$_e(e), n = function(e) {
        this === $c5aa5a6035c47210$var$gr && $c5aa5a6035c47210$var$g(n, $c5aa5a6035c47210$var$Lr, e), $c5aa5a6035c47210$var$ge(this, $c5aa5a6035c47210$var$vr) && $c5aa5a6035c47210$var$ge(this[$c5aa5a6035c47210$var$vr], t) && (this[$c5aa5a6035c47210$var$vr][t] = !1), $c5aa5a6035c47210$var$Zr(this, t, $c5aa5a6035c47210$var$I(1, e));
    };
    return $c5aa5a6035c47210$var$v && $c5aa5a6035c47210$var$Wr && $c5aa5a6035c47210$var$Zr($c5aa5a6035c47210$var$gr, t, {
        configurable: !0,
        set: n
    }), $c5aa5a6035c47210$var$Er(t, e);
}).prototype, $c5aa5a6035c47210$var$mt($c5aa5a6035c47210$var$Sr, "toString", function() {
    return $c5aa5a6035c47210$var$br(this).tag;
}), $c5aa5a6035c47210$var$mt($c5aa5a6035c47210$var$wr, "withoutSetter", function(e) {
    return $c5aa5a6035c47210$var$Er($c5aa5a6035c47210$var$_e(e), e);
}), $c5aa5a6035c47210$var$_.f = $c5aa5a6035c47210$var$Pr, $c5aa5a6035c47210$var$Je.f = $c5aa5a6035c47210$var$Gr, $c5aa5a6035c47210$var$Dn.f = $c5aa5a6035c47210$var$Ar, $c5aa5a6035c47210$var$Xe.f = $c5aa5a6035c47210$var$Xr, $c5aa5a6035c47210$var$Gt.f = $c5aa5a6035c47210$var$nr.f = $c5aa5a6035c47210$var$Fr, $c5aa5a6035c47210$var$At.f = $c5aa5a6035c47210$var$Kr, $c5aa5a6035c47210$var$rr.f = function(e) {
    return $c5aa5a6035c47210$var$Er($c5aa5a6035c47210$var$Ce(e), e);
}, $c5aa5a6035c47210$var$v && ($c5aa5a6035c47210$var$Or($c5aa5a6035c47210$var$Sr, "description", {
    configurable: !0,
    get: function() {
        return $c5aa5a6035c47210$var$br(this).description;
    }
}), $c5aa5a6035c47210$var$mt($c5aa5a6035c47210$var$gr, "propertyIsEnumerable", $c5aa5a6035c47210$var$Pr, {
    unsafe: !0
}))), $c5aa5a6035c47210$var$zt({
    global: !0,
    constructor: !0,
    wrap: !0,
    forced: !$c5aa5a6035c47210$var$ne,
    sham: !$c5aa5a6035c47210$var$ne
}, {
    Symbol: $c5aa5a6035c47210$var$wr
}), $c5aa5a6035c47210$var$yr($c5aa5a6035c47210$var$Nn($c5aa5a6035c47210$var$Rr), function(e) {
    $c5aa5a6035c47210$var$cr(e);
}), $c5aa5a6035c47210$var$zt({
    target: "Symbol",
    stat: !0,
    forced: !$c5aa5a6035c47210$var$ne
}, {
    useSetter: function() {
        $c5aa5a6035c47210$var$Wr = !0;
    },
    useSimple: function() {
        $c5aa5a6035c47210$var$Wr = !1;
    }
}), $c5aa5a6035c47210$var$zt({
    target: "Object",
    stat: !0,
    forced: !$c5aa5a6035c47210$var$ne,
    sham: !$c5aa5a6035c47210$var$v
}, {
    create: function(e, t) {
        return void 0 === t ? $c5aa5a6035c47210$var$Bn(e) : $c5aa5a6035c47210$var$Ar($c5aa5a6035c47210$var$Bn(e), t);
    },
    defineProperty: $c5aa5a6035c47210$var$Gr,
    defineProperties: $c5aa5a6035c47210$var$Ar,
    getOwnPropertyDescriptor: $c5aa5a6035c47210$var$Xr
}), $c5aa5a6035c47210$var$zt({
    target: "Object",
    stat: !0,
    forced: !$c5aa5a6035c47210$var$ne
}, {
    getOwnPropertyNames: $c5aa5a6035c47210$var$Fr
}), $c5aa5a6035c47210$var$ar(), $c5aa5a6035c47210$var$lr($c5aa5a6035c47210$var$wr, "Symbol"), $c5aa5a6035c47210$var$at[$c5aa5a6035c47210$var$vr] = !0;
var $c5aa5a6035c47210$var$Nr = $c5aa5a6035c47210$var$ne && !!Symbol.for && !!Symbol.keyFor, $c5aa5a6035c47210$var$Ur = $c5aa5a6035c47210$var$ye("string-to-symbol-registry"), $c5aa5a6035c47210$var$Dr = $c5aa5a6035c47210$var$ye("symbol-to-string-registry");
$c5aa5a6035c47210$var$zt({
    target: "Symbol",
    stat: !0,
    forced: !$c5aa5a6035c47210$var$Nr
}, {
    for: function(e) {
        var t = $c5aa5a6035c47210$var$rn(e);
        if ($c5aa5a6035c47210$var$ge($c5aa5a6035c47210$var$Ur, t)) return $c5aa5a6035c47210$var$Ur[t];
        var n = $c5aa5a6035c47210$var$z("Symbol")(t);
        return $c5aa5a6035c47210$var$Ur[t] = n, $c5aa5a6035c47210$var$Dr[n] = t, n;
    }
});
var $c5aa5a6035c47210$var$Hr = $c5aa5a6035c47210$var$ye("symbol-to-string-registry");
$c5aa5a6035c47210$var$zt({
    target: "Symbol",
    stat: !0,
    forced: !$c5aa5a6035c47210$var$Nr
}, {
    keyFor: function(e) {
        if (!$c5aa5a6035c47210$var$ie(e)) throw TypeError($c5aa5a6035c47210$var$ae(e) + " is not a symbol");
        if ($c5aa5a6035c47210$var$ge($c5aa5a6035c47210$var$Hr, e)) return $c5aa5a6035c47210$var$Hr[e];
    }
});
var $c5aa5a6035c47210$var$Yr = Function.prototype, $c5aa5a6035c47210$var$Jr = $c5aa5a6035c47210$var$Yr.apply, $c5aa5a6035c47210$var$Vr = $c5aa5a6035c47210$var$Yr.call, $c5aa5a6035c47210$var$zr = "object" == typeof Reflect && Reflect.apply || ($c5aa5a6035c47210$var$m ? $c5aa5a6035c47210$var$Vr.bind($c5aa5a6035c47210$var$Jr) : function() {
    return $c5aa5a6035c47210$var$Vr.apply($c5aa5a6035c47210$var$Jr, arguments);
}), $c5aa5a6035c47210$var$Mr = $c5aa5a6035c47210$var$L([].slice), $c5aa5a6035c47210$var$Br = $c5aa5a6035c47210$var$z("JSON", "stringify"), $c5aa5a6035c47210$var$Qr = $c5aa5a6035c47210$var$L(/./.exec), $c5aa5a6035c47210$var$qr = $c5aa5a6035c47210$var$L("".charAt), $c5aa5a6035c47210$var$$r = $c5aa5a6035c47210$var$L("".charCodeAt), $c5aa5a6035c47210$var$eo = $c5aa5a6035c47210$var$L("".replace), $c5aa5a6035c47210$var$to = $c5aa5a6035c47210$var$L(1..toString), $c5aa5a6035c47210$var$no = /[\uD800-\uDFFF]/g, $c5aa5a6035c47210$var$ro = /^[\uD800-\uDBFF]$/, $c5aa5a6035c47210$var$oo = /^[\uDC00-\uDFFF]$/, $c5aa5a6035c47210$var$io = !$c5aa5a6035c47210$var$ne || $c5aa5a6035c47210$var$y(function() {
    var e = $c5aa5a6035c47210$var$z("Symbol")();
    return "[null]" != $c5aa5a6035c47210$var$Br([
        e
    ]) || "{}" != $c5aa5a6035c47210$var$Br({
        a: e
    }) || "{}" != $c5aa5a6035c47210$var$Br(Object(e));
}), $c5aa5a6035c47210$var$co = $c5aa5a6035c47210$var$y(function() {
    return '"\\udf06\\ud834"' !== $c5aa5a6035c47210$var$Br("\udf06\ud834") || '"\\udead"' !== $c5aa5a6035c47210$var$Br("\udead");
}), $c5aa5a6035c47210$var$ao = function(e, t) {
    var n = $c5aa5a6035c47210$var$Mr(arguments), r = t;
    if (($c5aa5a6035c47210$var$J(t) || void 0 !== e) && !$c5aa5a6035c47210$var$ie(e)) return $c5aa5a6035c47210$var$mn(t) || (t = function(e, t) {
        if ($c5aa5a6035c47210$var$H(r) && (t = $c5aa5a6035c47210$var$g(r, this, e, t)), !$c5aa5a6035c47210$var$ie(t)) return t;
    }), n[1] = t, $c5aa5a6035c47210$var$zr($c5aa5a6035c47210$var$Br, null, n);
}, $c5aa5a6035c47210$var$so = function(e, t, n) {
    var r = $c5aa5a6035c47210$var$qr(n, t - 1), o = $c5aa5a6035c47210$var$qr(n, t + 1);
    return $c5aa5a6035c47210$var$Qr($c5aa5a6035c47210$var$ro, e) && !$c5aa5a6035c47210$var$Qr($c5aa5a6035c47210$var$oo, o) || $c5aa5a6035c47210$var$Qr($c5aa5a6035c47210$var$oo, e) && !$c5aa5a6035c47210$var$Qr($c5aa5a6035c47210$var$ro, r) ? "\\u" + $c5aa5a6035c47210$var$to($c5aa5a6035c47210$var$$r(e, 0), 16) : e;
};
$c5aa5a6035c47210$var$Br && $c5aa5a6035c47210$var$zt({
    target: "JSON",
    stat: !0,
    arity: 3,
    forced: $c5aa5a6035c47210$var$io || $c5aa5a6035c47210$var$co
}, {
    stringify: function(e, t, n) {
        var r = $c5aa5a6035c47210$var$Mr(arguments), o = $c5aa5a6035c47210$var$zr($c5aa5a6035c47210$var$io ? $c5aa5a6035c47210$var$ao : $c5aa5a6035c47210$var$Br, null, r);
        return $c5aa5a6035c47210$var$co && "string" == typeof o ? $c5aa5a6035c47210$var$eo(o, $c5aa5a6035c47210$var$no, $c5aa5a6035c47210$var$so) : o;
    }
});
var $c5aa5a6035c47210$var$uo = !$c5aa5a6035c47210$var$ne || $c5aa5a6035c47210$var$y(function() {
    $c5aa5a6035c47210$var$At.f(1);
});
$c5aa5a6035c47210$var$zt({
    target: "Object",
    stat: !0,
    forced: $c5aa5a6035c47210$var$uo
}, {
    getOwnPropertySymbols: function(e) {
        var t = $c5aa5a6035c47210$var$At.f;
        return t ? t($c5aa5a6035c47210$var$me(e)) : [];
    }
}), $c5aa5a6035c47210$var$cr("asyncIterator");
var $c5aa5a6035c47210$var$lo = $c5aa5a6035c47210$var$Je.f, $c5aa5a6035c47210$var$fo = $c5aa5a6035c47210$var$p.Symbol, $c5aa5a6035c47210$var$ho = $c5aa5a6035c47210$var$fo && $c5aa5a6035c47210$var$fo.prototype;
if ($c5aa5a6035c47210$var$v && $c5aa5a6035c47210$var$H($c5aa5a6035c47210$var$fo) && (!("description" in $c5aa5a6035c47210$var$ho) || void 0 !== $c5aa5a6035c47210$var$fo().description)) {
    var $c5aa5a6035c47210$var$po = {}, $c5aa5a6035c47210$var$yo = function() {
        var e = arguments.length < 1 || void 0 === arguments[0] ? void 0 : $c5aa5a6035c47210$var$rn(arguments[0]), t = $c5aa5a6035c47210$var$M($c5aa5a6035c47210$var$ho, this) ? new $c5aa5a6035c47210$var$fo(e) : void 0 === e ? $c5aa5a6035c47210$var$fo() : $c5aa5a6035c47210$var$fo(e);
        return "" === e && ($c5aa5a6035c47210$var$po[t] = !0), t;
    };
    $c5aa5a6035c47210$var$Ft($c5aa5a6035c47210$var$yo, $c5aa5a6035c47210$var$fo), $c5aa5a6035c47210$var$yo.prototype = $c5aa5a6035c47210$var$ho, $c5aa5a6035c47210$var$ho.constructor = $c5aa5a6035c47210$var$yo;
    var $c5aa5a6035c47210$var$vo = "Symbol(test)" == String($c5aa5a6035c47210$var$fo("test")), $c5aa5a6035c47210$var$mo = $c5aa5a6035c47210$var$L($c5aa5a6035c47210$var$ho.valueOf), $c5aa5a6035c47210$var$bo = $c5aa5a6035c47210$var$L($c5aa5a6035c47210$var$ho.toString), $c5aa5a6035c47210$var$go = /^Symbol\((.*)\)[^)]+$/, $c5aa5a6035c47210$var$wo = $c5aa5a6035c47210$var$L("".replace), $c5aa5a6035c47210$var$So = $c5aa5a6035c47210$var$L("".slice);
    $c5aa5a6035c47210$var$lo($c5aa5a6035c47210$var$ho, "description", {
        configurable: !0,
        get: function() {
            var e = $c5aa5a6035c47210$var$mo(this);
            if ($c5aa5a6035c47210$var$ge($c5aa5a6035c47210$var$po, e)) return "";
            var t = $c5aa5a6035c47210$var$bo(e), n = $c5aa5a6035c47210$var$vo ? $c5aa5a6035c47210$var$So(t, 7, -1) : $c5aa5a6035c47210$var$wo(t, $c5aa5a6035c47210$var$go, "$1");
            return "" === n ? void 0 : n;
        }
    }), $c5aa5a6035c47210$var$zt({
        global: !0,
        constructor: !0,
        forced: !0
    }, {
        Symbol: $c5aa5a6035c47210$var$yo
    });
}
$c5aa5a6035c47210$var$cr("hasInstance"), $c5aa5a6035c47210$var$cr("isConcatSpreadable"), $c5aa5a6035c47210$var$cr("iterator"), $c5aa5a6035c47210$var$cr("match"), $c5aa5a6035c47210$var$cr("matchAll"), $c5aa5a6035c47210$var$cr("replace"), $c5aa5a6035c47210$var$cr("search"), $c5aa5a6035c47210$var$cr("species"), $c5aa5a6035c47210$var$cr("split"), $c5aa5a6035c47210$var$cr("toPrimitive"), $c5aa5a6035c47210$var$ar(), $c5aa5a6035c47210$var$cr("toStringTag"), $c5aa5a6035c47210$var$lr($c5aa5a6035c47210$var$z("Symbol"), "Symbol"), $c5aa5a6035c47210$var$cr("unscopables"), $c5aa5a6035c47210$var$lr($c5aa5a6035c47210$var$p.JSON, "JSON", !0), $c5aa5a6035c47210$var$lr(Math, "Math", !0), $c5aa5a6035c47210$var$zt({
    global: !0
}, {
    Reflect: {}
}), $c5aa5a6035c47210$var$lr($c5aa5a6035c47210$var$p.Reflect, "Reflect", !0), $c5aa5a6035c47210$var$or.Symbol;
var $c5aa5a6035c47210$var$ko, $c5aa5a6035c47210$var$_o, $c5aa5a6035c47210$var$Io, $c5aa5a6035c47210$var$Oo = $c5aa5a6035c47210$var$L("".charAt), $c5aa5a6035c47210$var$xo = $c5aa5a6035c47210$var$L("".charCodeAt), $c5aa5a6035c47210$var$To = $c5aa5a6035c47210$var$L("".slice), $c5aa5a6035c47210$var$Co = function(e) {
    return function(t, n) {
        var r, o, i = $c5aa5a6035c47210$var$rn($c5aa5a6035c47210$var$F(t)), c = $c5aa5a6035c47210$var$St(n), a = i.length;
        return c < 0 || c >= a ? e ? "" : void 0 : (r = $c5aa5a6035c47210$var$xo(i, c)) < 55296 || r > 56319 || c + 1 === a || (o = $c5aa5a6035c47210$var$xo(i, c + 1)) < 56320 || o > 57343 ? e ? $c5aa5a6035c47210$var$Oo(i, c) : r : e ? $c5aa5a6035c47210$var$To(i, c, c + 2) : o - 56320 + (r - 55296 << 10) + 65536;
    };
}, $c5aa5a6035c47210$var$jo = {
    codeAt: $c5aa5a6035c47210$var$Co(!1),
    charAt: $c5aa5a6035c47210$var$Co(!0)
}, $c5aa5a6035c47210$var$Lo = !$c5aa5a6035c47210$var$y(function() {
    function e() {}
    return e.prototype.constructor = null, Object.getPrototypeOf(new e) !== e.prototype;
}), $c5aa5a6035c47210$var$Ro = $c5aa5a6035c47210$var$ct("IE_PROTO"), $c5aa5a6035c47210$var$Wo = Object, $c5aa5a6035c47210$var$Zo = $c5aa5a6035c47210$var$Wo.prototype, $c5aa5a6035c47210$var$Eo = $c5aa5a6035c47210$var$Lo ? $c5aa5a6035c47210$var$Wo.getPrototypeOf : function(e) {
    var t = $c5aa5a6035c47210$var$me(e);
    if ($c5aa5a6035c47210$var$ge(t, $c5aa5a6035c47210$var$Ro)) return t[$c5aa5a6035c47210$var$Ro];
    var n = t.constructor;
    return $c5aa5a6035c47210$var$H(n) && t instanceof n ? n.prototype : t instanceof $c5aa5a6035c47210$var$Wo ? $c5aa5a6035c47210$var$Zo : null;
}, $c5aa5a6035c47210$var$Go = $c5aa5a6035c47210$var$Ce("iterator"), $c5aa5a6035c47210$var$Ao = !1;
[].keys && ("next" in ($c5aa5a6035c47210$var$Io = [].keys()) ? ($c5aa5a6035c47210$var$_o = $c5aa5a6035c47210$var$Eo($c5aa5a6035c47210$var$Eo($c5aa5a6035c47210$var$Io))) !== Object.prototype && ($c5aa5a6035c47210$var$ko = $c5aa5a6035c47210$var$_o) : $c5aa5a6035c47210$var$Ao = !0);
var $c5aa5a6035c47210$var$Po = !$c5aa5a6035c47210$var$J($c5aa5a6035c47210$var$ko) || $c5aa5a6035c47210$var$y(function() {
    var e = {};
    return $c5aa5a6035c47210$var$ko[$c5aa5a6035c47210$var$Go].call(e) !== e;
});
$c5aa5a6035c47210$var$Po && ($c5aa5a6035c47210$var$ko = {}), $c5aa5a6035c47210$var$H($c5aa5a6035c47210$var$ko[$c5aa5a6035c47210$var$Go]) || $c5aa5a6035c47210$var$mt($c5aa5a6035c47210$var$ko, $c5aa5a6035c47210$var$Go, function() {
    return this;
});
var $c5aa5a6035c47210$var$Xo = {
    IteratorPrototype: $c5aa5a6035c47210$var$ko,
    BUGGY_SAFARI_ITERATORS: $c5aa5a6035c47210$var$Ao
}, $c5aa5a6035c47210$var$Fo = {}, $c5aa5a6035c47210$var$Ko = $c5aa5a6035c47210$var$Xo.IteratorPrototype, $c5aa5a6035c47210$var$No = function() {
    return this;
}, $c5aa5a6035c47210$var$Uo = String, $c5aa5a6035c47210$var$Do = TypeError, $c5aa5a6035c47210$var$Ho = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var e, t = !1, n = {};
    try {
        (e = $c5aa5a6035c47210$var$L(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set))(n, []), t = n instanceof Array;
    } catch (e) {}
    return function(n, r) {
        return $c5aa5a6035c47210$var$Ue(n), function(e) {
            if ("object" == typeof e || $c5aa5a6035c47210$var$H(e)) return e;
            throw $c5aa5a6035c47210$var$Do("Can't set " + $c5aa5a6035c47210$var$Uo(e) + " as a prototype");
        }(r), t ? e(n, r) : n.__proto__ = r, n;
    };
}() : void 0), $c5aa5a6035c47210$var$Yo = $c5aa5a6035c47210$var$Qe.PROPER, $c5aa5a6035c47210$var$Jo = $c5aa5a6035c47210$var$Qe.CONFIGURABLE, $c5aa5a6035c47210$var$Vo = $c5aa5a6035c47210$var$Xo.IteratorPrototype, $c5aa5a6035c47210$var$zo = $c5aa5a6035c47210$var$Xo.BUGGY_SAFARI_ITERATORS, $c5aa5a6035c47210$var$Mo = $c5aa5a6035c47210$var$Ce("iterator"), $c5aa5a6035c47210$var$Bo = function() {
    return this;
}, $c5aa5a6035c47210$var$Qo = function(e, t, n, r, o, i, c) {
    !function(e, t, n, r) {
        var o = t + " Iterator";
        e.prototype = $c5aa5a6035c47210$var$Bn($c5aa5a6035c47210$var$Ko, {
            next: $c5aa5a6035c47210$var$I(+!r, n)
        }), $c5aa5a6035c47210$var$lr(e, o, !1), $c5aa5a6035c47210$var$Fo[o] = $c5aa5a6035c47210$var$No;
    }(n, t, r);
    var a, s, u, l = function(e) {
        if (e === o && y) return y;
        if (!$c5aa5a6035c47210$var$zo && e in h) return h[e];
        switch(e){
            case "keys":
            case "values":
            case "entries":
                return function() {
                    return new n(this, e);
                };
        }
        return function() {
            return new n(this);
        };
    }, f = t + " Iterator", d = !1, h = e.prototype, p = h[$c5aa5a6035c47210$var$Mo] || h["@@iterator"] || o && h[o], y = !$c5aa5a6035c47210$var$zo && p || l(o), v = "Array" == t && h.entries || p;
    if (v && (a = $c5aa5a6035c47210$var$Eo(v.call(new e))) !== Object.prototype && a.next && ($c5aa5a6035c47210$var$Eo(a) !== $c5aa5a6035c47210$var$Vo && ($c5aa5a6035c47210$var$Ho ? $c5aa5a6035c47210$var$Ho(a, $c5aa5a6035c47210$var$Vo) : $c5aa5a6035c47210$var$H(a[$c5aa5a6035c47210$var$Mo]) || $c5aa5a6035c47210$var$mt(a, $c5aa5a6035c47210$var$Mo, $c5aa5a6035c47210$var$Bo)), $c5aa5a6035c47210$var$lr(a, f, !0)), $c5aa5a6035c47210$var$Yo && "values" == o && p && "values" !== p.name && ($c5aa5a6035c47210$var$Jo ? $c5aa5a6035c47210$var$Ve(h, "name", "values") : (d = !0, y = function() {
        return $c5aa5a6035c47210$var$g(p, this);
    })), o) {
        if (s = {
            values: l("values"),
            keys: i ? y : l("keys"),
            entries: l("entries")
        }, c) for(u in s)($c5aa5a6035c47210$var$zo || d || !(u in h)) && $c5aa5a6035c47210$var$mt(h, u, s[u]);
        else $c5aa5a6035c47210$var$zt({
            target: t,
            proto: !0,
            forced: $c5aa5a6035c47210$var$zo || d
        }, s);
    }
    return h[$c5aa5a6035c47210$var$Mo] !== y && $c5aa5a6035c47210$var$mt(h, $c5aa5a6035c47210$var$Mo, y, {
        name: o
    }), $c5aa5a6035c47210$var$Fo[t] = y, s;
}, $c5aa5a6035c47210$var$qo = function(e, t) {
    return {
        value: e,
        done: t
    };
}, $c5aa5a6035c47210$var$$o = $c5aa5a6035c47210$var$jo.charAt, $c5aa5a6035c47210$var$ei = $c5aa5a6035c47210$var$yt.set, $c5aa5a6035c47210$var$ti = $c5aa5a6035c47210$var$yt.getterFor("String Iterator");
$c5aa5a6035c47210$var$Qo(String, "String", function(e) {
    $c5aa5a6035c47210$var$ei(this, {
        type: "String Iterator",
        string: $c5aa5a6035c47210$var$rn(e),
        index: 0
    });
}, function() {
    var e, t = $c5aa5a6035c47210$var$ti(this), n = t.string, r = t.index;
    return r >= n.length ? $c5aa5a6035c47210$var$qo(void 0, !0) : (e = $c5aa5a6035c47210$var$$o(n, r), t.index += e.length, $c5aa5a6035c47210$var$qo(e, !1));
});
var $c5aa5a6035c47210$var$ni = function(e, t, n) {
    var r, o;
    $c5aa5a6035c47210$var$Ue(e);
    try {
        if (!(r = $c5aa5a6035c47210$var$le(e, "return"))) {
            if ("throw" === t) throw n;
            return n;
        }
        r = $c5aa5a6035c47210$var$g(r, e);
    } catch (e) {
        o = !0, r = e;
    }
    if ("throw" === t) throw n;
    if (o) throw r;
    return $c5aa5a6035c47210$var$Ue(r), n;
}, $c5aa5a6035c47210$var$ri = function(e, t, n, r) {
    try {
        return r ? t($c5aa5a6035c47210$var$Ue(n)[0], n[1]) : t(n);
    } catch (t) {
        $c5aa5a6035c47210$var$ni(e, "throw", t);
    }
}, $c5aa5a6035c47210$var$oi = $c5aa5a6035c47210$var$Ce("iterator"), $c5aa5a6035c47210$var$ii = Array.prototype, $c5aa5a6035c47210$var$ci = function(e) {
    return void 0 !== e && ($c5aa5a6035c47210$var$Fo.Array === e || $c5aa5a6035c47210$var$ii[$c5aa5a6035c47210$var$oi] === e);
}, $c5aa5a6035c47210$var$ai = $c5aa5a6035c47210$var$Ce("iterator"), $c5aa5a6035c47210$var$si = function(e) {
    if (!$c5aa5a6035c47210$var$P(e)) return $c5aa5a6035c47210$var$le(e, $c5aa5a6035c47210$var$ai) || $c5aa5a6035c47210$var$le(e, "@@iterator") || $c5aa5a6035c47210$var$Fo[$c5aa5a6035c47210$var$tn(e)];
}, $c5aa5a6035c47210$var$ui = TypeError, $c5aa5a6035c47210$var$li = function(e, t) {
    var n = arguments.length < 2 ? $c5aa5a6035c47210$var$si(e) : t;
    if ($c5aa5a6035c47210$var$ue(n)) return $c5aa5a6035c47210$var$Ue($c5aa5a6035c47210$var$g(n, e));
    throw $c5aa5a6035c47210$var$ui($c5aa5a6035c47210$var$ae(e) + " is not iterable");
}, $c5aa5a6035c47210$var$fi = Array, $c5aa5a6035c47210$var$di = $c5aa5a6035c47210$var$Ce("iterator"), $c5aa5a6035c47210$var$hi = !1;
try {
    var $c5aa5a6035c47210$var$pi = 0, $c5aa5a6035c47210$var$yi = {
        next: function() {
            return {
                done: !!$c5aa5a6035c47210$var$pi++
            };
        },
        return: function() {
            $c5aa5a6035c47210$var$hi = !0;
        }
    };
    $c5aa5a6035c47210$var$yi[$c5aa5a6035c47210$var$di] = function() {
        return this;
    }, Array.from($c5aa5a6035c47210$var$yi, function() {
        throw 2;
    });
} catch (e) {}
var $c5aa5a6035c47210$var$vi = function(e, t) {
    if (!t && !$c5aa5a6035c47210$var$hi) return !1;
    var n = !1;
    try {
        var r = {};
        r[$c5aa5a6035c47210$var$di] = function() {
            return {
                next: function() {
                    return {
                        done: n = !0
                    };
                }
            };
        }, e(r);
    } catch (e) {}
    return n;
}, $c5aa5a6035c47210$var$mi = !$c5aa5a6035c47210$var$vi(function(e) {
    Array.from(e);
});
$c5aa5a6035c47210$var$zt({
    target: "Array",
    stat: !0,
    forced: $c5aa5a6035c47210$var$mi
}, {
    from: function(e) {
        var t = $c5aa5a6035c47210$var$me(e), n = $c5aa5a6035c47210$var$Ln(this), r = arguments.length, o = r > 1 ? arguments[1] : void 0, i = void 0 !== o;
        i && (o = $c5aa5a6035c47210$var$dr(o, r > 2 ? arguments[2] : void 0));
        var c, a, s, u, l, f, d = $c5aa5a6035c47210$var$si(t), h = 0;
        if (!d || this === $c5aa5a6035c47210$var$fi && $c5aa5a6035c47210$var$ci(d)) for(c = $c5aa5a6035c47210$var$Tt(t), a = n ? new this(c) : $c5aa5a6035c47210$var$fi(c); c > h; h++)f = i ? o(t[h], h) : t[h], $c5aa5a6035c47210$var$wn(a, h, f);
        else for(l = (u = $c5aa5a6035c47210$var$li(t, d)).next, a = n ? new this : []; !(s = $c5aa5a6035c47210$var$g(l, u)).done; h++)f = i ? $c5aa5a6035c47210$var$ri(u, o, [
            s.value,
            h
        ], !0) : s.value, $c5aa5a6035c47210$var$wn(a, h, f);
        return a.length = h, a;
    }
}), $c5aa5a6035c47210$var$or.Array.from;
var $c5aa5a6035c47210$var$bi, $c5aa5a6035c47210$var$gi, $c5aa5a6035c47210$var$wi, $c5aa5a6035c47210$var$Si = "undefined" != typeof ArrayBuffer && "undefined" != typeof DataView, $c5aa5a6035c47210$var$ki = $c5aa5a6035c47210$var$Je.f, $c5aa5a6035c47210$var$_i = $c5aa5a6035c47210$var$yt.enforce, $c5aa5a6035c47210$var$Ii = $c5aa5a6035c47210$var$yt.get, $c5aa5a6035c47210$var$Oi = $c5aa5a6035c47210$var$p.Int8Array, $c5aa5a6035c47210$var$xi = $c5aa5a6035c47210$var$Oi && $c5aa5a6035c47210$var$Oi.prototype, $c5aa5a6035c47210$var$Ti = $c5aa5a6035c47210$var$p.Uint8ClampedArray, $c5aa5a6035c47210$var$Ci = $c5aa5a6035c47210$var$Ti && $c5aa5a6035c47210$var$Ti.prototype, $c5aa5a6035c47210$var$ji = $c5aa5a6035c47210$var$Oi && $c5aa5a6035c47210$var$Eo($c5aa5a6035c47210$var$Oi), $c5aa5a6035c47210$var$Li = $c5aa5a6035c47210$var$xi && $c5aa5a6035c47210$var$Eo($c5aa5a6035c47210$var$xi), $c5aa5a6035c47210$var$Ri = Object.prototype, $c5aa5a6035c47210$var$Wi = $c5aa5a6035c47210$var$p.TypeError, $c5aa5a6035c47210$var$Zi = $c5aa5a6035c47210$var$Ce("toStringTag"), $c5aa5a6035c47210$var$Ei = $c5aa5a6035c47210$var$_e("TYPED_ARRAY_TAG"), $c5aa5a6035c47210$var$Gi = $c5aa5a6035c47210$var$Si && !!$c5aa5a6035c47210$var$Ho && "Opera" !== $c5aa5a6035c47210$var$tn($c5aa5a6035c47210$var$p.opera), $c5aa5a6035c47210$var$Ai = !1, $c5aa5a6035c47210$var$Pi = {
    Int8Array: 1,
    Uint8Array: 1,
    Uint8ClampedArray: 1,
    Int16Array: 2,
    Uint16Array: 2,
    Int32Array: 4,
    Uint32Array: 4,
    Float32Array: 4,
    Float64Array: 8
}, $c5aa5a6035c47210$var$Xi = {
    BigInt64Array: 8,
    BigUint64Array: 8
}, $c5aa5a6035c47210$var$Fi = function(e) {
    var t = $c5aa5a6035c47210$var$Eo(e);
    if ($c5aa5a6035c47210$var$J(t)) {
        var n = $c5aa5a6035c47210$var$Ii(t);
        return n && $c5aa5a6035c47210$var$ge(n, "TypedArrayConstructor") ? n.TypedArrayConstructor : $c5aa5a6035c47210$var$Fi(t);
    }
}, $c5aa5a6035c47210$var$Ki = function(e) {
    if (!$c5aa5a6035c47210$var$J(e)) return !1;
    var t = $c5aa5a6035c47210$var$tn(e);
    return $c5aa5a6035c47210$var$ge($c5aa5a6035c47210$var$Pi, t) || $c5aa5a6035c47210$var$ge($c5aa5a6035c47210$var$Xi, t);
};
for($c5aa5a6035c47210$var$bi in $c5aa5a6035c47210$var$Pi)($c5aa5a6035c47210$var$wi = ($c5aa5a6035c47210$var$gi = $c5aa5a6035c47210$var$p[$c5aa5a6035c47210$var$bi]) && $c5aa5a6035c47210$var$gi.prototype) ? $c5aa5a6035c47210$var$_i($c5aa5a6035c47210$var$wi).TypedArrayConstructor = $c5aa5a6035c47210$var$gi : $c5aa5a6035c47210$var$Gi = !1;
for($c5aa5a6035c47210$var$bi in $c5aa5a6035c47210$var$Xi)($c5aa5a6035c47210$var$wi = ($c5aa5a6035c47210$var$gi = $c5aa5a6035c47210$var$p[$c5aa5a6035c47210$var$bi]) && $c5aa5a6035c47210$var$gi.prototype) && ($c5aa5a6035c47210$var$_i($c5aa5a6035c47210$var$wi).TypedArrayConstructor = $c5aa5a6035c47210$var$gi);
if ((!$c5aa5a6035c47210$var$Gi || !$c5aa5a6035c47210$var$H($c5aa5a6035c47210$var$ji) || $c5aa5a6035c47210$var$ji === Function.prototype) && ($c5aa5a6035c47210$var$ji = function() {
    throw $c5aa5a6035c47210$var$Wi("Incorrect invocation");
}, $c5aa5a6035c47210$var$Gi)) for($c5aa5a6035c47210$var$bi in $c5aa5a6035c47210$var$Pi)$c5aa5a6035c47210$var$p[$c5aa5a6035c47210$var$bi] && $c5aa5a6035c47210$var$Ho($c5aa5a6035c47210$var$p[$c5aa5a6035c47210$var$bi], $c5aa5a6035c47210$var$ji);
if ((!$c5aa5a6035c47210$var$Gi || !$c5aa5a6035c47210$var$Li || $c5aa5a6035c47210$var$Li === $c5aa5a6035c47210$var$Ri) && ($c5aa5a6035c47210$var$Li = $c5aa5a6035c47210$var$ji.prototype, $c5aa5a6035c47210$var$Gi)) for($c5aa5a6035c47210$var$bi in $c5aa5a6035c47210$var$Pi)$c5aa5a6035c47210$var$p[$c5aa5a6035c47210$var$bi] && $c5aa5a6035c47210$var$Ho($c5aa5a6035c47210$var$p[$c5aa5a6035c47210$var$bi].prototype, $c5aa5a6035c47210$var$Li);
if ($c5aa5a6035c47210$var$Gi && $c5aa5a6035c47210$var$Eo($c5aa5a6035c47210$var$Ci) !== $c5aa5a6035c47210$var$Li && $c5aa5a6035c47210$var$Ho($c5aa5a6035c47210$var$Ci, $c5aa5a6035c47210$var$Li), $c5aa5a6035c47210$var$v && !$c5aa5a6035c47210$var$ge($c5aa5a6035c47210$var$Li, $c5aa5a6035c47210$var$Zi)) for($c5aa5a6035c47210$var$bi in $c5aa5a6035c47210$var$Ai = !0, $c5aa5a6035c47210$var$ki($c5aa5a6035c47210$var$Li, $c5aa5a6035c47210$var$Zi, {
    get: function() {
        return $c5aa5a6035c47210$var$J(this) ? this[$c5aa5a6035c47210$var$Ei] : void 0;
    }
}), $c5aa5a6035c47210$var$Pi)$c5aa5a6035c47210$var$p[$c5aa5a6035c47210$var$bi] && $c5aa5a6035c47210$var$Ve($c5aa5a6035c47210$var$p[$c5aa5a6035c47210$var$bi], $c5aa5a6035c47210$var$Ei, $c5aa5a6035c47210$var$bi);
var $c5aa5a6035c47210$var$Ni = {
    NATIVE_ARRAY_BUFFER_VIEWS: $c5aa5a6035c47210$var$Gi,
    TYPED_ARRAY_TAG: $c5aa5a6035c47210$var$Ai && $c5aa5a6035c47210$var$Ei,
    aTypedArray: function(e) {
        if ($c5aa5a6035c47210$var$Ki(e)) return e;
        throw $c5aa5a6035c47210$var$Wi("Target is not a typed array");
    },
    aTypedArrayConstructor: function(e) {
        if ($c5aa5a6035c47210$var$H(e) && (!$c5aa5a6035c47210$var$Ho || $c5aa5a6035c47210$var$M($c5aa5a6035c47210$var$ji, e))) return e;
        throw $c5aa5a6035c47210$var$Wi($c5aa5a6035c47210$var$ae(e) + " is not a typed array constructor");
    },
    exportTypedArrayMethod: function(e, t, n, r) {
        if ($c5aa5a6035c47210$var$v) {
            if (n) for(var o in $c5aa5a6035c47210$var$Pi){
                var i = $c5aa5a6035c47210$var$p[o];
                if (i && $c5aa5a6035c47210$var$ge(i.prototype, e)) try {
                    delete i.prototype[e];
                } catch (n) {
                    try {
                        i.prototype[e] = t;
                    } catch (e) {}
                }
            }
            $c5aa5a6035c47210$var$Li[e] && !n || $c5aa5a6035c47210$var$mt($c5aa5a6035c47210$var$Li, e, n ? t : $c5aa5a6035c47210$var$Gi && $c5aa5a6035c47210$var$xi[e] || t, r);
        }
    },
    exportTypedArrayStaticMethod: function(e, t, n) {
        var r, o;
        if ($c5aa5a6035c47210$var$v) {
            if ($c5aa5a6035c47210$var$Ho) {
                if (n) {
                    for(r in $c5aa5a6035c47210$var$Pi)if ((o = $c5aa5a6035c47210$var$p[r]) && $c5aa5a6035c47210$var$ge(o, e)) try {
                        delete o[e];
                    } catch (e) {}
                }
                if ($c5aa5a6035c47210$var$ji[e] && !n) return;
                try {
                    return $c5aa5a6035c47210$var$mt($c5aa5a6035c47210$var$ji, e, n ? t : $c5aa5a6035c47210$var$Gi && $c5aa5a6035c47210$var$ji[e] || t);
                } catch (e) {}
            }
            for(r in $c5aa5a6035c47210$var$Pi)!(o = $c5aa5a6035c47210$var$p[r]) || o[e] && !n || $c5aa5a6035c47210$var$mt(o, e, t);
        }
    },
    getTypedArrayConstructor: $c5aa5a6035c47210$var$Fi,
    isView: function(e) {
        if (!$c5aa5a6035c47210$var$J(e)) return !1;
        var t = $c5aa5a6035c47210$var$tn(e);
        return "DataView" === t || $c5aa5a6035c47210$var$ge($c5aa5a6035c47210$var$Pi, t) || $c5aa5a6035c47210$var$ge($c5aa5a6035c47210$var$Xi, t);
    },
    isTypedArray: $c5aa5a6035c47210$var$Ki,
    TypedArray: $c5aa5a6035c47210$var$ji,
    TypedArrayPrototype: $c5aa5a6035c47210$var$Li
}, $c5aa5a6035c47210$var$Ui = TypeError, $c5aa5a6035c47210$var$Di = $c5aa5a6035c47210$var$Ce("species"), $c5aa5a6035c47210$var$Hi = function(e, t) {
    var n, r = $c5aa5a6035c47210$var$Ue(e).constructor;
    return void 0 === r || $c5aa5a6035c47210$var$P(n = $c5aa5a6035c47210$var$Ue(r)[$c5aa5a6035c47210$var$Di]) ? t : function(e) {
        if ($c5aa5a6035c47210$var$Ln(e)) return e;
        throw $c5aa5a6035c47210$var$Ui($c5aa5a6035c47210$var$ae(e) + " is not a constructor");
    }(n);
}, $c5aa5a6035c47210$var$Yi = $c5aa5a6035c47210$var$Ni.aTypedArrayConstructor, $c5aa5a6035c47210$var$Ji = $c5aa5a6035c47210$var$Ni.getTypedArrayConstructor, $c5aa5a6035c47210$var$Vi = $c5aa5a6035c47210$var$Ni.aTypedArray;
(0, $c5aa5a6035c47210$var$Ni.exportTypedArrayMethod)("slice", function(e, t) {
    for(var n, r = $c5aa5a6035c47210$var$Mr($c5aa5a6035c47210$var$Vi(this), e, t), o = $c5aa5a6035c47210$var$Yi($c5aa5a6035c47210$var$Hi(n = this, $c5aa5a6035c47210$var$Ji(n))), i = 0, c = r.length, a = new o(c); c > i;)a[i] = r[i++];
    return a;
}, $c5aa5a6035c47210$var$y(function() {
    new Int8Array(1).slice();
}));
var $c5aa5a6035c47210$var$zi = $c5aa5a6035c47210$var$Je.f, $c5aa5a6035c47210$var$Mi = $c5aa5a6035c47210$var$Ce("unscopables"), $c5aa5a6035c47210$var$Bi = Array.prototype;
null == $c5aa5a6035c47210$var$Bi[$c5aa5a6035c47210$var$Mi] && $c5aa5a6035c47210$var$zi($c5aa5a6035c47210$var$Bi, $c5aa5a6035c47210$var$Mi, {
    configurable: !0,
    value: $c5aa5a6035c47210$var$Bn(null)
});
var $c5aa5a6035c47210$var$Qi = function(e) {
    $c5aa5a6035c47210$var$Bi[$c5aa5a6035c47210$var$Mi][e] = !0;
}, $c5aa5a6035c47210$var$qi = $c5aa5a6035c47210$var$jt.includes, $c5aa5a6035c47210$var$$i = $c5aa5a6035c47210$var$y(function() {
    return !Array(1).includes();
});
$c5aa5a6035c47210$var$zt({
    target: "Array",
    proto: !0,
    forced: $c5aa5a6035c47210$var$$i
}, {
    includes: function(e) {
        return $c5aa5a6035c47210$var$qi(this, e, arguments.length > 1 ? arguments[1] : void 0);
    }
}), $c5aa5a6035c47210$var$Qi("includes"), $c5aa5a6035c47210$var$vn("Array", "includes");
var $c5aa5a6035c47210$var$ec = $c5aa5a6035c47210$var$L("".indexOf);
$c5aa5a6035c47210$var$zt({
    target: "String",
    proto: !0,
    forced: !$c5aa5a6035c47210$var$un("includes")
}, {
    includes: function(e) {
        return !!~$c5aa5a6035c47210$var$ec($c5aa5a6035c47210$var$rn($c5aa5a6035c47210$var$F(this)), $c5aa5a6035c47210$var$rn($c5aa5a6035c47210$var$an(e)), arguments.length > 1 ? arguments[1] : void 0);
    }
}), $c5aa5a6035c47210$var$vn("String", "includes");
var $c5aa5a6035c47210$var$tc = $c5aa5a6035c47210$var$Je.f, $c5aa5a6035c47210$var$nc = $c5aa5a6035c47210$var$yt.set, $c5aa5a6035c47210$var$rc = $c5aa5a6035c47210$var$yt.getterFor("Array Iterator");
$c5aa5a6035c47210$var$Qo(Array, "Array", function(e, t) {
    $c5aa5a6035c47210$var$nc(this, {
        type: "Array Iterator",
        target: $c5aa5a6035c47210$var$K(e),
        index: 0,
        kind: t
    });
}, function() {
    var e = $c5aa5a6035c47210$var$rc(this), t = e.target, n = e.kind, r = e.index++;
    return !t || r >= t.length ? (e.target = void 0, $c5aa5a6035c47210$var$qo(void 0, !0)) : $c5aa5a6035c47210$var$qo("keys" == n ? r : "values" == n ? t[r] : [
        r,
        t[r]
    ], !1);
}, "values");
var $c5aa5a6035c47210$var$oc = $c5aa5a6035c47210$var$Fo.Arguments = $c5aa5a6035c47210$var$Fo.Array;
if ($c5aa5a6035c47210$var$Qi("keys"), $c5aa5a6035c47210$var$Qi("values"), $c5aa5a6035c47210$var$Qi("entries"), $c5aa5a6035c47210$var$v && "values" !== $c5aa5a6035c47210$var$oc.name) try {
    $c5aa5a6035c47210$var$tc($c5aa5a6035c47210$var$oc, "name", {
        value: "values"
    });
} catch (e) {}
var $c5aa5a6035c47210$var$ic = $c5aa5a6035c47210$var$y(function() {
    if ("function" == typeof ArrayBuffer) {
        var e = new ArrayBuffer(8);
        Object.isExtensible(e) && Object.defineProperty(e, "a", {
            value: 8
        });
    }
}), $c5aa5a6035c47210$var$cc = Object.isExtensible, $c5aa5a6035c47210$var$ac = $c5aa5a6035c47210$var$y(function() {
    $c5aa5a6035c47210$var$cc(1);
}) || $c5aa5a6035c47210$var$ic ? function(e) {
    return !!$c5aa5a6035c47210$var$J(e) && (!$c5aa5a6035c47210$var$ic || "ArrayBuffer" != $c5aa5a6035c47210$var$Z(e)) && (!$c5aa5a6035c47210$var$cc || $c5aa5a6035c47210$var$cc(e));
} : $c5aa5a6035c47210$var$cc, $c5aa5a6035c47210$var$sc = !$c5aa5a6035c47210$var$y(function() {
    return Object.isExtensible(Object.preventExtensions({}));
}), $c5aa5a6035c47210$var$uc = $c5aa5a6035c47210$var$l(function(e) {
    var t = $c5aa5a6035c47210$var$Je.f, n = !1, r = $c5aa5a6035c47210$var$_e("meta"), o = 0, i = function(e) {
        t(e, r, {
            value: {
                objectID: "O" + o++,
                weakData: {}
            }
        });
    }, c = e.exports = {
        enable: function() {
            c.enable = function() {}, n = !0;
            var e = $c5aa5a6035c47210$var$Gt.f, t = $c5aa5a6035c47210$var$L([].splice), o = {};
            o[r] = 1, e(o).length && ($c5aa5a6035c47210$var$Gt.f = function(n) {
                for(var o = e(n), i = 0, c = o.length; i < c; i++)if (o[i] === r) {
                    t(o, i, 1);
                    break;
                }
                return o;
            }, $c5aa5a6035c47210$var$zt({
                target: "Object",
                stat: !0,
                forced: !0
            }, {
                getOwnPropertyNames: $c5aa5a6035c47210$var$nr.f
            }));
        },
        fastKey: function(e, t) {
            if (!$c5aa5a6035c47210$var$J(e)) return "symbol" == typeof e ? e : ("string" == typeof e ? "S" : "P") + e;
            if (!$c5aa5a6035c47210$var$ge(e, r)) {
                if (!$c5aa5a6035c47210$var$ac(e)) return "F";
                if (!t) return "E";
                i(e);
            }
            return e[r].objectID;
        },
        getWeakData: function(e, t) {
            if (!$c5aa5a6035c47210$var$ge(e, r)) {
                if (!$c5aa5a6035c47210$var$ac(e)) return !0;
                if (!t) return !1;
                i(e);
            }
            return e[r].weakData;
        },
        onFreeze: function(e) {
            return $c5aa5a6035c47210$var$sc && n && $c5aa5a6035c47210$var$ac(e) && !$c5aa5a6035c47210$var$ge(e, r) && i(e), e;
        }
    };
    $c5aa5a6035c47210$var$at[r] = !0;
});
$c5aa5a6035c47210$var$uc.enable, $c5aa5a6035c47210$var$uc.fastKey, $c5aa5a6035c47210$var$uc.getWeakData, $c5aa5a6035c47210$var$uc.onFreeze;
var $c5aa5a6035c47210$var$lc = TypeError, $c5aa5a6035c47210$var$fc = function(e, t) {
    this.stopped = e, this.result = t;
}, $c5aa5a6035c47210$var$dc = $c5aa5a6035c47210$var$fc.prototype, $c5aa5a6035c47210$var$hc = function(e, t, n) {
    var r, o, i, c, a, s, u, l = n && n.that, f = !(!n || !n.AS_ENTRIES), d = !(!n || !n.IS_RECORD), h = !(!n || !n.IS_ITERATOR), p = !(!n || !n.INTERRUPTED), y = $c5aa5a6035c47210$var$dr(t, l), v = function(e) {
        return r && $c5aa5a6035c47210$var$ni(r, "normal", e), new $c5aa5a6035c47210$var$fc(!0, e);
    }, m = function(e) {
        return f ? ($c5aa5a6035c47210$var$Ue(e), p ? y(e[0], e[1], v) : y(e[0], e[1])) : p ? y(e, v) : y(e);
    };
    if (d) r = e.iterator;
    else if (h) r = e;
    else {
        if (!(o = $c5aa5a6035c47210$var$si(e))) throw $c5aa5a6035c47210$var$lc($c5aa5a6035c47210$var$ae(e) + " is not iterable");
        if ($c5aa5a6035c47210$var$ci(o)) {
            for(i = 0, c = $c5aa5a6035c47210$var$Tt(e); c > i; i++)if ((a = m(e[i])) && $c5aa5a6035c47210$var$M($c5aa5a6035c47210$var$dc, a)) return a;
            return new $c5aa5a6035c47210$var$fc(!1);
        }
        r = $c5aa5a6035c47210$var$li(e, o);
    }
    for(s = d ? e.next : r.next; !(u = $c5aa5a6035c47210$var$g(s, r)).done;){
        try {
            a = m(u.value);
        } catch (e) {
            $c5aa5a6035c47210$var$ni(r, "throw", e);
        }
        if ("object" == typeof a && a && $c5aa5a6035c47210$var$M($c5aa5a6035c47210$var$dc, a)) return a;
    }
    return new $c5aa5a6035c47210$var$fc(!1);
}, $c5aa5a6035c47210$var$pc = TypeError, $c5aa5a6035c47210$var$yc = function(e, t) {
    if ($c5aa5a6035c47210$var$M(t, e)) return e;
    throw $c5aa5a6035c47210$var$pc("Incorrect invocation");
}, $c5aa5a6035c47210$var$vc = function(e, t, n) {
    for(var r in t)$c5aa5a6035c47210$var$mt(e, r, t[r], n);
    return e;
}, $c5aa5a6035c47210$var$mc = $c5aa5a6035c47210$var$Ce("species"), $c5aa5a6035c47210$var$bc = $c5aa5a6035c47210$var$Je.f, $c5aa5a6035c47210$var$gc = $c5aa5a6035c47210$var$uc.fastKey, $c5aa5a6035c47210$var$wc = $c5aa5a6035c47210$var$yt.set, $c5aa5a6035c47210$var$Sc = $c5aa5a6035c47210$var$yt.getterFor, $c5aa5a6035c47210$var$kc = {
    getConstructor: function(e, t, n, r) {
        var o = e(function(e, o) {
            $c5aa5a6035c47210$var$yc(e, i), $c5aa5a6035c47210$var$wc(e, {
                type: t,
                index: $c5aa5a6035c47210$var$Bn(null),
                first: void 0,
                last: void 0,
                size: 0
            }), $c5aa5a6035c47210$var$v || (e.size = 0), $c5aa5a6035c47210$var$P(o) || $c5aa5a6035c47210$var$hc(o, e[r], {
                that: e,
                AS_ENTRIES: n
            });
        }), i = o.prototype, c = $c5aa5a6035c47210$var$Sc(t), a = function(e, t, n) {
            var r, o, i = c(e), a = s(e, t);
            return a ? a.value = n : (i.last = a = {
                index: o = $c5aa5a6035c47210$var$gc(t, !0),
                key: t,
                value: n,
                previous: r = i.last,
                next: void 0,
                removed: !1
            }, i.first || (i.first = a), r && (r.next = a), $c5aa5a6035c47210$var$v ? i.size++ : e.size++, "F" !== o && (i.index[o] = a)), e;
        }, s = function(e, t) {
            var n, r = c(e), o = $c5aa5a6035c47210$var$gc(t);
            if ("F" !== o) return r.index[o];
            for(n = r.first; n; n = n.next)if (n.key == t) return n;
        };
        return $c5aa5a6035c47210$var$vc(i, {
            clear: function() {
                for(var e = c(this), t = e.index, n = e.first; n;)n.removed = !0, n.previous && (n.previous = n.previous.next = void 0), delete t[n.index], n = n.next;
                e.first = e.last = void 0, $c5aa5a6035c47210$var$v ? e.size = 0 : this.size = 0;
            },
            delete: function(e) {
                var t = this, n = c(t), r = s(t, e);
                if (r) {
                    var o = r.next, i = r.previous;
                    delete n.index[r.index], r.removed = !0, i && (i.next = o), o && (o.previous = i), n.first == r && (n.first = o), n.last == r && (n.last = i), $c5aa5a6035c47210$var$v ? n.size-- : t.size--;
                }
                return !!r;
            },
            forEach: function(e) {
                for(var t, n = c(this), r = $c5aa5a6035c47210$var$dr(e, arguments.length > 1 ? arguments[1] : void 0); t = t ? t.next : n.first;)for(r(t.value, t.key, this); t && t.removed;)t = t.previous;
            },
            has: function(e) {
                return !!s(this, e);
            }
        }), $c5aa5a6035c47210$var$vc(i, n ? {
            get: function(e) {
                var t = s(this, e);
                return t && t.value;
            },
            set: function(e, t) {
                return a(this, 0 === e ? 0 : e, t);
            }
        } : {
            add: function(e) {
                return a(this, e = 0 === e ? 0 : e, e);
            }
        }), $c5aa5a6035c47210$var$v && $c5aa5a6035c47210$var$bc(i, "size", {
            get: function() {
                return c(this).size;
            }
        }), o;
    },
    setStrong: function(e, t, n) {
        var r = t + " Iterator", o = $c5aa5a6035c47210$var$Sc(t), i = $c5aa5a6035c47210$var$Sc(r);
        $c5aa5a6035c47210$var$Qo(e, t, function(e, t) {
            $c5aa5a6035c47210$var$wc(this, {
                type: r,
                target: e,
                state: o(e),
                kind: t,
                last: void 0
            });
        }, function() {
            for(var e = i(this), t = e.kind, n = e.last; n && n.removed;)n = n.previous;
            return e.target && (e.last = n = n ? n.next : e.state.first) ? $c5aa5a6035c47210$var$qo("keys" == t ? n.key : "values" == t ? n.value : [
                n.key,
                n.value
            ], !1) : (e.target = void 0, $c5aa5a6035c47210$var$qo(void 0, !0));
        }, n ? "entries" : "values", !n, !0), function(e) {
            var t = $c5aa5a6035c47210$var$z(e), n = $c5aa5a6035c47210$var$Je.f;
            $c5aa5a6035c47210$var$v && t && !t[$c5aa5a6035c47210$var$mc] && n(t, $c5aa5a6035c47210$var$mc, {
                configurable: !0,
                get: function() {
                    return this;
                }
            });
        }(t);
    }
};
function $c5aa5a6035c47210$var$_c(e) {
    var t = this.constructor;
    return this.then(function(n) {
        return t.resolve(e()).then(function() {
            return n;
        });
    }, function(n) {
        return t.resolve(e()).then(function() {
            return t.reject(n);
        });
    });
}
function $c5aa5a6035c47210$var$Ic(e) {
    return new this(function(t, n) {
        if (!e || void 0 === e.length) return n(new TypeError(typeof e + " " + e + " is not iterable(cannot read property Symbol(Symbol.iterator))"));
        var r = Array.prototype.slice.call(e);
        if (0 === r.length) return t([]);
        var o = r.length;
        function i(e, n) {
            if (n && ("object" == typeof n || "function" == typeof n)) {
                var c = n.then;
                if ("function" == typeof c) return void c.call(n, function(t) {
                    i(e, t);
                }, function(n) {
                    r[e] = {
                        status: "rejected",
                        reason: n
                    }, 0 == --o && t(r);
                });
            }
            r[e] = {
                status: "fulfilled",
                value: n
            }, 0 == --o && t(r);
        }
        for(var c = 0; c < r.length; c++)i(c, r[c]);
    });
}
!function(e, t, n) {
    var r = -1 !== e.indexOf("Map"), o = -1 !== e.indexOf("Weak"), i = r ? "set" : "add", c = $c5aa5a6035c47210$var$p[e], a = c && c.prototype, s = c, u = {}, l = function(e) {
        var t = $c5aa5a6035c47210$var$L(a[e]);
        $c5aa5a6035c47210$var$mt(a, e, "add" == e ? function(e) {
            return t(this, 0 === e ? 0 : e), this;
        } : "delete" == e ? function(e) {
            return !(o && !$c5aa5a6035c47210$var$J(e)) && t(this, 0 === e ? 0 : e);
        } : "get" == e ? function(e) {
            return o && !$c5aa5a6035c47210$var$J(e) ? void 0 : t(this, 0 === e ? 0 : e);
        } : "has" == e ? function(e) {
            return !(o && !$c5aa5a6035c47210$var$J(e)) && t(this, 0 === e ? 0 : e);
        } : function(e, n) {
            return t(this, 0 === e ? 0 : e, n), this;
        });
    };
    if ($c5aa5a6035c47210$var$Jt(e, !$c5aa5a6035c47210$var$H(c) || !(o || a.forEach && !$c5aa5a6035c47210$var$y(function() {
        (new c).entries().next();
    })))) s = n.getConstructor(t, e, r, i), $c5aa5a6035c47210$var$uc.enable();
    else if ($c5aa5a6035c47210$var$Jt(e, !0)) {
        var f = new s, d = f[i](o ? {} : -0, 1) != f, h = $c5aa5a6035c47210$var$y(function() {
            f.has(1);
        }), v = $c5aa5a6035c47210$var$vi(function(e) {
            new c(e);
        }), m = !o && $c5aa5a6035c47210$var$y(function() {
            for(var e = new c, t = 5; t--;)e[i](t, t);
            return !e.has(-0);
        });
        v || ((s = t(function(e, t) {
            $c5aa5a6035c47210$var$yc(e, a);
            var n = function(e, t, n) {
                var r, o;
                return $c5aa5a6035c47210$var$Ho && $c5aa5a6035c47210$var$H(r = t.constructor) && r !== n && $c5aa5a6035c47210$var$J(o = r.prototype) && o !== n.prototype && $c5aa5a6035c47210$var$Ho(e, o), e;
            }(new c, e, s);
            return $c5aa5a6035c47210$var$P(t) || $c5aa5a6035c47210$var$hc(t, n[i], {
                that: n,
                AS_ENTRIES: r
            }), n;
        })).prototype = a, a.constructor = s), (h || m) && (l("delete"), l("has"), r && l("get")), (m || d) && l(i), o && a.clear && delete a.clear;
    }
    u[e] = s, $c5aa5a6035c47210$var$zt({
        global: !0,
        constructor: !0,
        forced: s != c
    }, u), $c5aa5a6035c47210$var$lr(s, e), o || n.setStrong(s, e, r);
}("Set", function(e) {
    return function() {
        return e(this, arguments.length ? arguments[0] : void 0);
    };
}, $c5aa5a6035c47210$var$kc), $c5aa5a6035c47210$var$or.Set;
var $c5aa5a6035c47210$var$Oc = setTimeout;
function $c5aa5a6035c47210$var$xc(e) {
    return Boolean(e && void 0 !== e.length);
}
function $c5aa5a6035c47210$var$Tc() {}
function $c5aa5a6035c47210$var$Cc(e) {
    if (!(this instanceof $c5aa5a6035c47210$var$Cc)) throw new TypeError("Promises must be constructed via new");
    if ("function" != typeof e) throw new TypeError("not a function");
    this._state = 0, this._handled = !1, this._value = void 0, this._deferreds = [], $c5aa5a6035c47210$var$Ec(e, this);
}
function $c5aa5a6035c47210$var$jc(e, t) {
    for(; 3 === e._state;)e = e._value;
    0 !== e._state ? (e._handled = !0, $c5aa5a6035c47210$var$Cc._immediateFn(function() {
        var n = 1 === e._state ? t.onFulfilled : t.onRejected;
        if (null !== n) {
            var r;
            try {
                r = n(e._value);
            } catch (e) {
                return void $c5aa5a6035c47210$var$Rc(t.promise, e);
            }
            $c5aa5a6035c47210$var$Lc(t.promise, r);
        } else (1 === e._state ? $c5aa5a6035c47210$var$Lc : $c5aa5a6035c47210$var$Rc)(t.promise, e._value);
    })) : e._deferreds.push(t);
}
function $c5aa5a6035c47210$var$Lc(e, t) {
    try {
        if (t === e) throw new TypeError("A promise cannot be resolved with itself.");
        if (t && ("object" == typeof t || "function" == typeof t)) {
            var n = t.then;
            if (t instanceof $c5aa5a6035c47210$var$Cc) return e._state = 3, e._value = t, void $c5aa5a6035c47210$var$Wc(e);
            if ("function" == typeof n) return void $c5aa5a6035c47210$var$Ec((r = n, o = t, function() {
                r.apply(o, arguments);
            }), e);
        }
        e._state = 1, e._value = t, $c5aa5a6035c47210$var$Wc(e);
    } catch (t) {
        $c5aa5a6035c47210$var$Rc(e, t);
    }
    var r, o;
}
function $c5aa5a6035c47210$var$Rc(e, t) {
    e._state = 2, e._value = t, $c5aa5a6035c47210$var$Wc(e);
}
function $c5aa5a6035c47210$var$Wc(e) {
    2 === e._state && 0 === e._deferreds.length && $c5aa5a6035c47210$var$Cc._immediateFn(function() {
        e._handled || $c5aa5a6035c47210$var$Cc._unhandledRejectionFn(e._value);
    });
    for(var t = 0, n = e._deferreds.length; t < n; t++)$c5aa5a6035c47210$var$jc(e, e._deferreds[t]);
    e._deferreds = null;
}
function $c5aa5a6035c47210$var$Zc(e, t, n) {
    this.onFulfilled = "function" == typeof e ? e : null, this.onRejected = "function" == typeof t ? t : null, this.promise = n;
}
function $c5aa5a6035c47210$var$Ec(e, t) {
    var n = !1;
    try {
        e(function(e) {
            n || (n = !0, $c5aa5a6035c47210$var$Lc(t, e));
        }, function(e) {
            n || (n = !0, $c5aa5a6035c47210$var$Rc(t, e));
        });
    } catch (e) {
        if (n) return;
        n = !0, $c5aa5a6035c47210$var$Rc(t, e);
    }
}
$c5aa5a6035c47210$var$Cc.prototype.catch = function(e) {
    return this.then(null, e);
}, $c5aa5a6035c47210$var$Cc.prototype.then = function(e, t) {
    var n = new this.constructor($c5aa5a6035c47210$var$Tc);
    return $c5aa5a6035c47210$var$jc(this, new $c5aa5a6035c47210$var$Zc(e, t, n)), n;
}, $c5aa5a6035c47210$var$Cc.prototype.finally = $c5aa5a6035c47210$var$_c, $c5aa5a6035c47210$var$Cc.all = function(e) {
    return new $c5aa5a6035c47210$var$Cc(function(t, n) {
        if (!$c5aa5a6035c47210$var$xc(e)) return n(new TypeError("Promise.all accepts an array"));
        var r = Array.prototype.slice.call(e);
        if (0 === r.length) return t([]);
        var o = r.length;
        function i(e, c) {
            try {
                if (c && ("object" == typeof c || "function" == typeof c)) {
                    var a = c.then;
                    if ("function" == typeof a) return void a.call(c, function(t) {
                        i(e, t);
                    }, n);
                }
                r[e] = c, 0 == --o && t(r);
            } catch (e) {
                n(e);
            }
        }
        for(var c = 0; c < r.length; c++)i(c, r[c]);
    });
}, $c5aa5a6035c47210$var$Cc.allSettled = $c5aa5a6035c47210$var$Ic, $c5aa5a6035c47210$var$Cc.resolve = function(e) {
    return e && "object" == typeof e && e.constructor === $c5aa5a6035c47210$var$Cc ? e : new $c5aa5a6035c47210$var$Cc(function(t) {
        t(e);
    });
}, $c5aa5a6035c47210$var$Cc.reject = function(e) {
    return new $c5aa5a6035c47210$var$Cc(function(t, n) {
        n(e);
    });
}, $c5aa5a6035c47210$var$Cc.race = function(e) {
    return new $c5aa5a6035c47210$var$Cc(function(t, n) {
        if (!$c5aa5a6035c47210$var$xc(e)) return n(new TypeError("Promise.race accepts an array"));
        for(var r = 0, o = e.length; r < o; r++)$c5aa5a6035c47210$var$Cc.resolve(e[r]).then(t, n);
    });
}, $c5aa5a6035c47210$var$Cc._immediateFn = "function" == typeof setImmediate && function(e) {
    setImmediate(e);
} || function(e) {
    $c5aa5a6035c47210$var$Oc(e, 0);
}, $c5aa5a6035c47210$var$Cc._unhandledRejectionFn = function(e) {
    "undefined" != typeof console && console && console.warn("Possible Unhandled Promise Rejection:", e);
};
var $c5aa5a6035c47210$var$Gc = function() {
    if ("undefined" != typeof self) return self;
    if ("undefined" != typeof window) return window;
    if ("undefined" != typeof $parcel$global) return $parcel$global;
    throw new Error("unable to locate global object");
}();
"function" != typeof $c5aa5a6035c47210$var$Gc.Promise ? $c5aa5a6035c47210$var$Gc.Promise = $c5aa5a6035c47210$var$Cc : ($c5aa5a6035c47210$var$Gc.Promise.prototype.finally || ($c5aa5a6035c47210$var$Gc.Promise.prototype.finally = $c5aa5a6035c47210$var$_c), $c5aa5a6035c47210$var$Gc.Promise.allSettled || ($c5aa5a6035c47210$var$Gc.Promise.allSettled = $c5aa5a6035c47210$var$Ic)), function(e) {
    function t(e) {
        for(var t = 0, n = Math.min(65536, e.length + 1), r = new Uint16Array(n), o = [], i = 0;;){
            var c = t < e.length;
            if (!c || i >= n - 1) {
                var a = r.subarray(0, i);
                if (o.push(String.fromCharCode.apply(null, a)), !c) return o.join("");
                e = e.subarray(t), t = 0, i = 0;
            }
            var s = e[t++];
            if (0 == (128 & s)) r[i++] = s;
            else if (192 == (224 & s)) {
                var u = 63 & e[t++];
                r[i++] = (31 & s) << 6 | u;
            } else if (224 == (240 & s)) {
                u = 63 & e[t++];
                var l = 63 & e[t++];
                r[i++] = (31 & s) << 12 | u << 6 | l;
            } else if (240 == (248 & s)) {
                var f = (7 & s) << 18 | (u = 63 & e[t++]) << 12 | (l = 63 & e[t++]) << 6 | 63 & e[t++];
                f > 65535 && (f -= 65536, r[i++] = f >>> 10 & 1023 | 55296, f = 56320 | 1023 & f), r[i++] = f;
            }
        }
    }
    var n = "Failed to ", r = function(e, t, r) {
        if (e) throw new Error("".concat(n).concat(t, ": the '").concat(r, "' option is unsupported."));
    }, o = "function" == typeof $c5aa5a6035c47210$require$Buffer && $c5aa5a6035c47210$require$Buffer.from, i = o ? function(e) {
        return $c5aa5a6035c47210$require$Buffer.from(e);
    } : function(e) {
        for(var t = 0, n = e.length, r = 0, o = Math.max(32, n + (n >>> 1) + 7), i = new Uint8Array(o >>> 3 << 3); t < n;){
            var c = e.charCodeAt(t++);
            if (c >= 55296 && c <= 56319) {
                if (t < n) {
                    var a = e.charCodeAt(t);
                    56320 == (64512 & a) && (++t, c = ((1023 & c) << 10) + (1023 & a) + 65536);
                }
                if (c >= 55296 && c <= 56319) continue;
            }
            if (r + 4 > i.length) {
                o += 8, o = (o *= 1 + t / e.length * 2) >>> 3 << 3;
                var s = new Uint8Array(o);
                s.set(i), i = s;
            }
            if (0 != (4294967168 & c)) {
                if (0 == (4294965248 & c)) i[r++] = c >>> 6 & 31 | 192;
                else if (0 == (4294901760 & c)) i[r++] = c >>> 12 & 15 | 224, i[r++] = c >>> 6 & 63 | 128;
                else {
                    if (0 != (4292870144 & c)) continue;
                    i[r++] = c >>> 18 & 7 | 240, i[r++] = c >>> 12 & 63 | 128, i[r++] = c >>> 6 & 63 | 128;
                }
                i[r++] = 63 & c | 128;
            } else i[r++] = c;
        }
        return i.slice ? i.slice(0, r) : i.subarray(0, r);
    };
    function c() {
        this.encoding = "utf-8";
    }
    c.prototype.encode = function(e, t) {
        return r(t && t.stream, "encode", "stream"), i(e);
    };
    var a = !o && "function" == typeof Blob && "function" == typeof URL && "function" == typeof URL.createObjectURL, s = [
        "utf-8",
        "utf8",
        "unicode-1-1-utf-8"
    ], u = t;
    o ? u = function(e, t) {
        return (e instanceof $c5aa5a6035c47210$require$Buffer ? e : $c5aa5a6035c47210$require$Buffer.from(e.buffer, e.byteOffset, e.byteLength)).toString(t);
    } : a && (u = function(e) {
        try {
            return function(e) {
                var t;
                try {
                    var n = new Blob([
                        e
                    ], {
                        type: "text/plain;charset=UTF-8"
                    });
                    t = URL.createObjectURL(n);
                    var r = new XMLHttpRequest;
                    return r.open("GET", t, !1), r.send(), r.responseText;
                } finally{
                    t && URL.revokeObjectURL(t);
                }
            }(e);
        } catch (n) {
            return t(e);
        }
    });
    var l = "construct 'TextDecoder'", f = "".concat(n, " ").concat(l, ": the ");
    function d(e, t) {
        if (r(t && t.fatal, l, "fatal"), e = e || "utf-8", !(o ? $c5aa5a6035c47210$require$Buffer.isEncoding(e) : -1 !== s.indexOf(e.toLowerCase()))) throw new RangeError("".concat(f, " encoding label provided ('").concat(e, "') is invalid."));
        this.encoding = e, this.fatal = !1, this.ignoreBOM = !1;
    }
    d.prototype.decode = function(e, t) {
        var n;
        return r(t && t.stream, "decode", "stream"), n = e instanceof Uint8Array ? e : e.buffer instanceof ArrayBuffer ? new Uint8Array(e.buffer) : new Uint8Array(e), u(n, this.encoding);
    }, e.TextEncoder = e.TextEncoder || c, e.TextDecoder = e.TextDecoder || d;
}("undefined" != typeof window ? window : $c5aa5a6035c47210$var$s), function() {
    function e(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function t(e, t) {
        for(var n = 0; n < t.length; n++){
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
    }
    function n(e, n, r) {
        return n && t(e.prototype, n), r && t(e, r), e;
    }
    function r(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
            constructor: {
                value: e,
                writable: !0,
                configurable: !0
            }
        }), t && i(e, t);
    }
    function o(e) {
        return o = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e);
        }, o(e);
    }
    function i(e, t) {
        return i = Object.setPrototypeOf || function(e, t) {
            return e.__proto__ = t, e;
        }, i(e, t);
    }
    function c() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
        } catch (e) {
            return !1;
        }
    }
    function a(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
    }
    function u(e, t) {
        return !t || "object" != typeof t && "function" != typeof t ? a(e) : t;
    }
    function l(e) {
        var t = c();
        return function() {
            var n, r = o(e);
            if (t) {
                var i = o(this).constructor;
                n = Reflect.construct(r, arguments, i);
            } else n = r.apply(this, arguments);
            return u(this, n);
        };
    }
    function f(e, t) {
        for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = o(e)););
        return e;
    }
    function d(e, t, n) {
        return d = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e, t, n) {
            var r = f(e, t);
            if (r) {
                var o = Object.getOwnPropertyDescriptor(r, t);
                return o.get ? o.get.call(n) : o.value;
            }
        }, d(e, t, n || e);
    }
    var h = function() {
        function t() {
            e(this, t), Object.defineProperty(this, "listeners", {
                value: {},
                writable: !0,
                configurable: !0
            });
        }
        return n(t, [
            {
                key: "addEventListener",
                value: function(e, t, n) {
                    e in this.listeners || (this.listeners[e] = []), this.listeners[e].push({
                        callback: t,
                        options: n
                    });
                }
            },
            {
                key: "removeEventListener",
                value: function(e, t) {
                    if (e in this.listeners) {
                        for(var n = this.listeners[e], r = 0, o = n.length; r < o; r++)if (n[r].callback === t) return void n.splice(r, 1);
                    }
                }
            },
            {
                key: "dispatchEvent",
                value: function(e) {
                    if (e.type in this.listeners) {
                        for(var t = this.listeners[e.type].slice(), n = 0, r = t.length; n < r; n++){
                            var o = t[n];
                            try {
                                o.callback.call(this, e);
                            } catch (e) {
                                Promise.resolve().then(function() {
                                    throw e;
                                });
                            }
                            o.options && o.options.once && this.removeEventListener(e.type, o.callback);
                        }
                        return !e.defaultPrevented;
                    }
                }
            }
        ]), t;
    }(), p = function(t) {
        r(c, t);
        var i = l(c);
        function c() {
            var t;
            return e(this, c), (t = i.call(this)).listeners || h.call(a(t)), Object.defineProperty(a(t), "aborted", {
                value: !1,
                writable: !0,
                configurable: !0
            }), Object.defineProperty(a(t), "onabort", {
                value: null,
                writable: !0,
                configurable: !0
            }), t;
        }
        return n(c, [
            {
                key: "toString",
                value: function() {
                    return "[object AbortSignal]";
                }
            },
            {
                key: "dispatchEvent",
                value: function(e) {
                    "abort" === e.type && (this.aborted = !0, "function" == typeof this.onabort && this.onabort.call(this, e)), d(o(c.prototype), "dispatchEvent", this).call(this, e);
                }
            }
        ]), c;
    }(h), y = function() {
        function t() {
            e(this, t), Object.defineProperty(this, "signal", {
                value: new p,
                writable: !0,
                configurable: !0
            });
        }
        return n(t, [
            {
                key: "abort",
                value: function() {
                    var e;
                    try {
                        e = new Event("abort");
                    } catch (t) {
                        "undefined" != typeof document ? document.createEvent ? (e = document.createEvent("Event")).initEvent("abort", !1, !1) : (e = document.createEventObject()).type = "abort" : e = {
                            type: "abort",
                            bubbles: !1,
                            cancelable: !1
                        };
                    }
                    this.signal.dispatchEvent(e);
                }
            },
            {
                key: "toString",
                value: function() {
                    return "[object AbortController]";
                }
            }
        ]), t;
    }();
    function v(e) {
        return e.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL ? (console.log("__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL=true is set, will force install polyfill"), !0) : "function" == typeof e.Request && !e.Request.prototype.hasOwnProperty("signal") || !e.AbortController;
    }
    "undefined" != typeof Symbol && Symbol.toStringTag && (y.prototype[Symbol.toStringTag] = "AbortController", p.prototype[Symbol.toStringTag] = "AbortSignal"), function(e) {
        v(e) && (e.AbortController = y, e.AbortSignal = p);
    }("undefined" != typeof self ? self : $c5aa5a6035c47210$var$s);
}();
var $c5aa5a6035c47210$var$Ac = $c5aa5a6035c47210$var$l(function(e, t) {
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = function() {
        function e() {
            var e = this;
            this.locked = new Map, this.addToLocked = function(t, n) {
                var r = e.locked.get(t);
                void 0 === r ? void 0 === n ? e.locked.set(t, []) : e.locked.set(t, [
                    n
                ]) : void 0 !== n && (r.unshift(n), e.locked.set(t, r));
            }, this.isLocked = function(t) {
                return e.locked.has(t);
            }, this.lock = function(t) {
                return new Promise(function(n, r) {
                    e.isLocked(t) ? e.addToLocked(t, n) : (e.addToLocked(t), n());
                });
            }, this.unlock = function(t) {
                var n = e.locked.get(t);
                if (void 0 !== n && 0 !== n.length) {
                    var r = n.pop();
                    e.locked.set(t, n), void 0 !== r && setTimeout(r, 0);
                } else e.locked.delete(t);
            };
        }
        return e.getInstance = function() {
            return void 0 === e.instance && (e.instance = new e), e.instance;
        }, e;
    }();
    t.default = function() {
        return n.getInstance();
    };
});
$c5aa5a6035c47210$var$u($c5aa5a6035c47210$var$Ac);
var $c5aa5a6035c47210$var$Pc = $c5aa5a6035c47210$var$l(function(e, t) {
    var n = $c5aa5a6035c47210$var$s && $c5aa5a6035c47210$var$s.__awaiter || function(e, t, n, r) {
        return new (n || (n = Promise))(function(o, i) {
            function c(e) {
                try {
                    s(r.next(e));
                } catch (e) {
                    i(e);
                }
            }
            function a(e) {
                try {
                    s(r.throw(e));
                } catch (e) {
                    i(e);
                }
            }
            function s(e) {
                e.done ? o(e.value) : new n(function(t) {
                    t(e.value);
                }).then(c, a);
            }
            s((r = r.apply(e, t || [])).next());
        });
    }, r = $c5aa5a6035c47210$var$s && $c5aa5a6035c47210$var$s.__generator || function(e, t) {
        var n, r, o, i, c = {
            label: 0,
            sent: function() {
                if (1 & o[0]) throw o[1];
                return o[1];
            },
            trys: [],
            ops: []
        };
        return i = {
            next: a(0),
            throw: a(1),
            return: a(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
            return this;
        }), i;
        function a(i) {
            return function(a) {
                return function(i) {
                    if (n) throw new TypeError("Generator is already executing.");
                    for(; c;)try {
                        if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                        switch(r = 0, o && (i = [
                            2 & i[0],
                            o.value
                        ]), i[0]){
                            case 0:
                            case 1:
                                o = i;
                                break;
                            case 4:
                                return c.label++, {
                                    value: i[1],
                                    done: !1
                                };
                            case 5:
                                c.label++, r = i[1], i = [
                                    0
                                ];
                                continue;
                            case 7:
                                i = c.ops.pop(), c.trys.pop();
                                continue;
                            default:
                                if (!(o = c.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                    c = 0;
                                    continue;
                                }
                                if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                                    c.label = i[1];
                                    break;
                                }
                                if (6 === i[0] && c.label < o[1]) {
                                    c.label = o[1], o = i;
                                    break;
                                }
                                if (o && c.label < o[2]) {
                                    c.label = o[2], c.ops.push(i);
                                    break;
                                }
                                o[2] && c.ops.pop(), c.trys.pop();
                                continue;
                        }
                        i = t.call(e, c);
                    } catch (e) {
                        i = [
                            6,
                            e
                        ], r = 0;
                    } finally{
                        n = o = 0;
                    }
                    if (5 & i[0]) throw i[1];
                    return {
                        value: i[0] ? i[1] : void 0,
                        done: !0
                    };
                }([
                    i,
                    a
                ]);
            };
        }
    };
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var o = "browser-tabs-lock-key";
    function i(e) {
        return new Promise(function(t) {
            return setTimeout(t, e);
        });
    }
    function c(e) {
        for(var t = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz", n = "", r = 0; r < e; r++)n += t[Math.floor(Math.random() * t.length)];
        return n;
    }
    var a = function() {
        function e() {
            this.acquiredIatSet = new Set, this.id = Date.now().toString() + c(15), this.acquireLock = this.acquireLock.bind(this), this.releaseLock = this.releaseLock.bind(this), this.releaseLock__private__ = this.releaseLock__private__.bind(this), this.waitForSomethingToChange = this.waitForSomethingToChange.bind(this), this.refreshLockWhileAcquired = this.refreshLockWhileAcquired.bind(this), void 0 === e.waiters && (e.waiters = []);
        }
        return e.prototype.acquireLock = function(t, a) {
            return void 0 === a && (a = 5e3), n(this, void 0, void 0, function() {
                var n, s, u, l, f, d;
                return r(this, function(r) {
                    switch(r.label){
                        case 0:
                            n = Date.now() + c(4), s = Date.now() + a, u = o + "-" + t, l = window.localStorage, r.label = 1;
                        case 1:
                            return Date.now() < s ? [
                                4,
                                i(30)
                            ] : [
                                3,
                                8
                            ];
                        case 2:
                            return r.sent(), null !== l.getItem(u) ? [
                                3,
                                5
                            ] : (f = this.id + "-" + t + "-" + n, [
                                4,
                                i(Math.floor(25 * Math.random()))
                            ]);
                        case 3:
                            return r.sent(), l.setItem(u, JSON.stringify({
                                id: this.id,
                                iat: n,
                                timeoutKey: f,
                                timeAcquired: Date.now(),
                                timeRefreshed: Date.now()
                            })), [
                                4,
                                i(30)
                            ];
                        case 4:
                            return r.sent(), null !== (d = l.getItem(u)) && (d = JSON.parse(d)).id === this.id && d.iat === n ? (this.acquiredIatSet.add(n), this.refreshLockWhileAcquired(u, n), [
                                2,
                                !0
                            ]) : [
                                3,
                                7
                            ];
                        case 5:
                            return e.lockCorrector(), [
                                4,
                                this.waitForSomethingToChange(s)
                            ];
                        case 6:
                            r.sent(), r.label = 7;
                        case 7:
                            return n = Date.now() + c(4), [
                                3,
                                1
                            ];
                        case 8:
                            return [
                                2,
                                !1
                            ];
                    }
                });
            });
        }, e.prototype.refreshLockWhileAcquired = function(e, t) {
            return n(this, void 0, void 0, function() {
                var o = this;
                return r(this, function(i) {
                    return setTimeout(function() {
                        return n(o, void 0, void 0, function() {
                            var n, o;
                            return r(this, function(r) {
                                switch(r.label){
                                    case 0:
                                        return [
                                            4,
                                            $c5aa5a6035c47210$var$Ac.default().lock(t)
                                        ];
                                    case 1:
                                        return r.sent(), this.acquiredIatSet.has(t) ? (n = window.localStorage, null === (o = n.getItem(e)) ? ($c5aa5a6035c47210$var$Ac.default().unlock(t), [
                                            2
                                        ]) : ((o = JSON.parse(o)).timeRefreshed = Date.now(), n.setItem(e, JSON.stringify(o)), $c5aa5a6035c47210$var$Ac.default().unlock(t), this.refreshLockWhileAcquired(e, t), [
                                            2
                                        ])) : ($c5aa5a6035c47210$var$Ac.default().unlock(t), [
                                            2
                                        ]);
                                }
                            });
                        });
                    }, 1e3), [
                        2
                    ];
                });
            });
        }, e.prototype.waitForSomethingToChange = function(t) {
            return n(this, void 0, void 0, function() {
                return r(this, function(n) {
                    switch(n.label){
                        case 0:
                            return [
                                4,
                                new Promise(function(n) {
                                    var r = !1, o = Date.now(), i = !1;
                                    function c() {
                                        if (i || (window.removeEventListener("storage", c), e.removeFromWaiting(c), clearTimeout(a), i = !0), !r) {
                                            r = !0;
                                            var t = 50 - (Date.now() - o);
                                            t > 0 ? setTimeout(n, t) : n();
                                        }
                                    }
                                    window.addEventListener("storage", c), e.addToWaiting(c);
                                    var a = setTimeout(c, Math.max(0, t - Date.now()));
                                })
                            ];
                        case 1:
                            return n.sent(), [
                                2
                            ];
                    }
                });
            });
        }, e.addToWaiting = function(t) {
            this.removeFromWaiting(t), void 0 !== e.waiters && e.waiters.push(t);
        }, e.removeFromWaiting = function(t) {
            void 0 !== e.waiters && (e.waiters = e.waiters.filter(function(e) {
                return e !== t;
            }));
        }, e.notifyWaiters = function() {
            void 0 !== e.waiters && e.waiters.slice().forEach(function(e) {
                return e();
            });
        }, e.prototype.releaseLock = function(e) {
            return n(this, void 0, void 0, function() {
                return r(this, function(t) {
                    switch(t.label){
                        case 0:
                            return [
                                4,
                                this.releaseLock__private__(e)
                            ];
                        case 1:
                            return [
                                2,
                                t.sent()
                            ];
                    }
                });
            });
        }, e.prototype.releaseLock__private__ = function(t) {
            return n(this, void 0, void 0, function() {
                var n, i, c;
                return r(this, function(r) {
                    switch(r.label){
                        case 0:
                            return n = window.localStorage, i = o + "-" + t, null === (c = n.getItem(i)) ? [
                                2
                            ] : (c = JSON.parse(c)).id !== this.id ? [
                                3,
                                2
                            ] : [
                                4,
                                $c5aa5a6035c47210$var$Ac.default().lock(c.iat)
                            ];
                        case 1:
                            r.sent(), this.acquiredIatSet.delete(c.iat), n.removeItem(i), $c5aa5a6035c47210$var$Ac.default().unlock(c.iat), e.notifyWaiters(), r.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
        }, e.lockCorrector = function() {
            for(var t = Date.now() - 5e3, n = window.localStorage, r = Object.keys(n), i = !1, c = 0; c < r.length; c++){
                var a = r[c];
                if (a.includes(o)) {
                    var s = n.getItem(a);
                    null !== s && (void 0 === (s = JSON.parse(s)).timeRefreshed && s.timeAcquired < t || void 0 !== s.timeRefreshed && s.timeRefreshed < t) && (n.removeItem(a), i = !0);
                }
            }
            i && e.notifyWaiters();
        }, e.waiters = void 0, e;
    }();
    t.default = a;
}), $c5aa5a6035c47210$var$Xc = $c5aa5a6035c47210$var$u($c5aa5a6035c47210$var$Pc), $c5aa5a6035c47210$var$Fc = {
    timeoutInSeconds: 60
}, $c5aa5a6035c47210$var$Kc = [
    "login_required",
    "consent_required",
    "interaction_required",
    "account_selection_required",
    "access_denied"
], $c5aa5a6035c47210$var$Nc = {
    name: "auth0-spa-js",
    version: "1.22.6"
}, $c5aa5a6035c47210$var$Uc = function() {
    return Date.now();
}, $c5aa5a6035c47210$export$7d465be8efa67280 = function(e) {
    function n(t, r) {
        var o = e.call(this, r) || this;
        return o.error = t, o.error_description = r, Object.setPrototypeOf(o, n.prototype), o;
    }
    return $c5aa5a6035c47210$var$t(n, e), n.fromPayload = function(e) {
        return new n(e.error, e.error_description);
    }, n;
}(Error), $c5aa5a6035c47210$export$cf0c46b07324e9c5 = function(e) {
    function n(t, r, o, i) {
        void 0 === i && (i = null);
        var c = e.call(this, t, r) || this;
        return c.state = o, c.appState = i, Object.setPrototypeOf(c, n.prototype), c;
    }
    return $c5aa5a6035c47210$var$t(n, e), n;
}($c5aa5a6035c47210$export$7d465be8efa67280), $c5aa5a6035c47210$export$66d311bf29d5c89c = function(e) {
    function n() {
        var t = e.call(this, "timeout", "Timeout") || this;
        return Object.setPrototypeOf(t, n.prototype), t;
    }
    return $c5aa5a6035c47210$var$t(n, e), n;
}($c5aa5a6035c47210$export$7d465be8efa67280), $c5aa5a6035c47210$export$ebbb83fe03f719a4 = function(e) {
    function n(t) {
        var r = e.call(this) || this;
        return r.popup = t, Object.setPrototypeOf(r, n.prototype), r;
    }
    return $c5aa5a6035c47210$var$t(n, e), n;
}($c5aa5a6035c47210$export$66d311bf29d5c89c), $c5aa5a6035c47210$export$f1f681f0fb26bb55 = function(e) {
    function n(t) {
        var r = e.call(this, "cancelled", "Popup closed") || this;
        return r.popup = t, Object.setPrototypeOf(r, n.prototype), r;
    }
    return $c5aa5a6035c47210$var$t(n, e), n;
}($c5aa5a6035c47210$export$7d465be8efa67280), $c5aa5a6035c47210$export$c59494f4dae44ada = function(e) {
    function n(t, r, o) {
        var i = e.call(this, t, r) || this;
        return i.mfa_token = o, Object.setPrototypeOf(i, n.prototype), i;
    }
    return $c5aa5a6035c47210$var$t(n, e), n;
}($c5aa5a6035c47210$export$7d465be8efa67280), $c5aa5a6035c47210$var$Mc = function(e) {
    function n(t, r) {
        var o = e.call(this, "missing_refresh_token", "Missing Refresh Token (audience: '".concat($c5aa5a6035c47210$var$ia(t, [
            "default"
        ]), "', scope: '").concat($c5aa5a6035c47210$var$ia(r), "')")) || this;
        return o.audience = t, o.scope = r, Object.setPrototypeOf(o, n.prototype), o;
    }
    return $c5aa5a6035c47210$var$t(n, e), n;
}($c5aa5a6035c47210$export$7d465be8efa67280), $c5aa5a6035c47210$var$Bc = function(e) {
    return new Promise(function(t, n) {
        var r, o = setInterval(function() {
            e.popup && e.popup.closed && (clearInterval(o), clearTimeout(i), window.removeEventListener("message", r, !1), n(new $c5aa5a6035c47210$export$f1f681f0fb26bb55(e.popup)));
        }, 1e3), i = setTimeout(function() {
            clearInterval(o), n(new $c5aa5a6035c47210$export$ebbb83fe03f719a4(e.popup)), window.removeEventListener("message", r, !1);
        }, 1e3 * (e.timeoutInSeconds || 60));
        r = function(c) {
            if (c.data && "authorization_response" === c.data.type) {
                if (clearTimeout(i), clearInterval(o), window.removeEventListener("message", r, !1), e.popup.close(), c.data.response.error) return n($c5aa5a6035c47210$export$7d465be8efa67280.fromPayload(c.data.response));
                t(c.data.response);
            }
        }, window.addEventListener("message", r);
    });
}, $c5aa5a6035c47210$var$Qc = function() {
    return window.crypto || window.msCrypto;
}, $c5aa5a6035c47210$var$qc = function() {
    var e = $c5aa5a6035c47210$var$Qc();
    return e.subtle || e.webkitSubtle;
}, $c5aa5a6035c47210$var$$c = function() {
    var e = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.", t = "";
    return Array.from($c5aa5a6035c47210$var$Qc().getRandomValues(new Uint8Array(43))).forEach(function(n) {
        return t += e[n % e.length];
    }), t;
}, $c5aa5a6035c47210$var$ea = function(e) {
    return btoa(e);
}, $c5aa5a6035c47210$var$ta = function(e) {
    return Object.keys(e).filter(function(t) {
        return void 0 !== e[t];
    }).map(function(t) {
        return encodeURIComponent(t) + "=" + encodeURIComponent(e[t]);
    }).join("&");
}, $c5aa5a6035c47210$var$na = function(e) {
    return $c5aa5a6035c47210$var$o(void 0, void 0, void 0, function() {
        var t;
        return $c5aa5a6035c47210$var$i(this, function(n) {
            switch(n.label){
                case 0:
                    return t = $c5aa5a6035c47210$var$qc().digest({
                        name: "SHA-256"
                    }, (new TextEncoder).encode(e)), window.msCrypto ? [
                        2,
                        new Promise(function(e, n) {
                            t.oncomplete = function(t) {
                                e(t.target.result);
                            }, t.onerror = function(e) {
                                n(e.error);
                            }, t.onabort = function() {
                                n("The digest operation was aborted");
                            };
                        })
                    ] : [
                        4,
                        t
                    ];
                case 1:
                    return [
                        2,
                        n.sent()
                    ];
            }
        });
    });
}, $c5aa5a6035c47210$var$ra = function(e) {
    return function(e) {
        return decodeURIComponent(atob(e).split("").map(function(e) {
            return "%" + ("00" + e.charCodeAt(0).toString(16)).slice(-2);
        }).join(""));
    }(e.replace(/_/g, "/").replace(/-/g, "+"));
}, $c5aa5a6035c47210$var$oa = function(e) {
    var t = new Uint8Array(e);
    return function(e) {
        var t = {
            "+": "-",
            "/": "_",
            "=": ""
        };
        return e.replace(/[+/=]/g, function(e) {
            return t[e];
        });
    }(window.btoa(String.fromCharCode.apply(String, $c5aa5a6035c47210$var$a([], $c5aa5a6035c47210$var$c(Array.from(t)), !1))));
};
function $c5aa5a6035c47210$var$ia(e, t) {
    return void 0 === t && (t = []), e && !t.includes(e) ? e : "";
}
var $c5aa5a6035c47210$var$ca = function(e, t) {
    return $c5aa5a6035c47210$var$o(void 0, void 0, void 0, function() {
        var n, r;
        return $c5aa5a6035c47210$var$i(this, function(o) {
            switch(o.label){
                case 0:
                    return [
                        4,
                        (i = e, c = t, c = c || {}, new Promise(function(e, t) {
                            var n = new XMLHttpRequest, r = [], o = [], a = {}, s = function() {
                                return {
                                    ok: 2 == (n.status / 100 | 0),
                                    statusText: n.statusText,
                                    status: n.status,
                                    url: n.responseURL,
                                    text: function() {
                                        return Promise.resolve(n.responseText);
                                    },
                                    json: function() {
                                        return Promise.resolve(n.responseText).then(JSON.parse);
                                    },
                                    blob: function() {
                                        return Promise.resolve(new Blob([
                                            n.response
                                        ]));
                                    },
                                    clone: s,
                                    headers: {
                                        keys: function() {
                                            return r;
                                        },
                                        entries: function() {
                                            return o;
                                        },
                                        get: function(e) {
                                            return a[e.toLowerCase()];
                                        },
                                        has: function(e) {
                                            return e.toLowerCase() in a;
                                        }
                                    }
                                };
                            };
                            for(var u in n.open(c.method || "get", i, !0), n.onload = function() {
                                n.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(e, t, n) {
                                    r.push(t = t.toLowerCase()), o.push([
                                        t,
                                        n
                                    ]), a[t] = a[t] ? a[t] + "," + n : n;
                                }), e(s());
                            }, n.onerror = t, n.withCredentials = "include" == c.credentials, c.headers)n.setRequestHeader(u, c.headers[u]);
                            n.send(c.body || null);
                        }))
                    ];
                case 1:
                    return n = o.sent(), r = {
                        ok: n.ok
                    }, [
                        4,
                        n.json()
                    ];
                case 2:
                    return [
                        2,
                        (r.json = o.sent(), r)
                    ];
            }
            var i, c;
        });
    });
}, $c5aa5a6035c47210$var$aa = function(e, t, n) {
    return $c5aa5a6035c47210$var$o(void 0, void 0, void 0, function() {
        var r, o;
        return $c5aa5a6035c47210$var$i(this, function(i) {
            return r = new AbortController, t.signal = r.signal, [
                2,
                Promise.race([
                    $c5aa5a6035c47210$var$ca(e, t),
                    new Promise(function(e, t) {
                        o = setTimeout(function() {
                            r.abort(), t(new Error("Timeout when executing 'fetch'"));
                        }, n);
                    })
                ]).finally(function() {
                    clearTimeout(o);
                })
            ];
        });
    });
}, $c5aa5a6035c47210$var$sa = function(e, t, n, r, c, a, s) {
    return $c5aa5a6035c47210$var$o(void 0, void 0, void 0, function() {
        return $c5aa5a6035c47210$var$i(this, function(o) {
            var i, u;
            return [
                2,
                (i = {
                    auth: {
                        audience: t,
                        scope: n
                    },
                    timeout: c,
                    fetchUrl: e,
                    fetchOptions: r,
                    useFormData: s
                }, u = a, new Promise(function(e, t) {
                    var n = new MessageChannel;
                    n.port1.onmessage = function(r) {
                        r.data.error ? t(new Error(r.data.error)) : e(r.data), n.port1.close();
                    }, u.postMessage(i, [
                        n.port2
                    ]);
                }))
            ];
        });
    });
}, $c5aa5a6035c47210$var$ua = function(e, t, n, r, c, a, s) {
    return void 0 === s && (s = 1e4), $c5aa5a6035c47210$var$o(void 0, void 0, void 0, function() {
        return $c5aa5a6035c47210$var$i(this, function(o) {
            return c ? [
                2,
                $c5aa5a6035c47210$var$sa(e, t, n, r, s, c, a)
            ] : [
                2,
                $c5aa5a6035c47210$var$aa(e, r, s)
            ];
        });
    });
};
function $c5aa5a6035c47210$var$la(e, t, n, c, a, s, u) {
    return $c5aa5a6035c47210$var$o(this, void 0, void 0, function() {
        var o, l, f, d, h, p, y, v, m;
        return $c5aa5a6035c47210$var$i(this, function(i) {
            switch(i.label){
                case 0:
                    o = null, f = 0, i.label = 1;
                case 1:
                    if (!(f < 3)) return [
                        3,
                        6
                    ];
                    i.label = 2;
                case 2:
                    return i.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]), [
                        4,
                        $c5aa5a6035c47210$var$ua(e, n, c, a, s, u, t)
                    ];
                case 3:
                    return l = i.sent(), o = null, [
                        3,
                        6
                    ];
                case 4:
                    return d = i.sent(), o = d, [
                        3,
                        5
                    ];
                case 5:
                    return f++, [
                        3,
                        1
                    ];
                case 6:
                    if (o) throw o.message = o.message || "Failed to fetch", o;
                    if (h = l.json, p = h.error, y = h.error_description, v = $c5aa5a6035c47210$var$r(h, [
                        "error",
                        "error_description"
                    ]), !l.ok) {
                        if (m = y || "HTTP error. Unable to fetch ".concat(e), "mfa_required" === p) throw new $c5aa5a6035c47210$export$c59494f4dae44ada(p, m, v.mfa_token);
                        throw new $c5aa5a6035c47210$export$7d465be8efa67280(p || "request_error", m);
                    }
                    return [
                        2,
                        v
                    ];
            }
        });
    });
}
function $c5aa5a6035c47210$var$fa(e, t) {
    var n = e.baseUrl, c = e.timeout, a = e.audience, s = e.scope, u = e.auth0Client, l = e.useFormData, f = $c5aa5a6035c47210$var$r(e, [
        "baseUrl",
        "timeout",
        "audience",
        "scope",
        "auth0Client",
        "useFormData"
    ]);
    return $c5aa5a6035c47210$var$o(this, void 0, void 0, function() {
        var e;
        return $c5aa5a6035c47210$var$i(this, function(r) {
            switch(r.label){
                case 0:
                    return e = l ? $c5aa5a6035c47210$var$ta(f) : JSON.stringify(f), [
                        4,
                        $c5aa5a6035c47210$var$la("".concat(n, "/oauth/token"), c, a || "default", s, {
                            method: "POST",
                            body: e,
                            headers: {
                                "Content-Type": l ? "application/x-www-form-urlencoded" : "application/json",
                                "Auth0-Client": btoa(JSON.stringify(u || $c5aa5a6035c47210$var$Nc))
                            }
                        }, t, l)
                    ];
                case 1:
                    return [
                        2,
                        r.sent()
                    ];
            }
        });
    });
}
var $c5aa5a6035c47210$var$da = function(e) {
    return Array.from(new Set(e));
}, $c5aa5a6035c47210$var$ha = function() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    return $c5aa5a6035c47210$var$da(e.join(" ").trim().split(/\s+/)).join(" ");
}, $c5aa5a6035c47210$var$pa = function() {
    function e(e, t) {
        void 0 === t && (t = "@@auth0spajs@@"), this.prefix = t, this.client_id = e.client_id, this.scope = e.scope, this.audience = e.audience;
    }
    return e.prototype.toKey = function() {
        return "".concat(this.prefix, "::").concat(this.client_id, "::").concat(this.audience, "::").concat(this.scope);
    }, e.fromKey = function(t) {
        var n = $c5aa5a6035c47210$var$c(t.split("::"), 4), r = n[0], o = n[1], i = n[2];
        return new e({
            client_id: o,
            scope: n[3],
            audience: i
        }, r);
    }, e.fromCacheEntry = function(t) {
        return new e({
            scope: t.scope,
            audience: t.audience,
            client_id: t.client_id
        });
    }, e;
}(), $c5aa5a6035c47210$export$40ef2cb682e70737 = function() {
    function e() {}
    return e.prototype.set = function(e, t) {
        localStorage.setItem(e, JSON.stringify(t));
    }, e.prototype.get = function(e) {
        var t = window.localStorage.getItem(e);
        if (t) try {
            return JSON.parse(t);
        } catch (e) {
            return;
        }
    }, e.prototype.remove = function(e) {
        localStorage.removeItem(e);
    }, e.prototype.allKeys = function() {
        return Object.keys(window.localStorage).filter(function(e) {
            return e.startsWith("@@auth0spajs@@");
        });
    }, e;
}(), $c5aa5a6035c47210$export$467265324939f47f = function() {
    var e;
    this.enclosedCache = (e = {}, {
        set: function(t, n) {
            e[t] = n;
        },
        get: function(t) {
            var n = e[t];
            if (n) return n;
        },
        remove: function(t) {
            delete e[t];
        },
        allKeys: function() {
            return Object.keys(e);
        }
    });
}, $c5aa5a6035c47210$var$ma = function() {
    function e(e, t, n) {
        this.cache = e, this.keyManifest = t, this.nowProvider = n, this.nowProvider = this.nowProvider || $c5aa5a6035c47210$var$Uc;
    }
    return e.prototype.get = function(e, t) {
        var n;
        return void 0 === t && (t = 0), $c5aa5a6035c47210$var$o(this, void 0, void 0, function() {
            var r, o, c, a, s;
            return $c5aa5a6035c47210$var$i(this, function(i) {
                switch(i.label){
                    case 0:
                        return [
                            4,
                            this.cache.get(e.toKey())
                        ];
                    case 1:
                        return (r = i.sent()) ? [
                            3,
                            4
                        ] : [
                            4,
                            this.getCacheKeys()
                        ];
                    case 2:
                        return (o = i.sent()) ? (c = this.matchExistingCacheKey(e, o)) ? [
                            4,
                            this.cache.get(c)
                        ] : [
                            3,
                            4
                        ] : [
                            2
                        ];
                    case 3:
                        r = i.sent(), i.label = 4;
                    case 4:
                        return r ? [
                            4,
                            this.nowProvider()
                        ] : [
                            2
                        ];
                    case 5:
                        return a = i.sent(), s = Math.floor(a / 1e3), r.expiresAt - t < s ? r.body.refresh_token ? (r.body = {
                            refresh_token: r.body.refresh_token
                        }, [
                            4,
                            this.cache.set(e.toKey(), r)
                        ]) : [
                            3,
                            7
                        ] : [
                            3,
                            10
                        ];
                    case 6:
                        return i.sent(), [
                            2,
                            r.body
                        ];
                    case 7:
                        return [
                            4,
                            this.cache.remove(e.toKey())
                        ];
                    case 8:
                        return i.sent(), [
                            4,
                            null === (n = this.keyManifest) || void 0 === n ? void 0 : n.remove(e.toKey())
                        ];
                    case 9:
                        return i.sent(), [
                            2
                        ];
                    case 10:
                        return [
                            2,
                            r.body
                        ];
                }
            });
        });
    }, e.prototype.set = function(e) {
        var t;
        return $c5aa5a6035c47210$var$o(this, void 0, void 0, function() {
            var n, r;
            return $c5aa5a6035c47210$var$i(this, function(o) {
                switch(o.label){
                    case 0:
                        return n = new $c5aa5a6035c47210$var$pa({
                            client_id: e.client_id,
                            scope: e.scope,
                            audience: e.audience
                        }), [
                            4,
                            this.wrapCacheEntry(e)
                        ];
                    case 1:
                        return r = o.sent(), [
                            4,
                            this.cache.set(n.toKey(), r)
                        ];
                    case 2:
                        return o.sent(), [
                            4,
                            null === (t = this.keyManifest) || void 0 === t ? void 0 : t.add(n.toKey())
                        ];
                    case 3:
                        return o.sent(), [
                            2
                        ];
                }
            });
        });
    }, e.prototype.clear = function(e) {
        var t;
        return $c5aa5a6035c47210$var$o(this, void 0, void 0, function() {
            var n, r = this;
            return $c5aa5a6035c47210$var$i(this, function(c) {
                switch(c.label){
                    case 0:
                        return [
                            4,
                            this.getCacheKeys()
                        ];
                    case 1:
                        return (n = c.sent()) ? [
                            4,
                            n.filter(function(t) {
                                return !e || t.includes(e);
                            }).reduce(function(e, t) {
                                return $c5aa5a6035c47210$var$o(r, void 0, void 0, function() {
                                    return $c5aa5a6035c47210$var$i(this, function(n) {
                                        switch(n.label){
                                            case 0:
                                                return [
                                                    4,
                                                    e
                                                ];
                                            case 1:
                                                return n.sent(), [
                                                    4,
                                                    this.cache.remove(t)
                                                ];
                                            case 2:
                                                return n.sent(), [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            }, Promise.resolve())
                        ] : [
                            2
                        ];
                    case 2:
                        return c.sent(), [
                            4,
                            null === (t = this.keyManifest) || void 0 === t ? void 0 : t.clear()
                        ];
                    case 3:
                        return c.sent(), [
                            2
                        ];
                }
            });
        });
    }, e.prototype.clearSync = function(e) {
        var t = this, n = this.cache.allKeys();
        n && n.filter(function(t) {
            return !e || t.includes(e);
        }).forEach(function(e) {
            t.cache.remove(e);
        });
    }, e.prototype.wrapCacheEntry = function(e) {
        return $c5aa5a6035c47210$var$o(this, void 0, void 0, function() {
            var t, n, r;
            return $c5aa5a6035c47210$var$i(this, function(o) {
                switch(o.label){
                    case 0:
                        return [
                            4,
                            this.nowProvider()
                        ];
                    case 1:
                        return t = o.sent(), n = Math.floor(t / 1e3) + e.expires_in, r = Math.min(n, e.decodedToken.claims.exp), [
                            2,
                            {
                                body: e,
                                expiresAt: r
                            }
                        ];
                }
            });
        });
    }, e.prototype.getCacheKeys = function() {
        var e;
        return $c5aa5a6035c47210$var$o(this, void 0, void 0, function() {
            var t;
            return $c5aa5a6035c47210$var$i(this, function(n) {
                switch(n.label){
                    case 0:
                        return this.keyManifest ? [
                            4,
                            this.keyManifest.get()
                        ] : [
                            3,
                            2
                        ];
                    case 1:
                        return t = null === (e = n.sent()) || void 0 === e ? void 0 : e.keys, [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            this.cache.allKeys()
                        ];
                    case 3:
                        t = n.sent(), n.label = 4;
                    case 4:
                        return [
                            2,
                            t
                        ];
                }
            });
        });
    }, e.prototype.matchExistingCacheKey = function(e, t) {
        return t.filter(function(t) {
            var n = $c5aa5a6035c47210$var$pa.fromKey(t), r = new Set(n.scope && n.scope.split(" ")), o = e.scope.split(" "), i = n.scope && o.reduce(function(e, t) {
                return e && r.has(t);
            }, !0);
            return "@@auth0spajs@@" === n.prefix && n.client_id === e.client_id && n.audience === e.audience && i;
        })[0];
    }, e;
}(), $c5aa5a6035c47210$var$ba = function() {
    function e(e, t) {
        this.storage = e, this.clientId = t, this.storageKey = "".concat("a0.spajs.txs", ".").concat(this.clientId), this.transaction = this.storage.get(this.storageKey);
    }
    return e.prototype.create = function(e) {
        this.transaction = e, this.storage.save(this.storageKey, e, {
            daysUntilExpire: 1
        });
    }, e.prototype.get = function() {
        return this.transaction;
    }, e.prototype.remove = function() {
        delete this.transaction, this.storage.remove(this.storageKey);
    }, e;
}(), $c5aa5a6035c47210$var$ga = function(e) {
    return "number" == typeof e;
}, $c5aa5a6035c47210$var$wa = [
    "iss",
    "aud",
    "exp",
    "nbf",
    "iat",
    "jti",
    "azp",
    "nonce",
    "auth_time",
    "at_hash",
    "c_hash",
    "acr",
    "amr",
    "sub_jwk",
    "cnf",
    "sip_from_tag",
    "sip_date",
    "sip_callid",
    "sip_cseq_num",
    "sip_via_branch",
    "orig",
    "dest",
    "mky",
    "events",
    "toe",
    "txn",
    "rph",
    "sid",
    "vot",
    "vtm"
], $c5aa5a6035c47210$var$Sa = function(e) {
    if (!e.id_token) throw new Error("ID token is required but missing");
    var t = function(e) {
        var t = e.split("."), n = $c5aa5a6035c47210$var$c(t, 3), r = n[0], o = n[1], i = n[2];
        if (3 !== t.length || !r || !o || !i) throw new Error("ID token could not be decoded");
        var a = JSON.parse($c5aa5a6035c47210$var$ra(o)), s = {
            __raw: e
        }, u = {};
        return Object.keys(a).forEach(function(e) {
            s[e] = a[e], $c5aa5a6035c47210$var$wa.includes(e) || (u[e] = a[e]);
        }), {
            encoded: {
                header: r,
                payload: o,
                signature: i
            },
            header: JSON.parse($c5aa5a6035c47210$var$ra(r)),
            claims: s,
            user: u
        };
    }(e.id_token);
    if (!t.claims.iss) throw new Error("Issuer (iss) claim must be a string present in the ID token");
    if (t.claims.iss !== e.iss) throw new Error('Issuer (iss) claim mismatch in the ID token; expected "'.concat(e.iss, '", found "').concat(t.claims.iss, '"'));
    if (!t.user.sub) throw new Error("Subject (sub) claim must be a string present in the ID token");
    if ("RS256" !== t.header.alg) throw new Error('Signature algorithm of "'.concat(t.header.alg, '" is not supported. Expected the ID token to be signed with "RS256".'));
    if (!t.claims.aud || "string" != typeof t.claims.aud && !Array.isArray(t.claims.aud)) throw new Error("Audience (aud) claim must be a string or array of strings present in the ID token");
    if (Array.isArray(t.claims.aud)) {
        if (!t.claims.aud.includes(e.aud)) throw new Error('Audience (aud) claim mismatch in the ID token; expected "'.concat(e.aud, '" but was not one of "').concat(t.claims.aud.join(", "), '"'));
        if (t.claims.aud.length > 1) {
            if (!t.claims.azp) throw new Error("Authorized Party (azp) claim must be a string present in the ID token when Audience (aud) claim has multiple values");
            if (t.claims.azp !== e.aud) throw new Error('Authorized Party (azp) claim mismatch in the ID token; expected "'.concat(e.aud, '", found "').concat(t.claims.azp, '"'));
        }
    } else if (t.claims.aud !== e.aud) throw new Error('Audience (aud) claim mismatch in the ID token; expected "'.concat(e.aud, '" but found "').concat(t.claims.aud, '"'));
    if (e.nonce) {
        if (!t.claims.nonce) throw new Error("Nonce (nonce) claim must be a string present in the ID token");
        if (t.claims.nonce !== e.nonce) throw new Error('Nonce (nonce) claim mismatch in the ID token; expected "'.concat(e.nonce, '", found "').concat(t.claims.nonce, '"'));
    }
    if (e.max_age && !$c5aa5a6035c47210$var$ga(t.claims.auth_time)) throw new Error("Authentication Time (auth_time) claim must be a number present in the ID token when Max Age (max_age) is specified");
    if (!$c5aa5a6035c47210$var$ga(t.claims.exp)) throw new Error("Expiration Time (exp) claim must be a number present in the ID token");
    if (!$c5aa5a6035c47210$var$ga(t.claims.iat)) throw new Error("Issued At (iat) claim must be a number present in the ID token");
    var n = e.leeway || 60, r = new Date(e.now || Date.now()), o = new Date(0), i = new Date(0), a = new Date(0);
    if (a.setUTCSeconds(parseInt(t.claims.auth_time) + e.max_age + n), o.setUTCSeconds(t.claims.exp + n), i.setUTCSeconds(t.claims.nbf - n), r > o) throw new Error("Expiration Time (exp) claim error in the ID token; current time (".concat(r, ") is after expiration time (").concat(o, ")"));
    if ($c5aa5a6035c47210$var$ga(t.claims.nbf) && r < i) throw new Error("Not Before time (nbf) claim in the ID token indicates that this token can't be used just yet. Currrent time (".concat(r, ") is before ").concat(i));
    if ($c5aa5a6035c47210$var$ga(t.claims.auth_time) && r > a) throw new Error("Authentication Time (auth_time) claim in the ID token indicates that too much time has passed since the last end-user authentication. Currrent time (".concat(r, ") is after last auth at ").concat(a));
    if (e.organizationId) {
        if (!t.claims.org_id) throw new Error("Organization ID (org_id) claim must be a string present in the ID token");
        if (e.organizationId !== t.claims.org_id) throw new Error('Organization ID (org_id) claim mismatch in the ID token; expected "'.concat(e.organizationId, '", found "').concat(t.claims.org_id, '"'));
    }
    return t;
}, $c5aa5a6035c47210$var$ka = $c5aa5a6035c47210$var$l(function(e, t) {
    var n = $c5aa5a6035c47210$var$s && $c5aa5a6035c47210$var$s.__assign || function() {
        return n = Object.assign || function(e) {
            for(var t, n = 1, r = arguments.length; n < r; n++)for(var o in t = arguments[n])Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
            return e;
        }, n.apply(this, arguments);
    };
    function r(e, t) {
        if (!t) return "";
        var n = "; " + e;
        return !0 === t ? n : n + "=" + t;
    }
    function o(e, t, n) {
        return encodeURIComponent(e).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/\(/g, "%28").replace(/\)/g, "%29") + "=" + encodeURIComponent(t).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent) + function(e) {
            if ("number" == typeof e.expires) {
                var t = new Date;
                t.setMilliseconds(t.getMilliseconds() + 864e5 * e.expires), e.expires = t;
            }
            return r("Expires", e.expires ? e.expires.toUTCString() : "") + r("Domain", e.domain) + r("Path", e.path) + r("Secure", e.secure) + r("SameSite", e.sameSite);
        }(n);
    }
    function i(e) {
        for(var t = {}, n = e ? e.split("; ") : [], r = /(%[\dA-F]{2})+/gi, o = 0; o < n.length; o++){
            var i = n[o].split("="), c = i.slice(1).join("=");
            '"' === c.charAt(0) && (c = c.slice(1, -1));
            try {
                t[i[0].replace(r, decodeURIComponent)] = c.replace(r, decodeURIComponent);
            } catch (e) {}
        }
        return t;
    }
    function c() {
        return i(document.cookie);
    }
    function a(e, t, r) {
        document.cookie = o(e, t, n({
            path: "/"
        }, r));
    }
    t.__esModule = !0, t.encode = o, t.parse = i, t.getAll = c, t.get = function(e) {
        return c()[e];
    }, t.set = a, t.remove = function(e, t) {
        a(e, "", n(n({}, t), {
            expires: -1
        }));
    };
});
$c5aa5a6035c47210$var$u($c5aa5a6035c47210$var$ka), $c5aa5a6035c47210$var$ka.encode, $c5aa5a6035c47210$var$ka.parse, $c5aa5a6035c47210$var$ka.getAll;
var $c5aa5a6035c47210$var$_a = $c5aa5a6035c47210$var$ka.get, $c5aa5a6035c47210$var$Ia = $c5aa5a6035c47210$var$ka.set, $c5aa5a6035c47210$var$Oa = $c5aa5a6035c47210$var$ka.remove, $c5aa5a6035c47210$var$xa = {
    get: function(e) {
        var t = $c5aa5a6035c47210$var$_a(e);
        if (void 0 !== t) return JSON.parse(t);
    },
    save: function(e, t, n) {
        var r = {};
        "https:" === window.location.protocol && (r = {
            secure: !0,
            sameSite: "none"
        }), (null == n ? void 0 : n.daysUntilExpire) && (r.expires = n.daysUntilExpire), (null == n ? void 0 : n.cookieDomain) && (r.domain = n.cookieDomain), $c5aa5a6035c47210$var$Ia(e, JSON.stringify(t), r);
    },
    remove: function(e, t) {
        var n = {};
        (null == t ? void 0 : t.cookieDomain) && (n.domain = t.cookieDomain), $c5aa5a6035c47210$var$Oa(e, n);
    }
}, $c5aa5a6035c47210$var$Ta = {
    get: function(e) {
        var t = $c5aa5a6035c47210$var$xa.get(e);
        return t || $c5aa5a6035c47210$var$xa.get("".concat("_legacy_").concat(e));
    },
    save: function(e, t, n) {
        var r = {};
        "https:" === window.location.protocol && (r = {
            secure: !0
        }), (null == n ? void 0 : n.daysUntilExpire) && (r.expires = n.daysUntilExpire), $c5aa5a6035c47210$var$Ia("".concat("_legacy_").concat(e), JSON.stringify(t), r), $c5aa5a6035c47210$var$xa.save(e, t, n);
    },
    remove: function(e, t) {
        var n = {};
        (null == t ? void 0 : t.cookieDomain) && (n.domain = t.cookieDomain), $c5aa5a6035c47210$var$Oa(e, n), $c5aa5a6035c47210$var$xa.remove(e, t), $c5aa5a6035c47210$var$xa.remove("".concat("_legacy_").concat(e), t);
    }
}, $c5aa5a6035c47210$var$Ca = {
    get: function(e) {
        if ("undefined" != typeof sessionStorage) {
            var t = sessionStorage.getItem(e);
            if (void 0 !== t) return JSON.parse(t);
        }
    },
    save: function(e, t) {
        sessionStorage.setItem(e, JSON.stringify(t));
    },
    remove: function(e) {
        sessionStorage.removeItem(e);
    }
};
function $c5aa5a6035c47210$var$ja(e, t, n) {
    var r = void 0 === t ? null : t, o = function(e, t) {
        var n = atob(e);
        if (t) {
            for(var r = new Uint8Array(n.length), o = 0, i = n.length; o < i; ++o)r[o] = n.charCodeAt(o);
            return String.fromCharCode.apply(null, new Uint16Array(r.buffer));
        }
        return n;
    }(e, void 0 !== n && n), i = o.indexOf("\n", 10) + 1, c = o.substring(i) + (r ? "//# sourceMappingURL=" + r : ""), a = new Blob([
        c
    ], {
        type: "application/javascript"
    });
    return URL.createObjectURL(a);
}
var $c5aa5a6035c47210$var$La, $c5aa5a6035c47210$var$Ra, $c5aa5a6035c47210$var$Wa, $c5aa5a6035c47210$var$Za, $c5aa5a6035c47210$var$Ea = ($c5aa5a6035c47210$var$La = "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", $c5aa5a6035c47210$var$Ra = null, $c5aa5a6035c47210$var$Wa = !1, function(e) {
    return $c5aa5a6035c47210$var$Za = $c5aa5a6035c47210$var$Za || $c5aa5a6035c47210$var$ja($c5aa5a6035c47210$var$La, $c5aa5a6035c47210$var$Ra, $c5aa5a6035c47210$var$Wa), new Worker($c5aa5a6035c47210$var$Za, e);
}), $c5aa5a6035c47210$var$Ga = {}, $c5aa5a6035c47210$var$Aa = function() {
    function e(e, t) {
        this.cache = e, this.clientId = t, this.manifestKey = this.createManifestKeyFrom(this.clientId);
    }
    return e.prototype.add = function(e) {
        var t;
        return $c5aa5a6035c47210$var$o(this, void 0, void 0, function() {
            var n, r;
            return $c5aa5a6035c47210$var$i(this, function(o) {
                switch(o.label){
                    case 0:
                        return r = Set.bind, [
                            4,
                            this.cache.get(this.manifestKey)
                        ];
                    case 1:
                        return (n = new (r.apply(Set, [
                            void 0,
                            (null === (t = o.sent()) || void 0 === t ? void 0 : t.keys) || []
                        ]))).add(e), [
                            4,
                            this.cache.set(this.manifestKey, {
                                keys: $c5aa5a6035c47210$var$a([], $c5aa5a6035c47210$var$c(n), !1)
                            })
                        ];
                    case 2:
                        return o.sent(), [
                            2
                        ];
                }
            });
        });
    }, e.prototype.remove = function(e) {
        return $c5aa5a6035c47210$var$o(this, void 0, void 0, function() {
            var t, n;
            return $c5aa5a6035c47210$var$i(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            this.cache.get(this.manifestKey)
                        ];
                    case 1:
                        return (t = r.sent()) ? ((n = new Set(t.keys)).delete(e), n.size > 0 ? [
                            4,
                            this.cache.set(this.manifestKey, {
                                keys: $c5aa5a6035c47210$var$a([], $c5aa5a6035c47210$var$c(n), !1)
                            })
                        ] : [
                            3,
                            3
                        ]) : [
                            3,
                            5
                        ];
                    case 2:
                    case 4:
                        return [
                            2,
                            r.sent()
                        ];
                    case 3:
                        return [
                            4,
                            this.cache.remove(this.manifestKey)
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
    }, e.prototype.get = function() {
        return this.cache.get(this.manifestKey);
    }, e.prototype.clear = function() {
        return this.cache.remove(this.manifestKey);
    }, e.prototype.createManifestKeyFrom = function(e) {
        return "".concat("@@auth0spajs@@", "::").concat(e);
    }, e;
}(), $c5aa5a6035c47210$var$Pa = new $c5aa5a6035c47210$var$Xc, $c5aa5a6035c47210$var$Xa = {
    memory: function() {
        return (new $c5aa5a6035c47210$export$467265324939f47f).enclosedCache;
    },
    localstorage: function() {
        return new $c5aa5a6035c47210$export$40ef2cb682e70737;
    }
}, $c5aa5a6035c47210$var$Fa = function(e) {
    return $c5aa5a6035c47210$var$Xa[e];
}, $c5aa5a6035c47210$var$Ka = function() {
    return !/Trident.*rv:11\.0/.test(navigator.userAgent);
}, $c5aa5a6035c47210$export$b50978e389d6e1d5 = function() {
    function e(e) {
        var t, n, c, a, s = this;
        if (this.options = e, this._releaseLockOnPageHide = function() {
            return $c5aa5a6035c47210$var$o(s, void 0, void 0, function() {
                return $c5aa5a6035c47210$var$i(this, function(e) {
                    switch(e.label){
                        case 0:
                            return [
                                4,
                                $c5aa5a6035c47210$var$Pa.releaseLock("auth0.lock.getTokenSilently")
                            ];
                        case 1:
                            return e.sent(), window.removeEventListener("pagehide", this._releaseLockOnPageHide), [
                                2
                            ];
                    }
                });
            });
        }, "undefined" != typeof window && function() {
            if (!$c5aa5a6035c47210$var$Qc()) throw new Error("For security reasons, `window.crypto` is required to run `auth0-spa-js`.");
            if (void 0 === $c5aa5a6035c47210$var$qc()) throw new Error("\n      auth0-spa-js must run on a secure origin. See https://github.com/auth0/auth0-spa-js/blob/master/FAQ.md#why-do-i-get-auth0-spa-js-must-run-on-a-secure-origin for more information.\n    ");
        }(), e.cache && e.cacheLocation && console.warn("Both `cache` and `cacheLocation` options have been specified in the Auth0Client configuration; ignoring `cacheLocation` and using `cache`."), e.cache) c = e.cache;
        else {
            if (this.cacheLocation = e.cacheLocation || "memory", !$c5aa5a6035c47210$var$Fa(this.cacheLocation)) throw new Error('Invalid cache location "'.concat(this.cacheLocation, '"'));
            c = $c5aa5a6035c47210$var$Fa(this.cacheLocation)();
        }
        this.httpTimeoutMs = e.httpTimeoutInSeconds ? 1e3 * e.httpTimeoutInSeconds : 1e4, this.cookieStorage = !1 === e.legacySameSiteCookie ? $c5aa5a6035c47210$var$xa : $c5aa5a6035c47210$var$Ta, this.orgHintCookieName = (a = this.options.client_id, "auth0.".concat(a, ".organization_hint")), this.isAuthenticatedCookieName = function(e) {
            return "auth0.".concat(e, ".is.authenticated");
        }(this.options.client_id), this.sessionCheckExpiryDays = e.sessionCheckExpiryDays || 1;
        var u, l = e.useCookiesForTransactions ? this.cookieStorage : $c5aa5a6035c47210$var$Ca;
        this.scope = this.options.scope, this.transactionManager = new $c5aa5a6035c47210$var$ba(l, this.options.client_id), this.nowProvider = this.options.nowProvider || $c5aa5a6035c47210$var$Uc, this.cacheManager = new $c5aa5a6035c47210$var$ma(c, c.allKeys ? null : new $c5aa5a6035c47210$var$Aa(c, this.options.client_id), this.nowProvider), this.domainUrl = (u = this.options.domain, /^https?:\/\//.test(u) ? u : "https://".concat(u)), this.tokenIssuer = function(e, t) {
            return e ? e.startsWith("https://") ? e : "https://".concat(e, "/") : "".concat(t, "/");
        }(this.options.issuer, this.domainUrl), this.defaultScope = $c5aa5a6035c47210$var$ha("openid", void 0 !== (null === (n = null === (t = this.options) || void 0 === t ? void 0 : t.advancedOptions) || void 0 === n ? void 0 : n.defaultScope) ? this.options.advancedOptions.defaultScope : "openid profile email"), this.options.useRefreshTokens && (this.scope = $c5aa5a6035c47210$var$ha(this.scope, "offline_access")), "undefined" != typeof window && window.Worker && this.options.useRefreshTokens && "memory" === this.cacheLocation && $c5aa5a6035c47210$var$Ka() && (this.worker = new $c5aa5a6035c47210$var$Ea), this.customOptions = function(e) {
            return e.advancedOptions, e.audience, e.auth0Client, e.authorizeTimeoutInSeconds, e.cacheLocation, e.cache, e.client_id, e.domain, e.issuer, e.leeway, e.max_age, e.nowProvider, e.redirect_uri, e.scope, e.useRefreshTokens, e.useRefreshTokensFallback, e.useCookiesForTransactions, e.useFormData, $c5aa5a6035c47210$var$r(e, [
                "advancedOptions",
                "audience",
                "auth0Client",
                "authorizeTimeoutInSeconds",
                "cacheLocation",
                "cache",
                "client_id",
                "domain",
                "issuer",
                "leeway",
                "max_age",
                "nowProvider",
                "redirect_uri",
                "scope",
                "useRefreshTokens",
                "useRefreshTokensFallback",
                "useCookiesForTransactions",
                "useFormData"
            ]);
        }(e), this.useRefreshTokensFallback = !1 !== this.options.useRefreshTokensFallback;
    }
    return e.prototype._url = function(e) {
        var t = encodeURIComponent(btoa(JSON.stringify(this.options.auth0Client || $c5aa5a6035c47210$var$Nc)));
        return "".concat(this.domainUrl).concat(e, "&auth0Client=").concat(t);
    }, e.prototype._getParams = function(e, t, o, i, c) {
        var a = this.options;
        a.useRefreshTokens, a.useCookiesForTransactions, a.useFormData, a.auth0Client, a.cacheLocation, a.advancedOptions, a.detailedResponse, a.nowProvider, a.authorizeTimeoutInSeconds, a.legacySameSiteCookie, a.sessionCheckExpiryDays, a.domain, a.leeway, a.httpTimeoutInSeconds;
        var s = $c5aa5a6035c47210$var$r(a, [
            "useRefreshTokens",
            "useCookiesForTransactions",
            "useFormData",
            "auth0Client",
            "cacheLocation",
            "advancedOptions",
            "detailedResponse",
            "nowProvider",
            "authorizeTimeoutInSeconds",
            "legacySameSiteCookie",
            "sessionCheckExpiryDays",
            "domain",
            "leeway",
            "httpTimeoutInSeconds"
        ]);
        return $c5aa5a6035c47210$var$n($c5aa5a6035c47210$var$n($c5aa5a6035c47210$var$n({}, s), e), {
            scope: $c5aa5a6035c47210$var$ha(this.defaultScope, this.scope, e.scope),
            response_type: "code",
            response_mode: "query",
            state: t,
            nonce: o,
            redirect_uri: c || this.options.redirect_uri,
            code_challenge: i,
            code_challenge_method: "S256"
        });
    }, e.prototype._authorizeUrl = function(e) {
        return this._url("/authorize?".concat($c5aa5a6035c47210$var$ta(e)));
    }, e.prototype._verifyIdToken = function(e, t, n) {
        return $c5aa5a6035c47210$var$o(this, void 0, void 0, function() {
            var r;
            return $c5aa5a6035c47210$var$i(this, function(o) {
                switch(o.label){
                    case 0:
                        return [
                            4,
                            this.nowProvider()
                        ];
                    case 1:
                        return r = o.sent(), [
                            2,
                            $c5aa5a6035c47210$var$Sa({
                                iss: this.tokenIssuer,
                                aud: this.options.client_id,
                                id_token: e,
                                nonce: t,
                                organizationId: n,
                                leeway: this.options.leeway,
                                max_age: this._parseNumber(this.options.max_age),
                                now: r
                            })
                        ];
                }
            });
        });
    }, e.prototype._parseNumber = function(e) {
        return "string" != typeof e ? e : parseInt(e, 10) || void 0;
    }, e.prototype._processOrgIdHint = function(e) {
        e ? this.cookieStorage.save(this.orgHintCookieName, e, {
            daysUntilExpire: this.sessionCheckExpiryDays,
            cookieDomain: this.options.cookieDomain
        }) : this.cookieStorage.remove(this.orgHintCookieName, {
            cookieDomain: this.options.cookieDomain
        });
    }, e.prototype.buildAuthorizeUrl = function(e) {
        return void 0 === e && (e = {}), $c5aa5a6035c47210$var$o(this, void 0, void 0, function() {
            var t, o, c, a, s, u, l, f, d, h, p, y;
            return $c5aa5a6035c47210$var$i(this, function(i) {
                switch(i.label){
                    case 0:
                        return t = e.redirect_uri, o = e.appState, c = $c5aa5a6035c47210$var$r(e, [
                            "redirect_uri",
                            "appState"
                        ]), a = $c5aa5a6035c47210$var$ea($c5aa5a6035c47210$var$$c()), s = $c5aa5a6035c47210$var$ea($c5aa5a6035c47210$var$$c()), u = $c5aa5a6035c47210$var$$c(), [
                            4,
                            $c5aa5a6035c47210$var$na(u)
                        ];
                    case 1:
                        return l = i.sent(), f = $c5aa5a6035c47210$var$oa(l), d = e.fragment ? "#".concat(e.fragment) : "", h = this._getParams(c, a, s, f, t), p = this._authorizeUrl(h), y = e.organization || this.options.organization, this.transactionManager.create($c5aa5a6035c47210$var$n({
                            nonce: s,
                            code_verifier: u,
                            appState: o,
                            scope: h.scope,
                            audience: h.audience || "default",
                            redirect_uri: h.redirect_uri,
                            state: a
                        }, y && {
                            organizationId: y
                        })), [
                            2,
                            p + d
                        ];
                }
            });
        });
    }, e.prototype.loginWithPopup = function(e, t) {
        return $c5aa5a6035c47210$var$o(this, void 0, void 0, function() {
            var o, c, a, s, u, l, f, d, h, p, y, v, m;
            return $c5aa5a6035c47210$var$i(this, function(i) {
                switch(i.label){
                    case 0:
                        if (e = e || {}, !(t = t || {}).popup && (t.popup = function(e) {
                            var t = window.screenX + (window.innerWidth - 400) / 2, n = window.screenY + (window.innerHeight - 600) / 2;
                            return window.open(e, "auth0:authorize:popup", "left=".concat(t, ",top=").concat(n, ",width=").concat(400, ",height=").concat(600, ",resizable,scrollbars=yes,status=1"));
                        }(""), !t.popup)) throw new Error("Unable to open a popup for loginWithPopup - window.open returned `null`");
                        return o = $c5aa5a6035c47210$var$r(e, []), c = $c5aa5a6035c47210$var$ea($c5aa5a6035c47210$var$$c()), a = $c5aa5a6035c47210$var$ea($c5aa5a6035c47210$var$$c()), s = $c5aa5a6035c47210$var$$c(), [
                            4,
                            $c5aa5a6035c47210$var$na(s)
                        ];
                    case 1:
                        return u = i.sent(), l = $c5aa5a6035c47210$var$oa(u), f = this._getParams(o, c, a, l, this.options.redirect_uri || window.location.origin), d = this._authorizeUrl($c5aa5a6035c47210$var$n($c5aa5a6035c47210$var$n({}, f), {
                            response_mode: "web_message"
                        })), t.popup.location.href = d, [
                            4,
                            $c5aa5a6035c47210$var$Bc($c5aa5a6035c47210$var$n($c5aa5a6035c47210$var$n({}, t), {
                                timeoutInSeconds: t.timeoutInSeconds || this.options.authorizeTimeoutInSeconds || 60
                            }))
                        ];
                    case 2:
                        if (h = i.sent(), c !== h.state) throw new Error("Invalid state");
                        return [
                            4,
                            $c5aa5a6035c47210$var$fa({
                                audience: f.audience,
                                scope: f.scope,
                                baseUrl: this.domainUrl,
                                client_id: this.options.client_id,
                                code_verifier: s,
                                code: h.code,
                                grant_type: "authorization_code",
                                redirect_uri: f.redirect_uri,
                                auth0Client: this.options.auth0Client,
                                useFormData: this.options.useFormData,
                                timeout: this.httpTimeoutMs
                            }, this.worker)
                        ];
                    case 3:
                        return p = i.sent(), y = e.organization || this.options.organization, [
                            4,
                            this._verifyIdToken(p.id_token, a, y)
                        ];
                    case 4:
                        return v = i.sent(), m = $c5aa5a6035c47210$var$n($c5aa5a6035c47210$var$n({}, p), {
                            decodedToken: v,
                            scope: f.scope,
                            audience: f.audience || "default",
                            client_id: this.options.client_id
                        }), [
                            4,
                            this.cacheManager.set(m)
                        ];
                    case 5:
                        return i.sent(), this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
                            daysUntilExpire: this.sessionCheckExpiryDays,
                            cookieDomain: this.options.cookieDomain
                        }), this._processOrgIdHint(v.claims.org_id), [
                            2
                        ];
                }
            });
        });
    }, e.prototype.getUser = function(e) {
        return void 0 === e && (e = {}), $c5aa5a6035c47210$var$o(this, void 0, void 0, function() {
            var t, n, r;
            return $c5aa5a6035c47210$var$i(this, function(o) {
                switch(o.label){
                    case 0:
                        return t = e.audience || this.options.audience || "default", n = $c5aa5a6035c47210$var$ha(this.defaultScope, this.scope, e.scope), [
                            4,
                            this.cacheManager.get(new $c5aa5a6035c47210$var$pa({
                                client_id: this.options.client_id,
                                audience: t,
                                scope: n
                            }))
                        ];
                    case 1:
                        return [
                            2,
                            (r = o.sent()) && r.decodedToken && r.decodedToken.user
                        ];
                }
            });
        });
    }, e.prototype.getIdTokenClaims = function(e) {
        return void 0 === e && (e = {}), $c5aa5a6035c47210$var$o(this, void 0, void 0, function() {
            var t, n, r;
            return $c5aa5a6035c47210$var$i(this, function(o) {
                switch(o.label){
                    case 0:
                        return t = e.audience || this.options.audience || "default", n = $c5aa5a6035c47210$var$ha(this.defaultScope, this.scope, e.scope), [
                            4,
                            this.cacheManager.get(new $c5aa5a6035c47210$var$pa({
                                client_id: this.options.client_id,
                                audience: t,
                                scope: n
                            }))
                        ];
                    case 1:
                        return [
                            2,
                            (r = o.sent()) && r.decodedToken && r.decodedToken.claims
                        ];
                }
            });
        });
    }, e.prototype.loginWithRedirect = function(e) {
        return void 0 === e && (e = {}), $c5aa5a6035c47210$var$o(this, void 0, void 0, function() {
            var t, n, o;
            return $c5aa5a6035c47210$var$i(this, function(i) {
                switch(i.label){
                    case 0:
                        return t = e.redirectMethod, n = $c5aa5a6035c47210$var$r(e, [
                            "redirectMethod"
                        ]), [
                            4,
                            this.buildAuthorizeUrl(n)
                        ];
                    case 1:
                        return o = i.sent(), window.location[t || "assign"](o), [
                            2
                        ];
                }
            });
        });
    }, e.prototype.handleRedirectCallback = function(e) {
        return void 0 === e && (e = window.location.href), $c5aa5a6035c47210$var$o(this, void 0, void 0, function() {
            var t, r, o, a, s, u, l, f, d, h;
            return $c5aa5a6035c47210$var$i(this, function(i) {
                switch(i.label){
                    case 0:
                        if (0 === (t = e.split("?").slice(1)).length) throw new Error("There are no query params available for parsing.");
                        if (r = function(e) {
                            e.indexOf("#") > -1 && (e = e.substr(0, e.indexOf("#")));
                            var t = e.split("&"), n = {};
                            return t.forEach(function(e) {
                                var t = $c5aa5a6035c47210$var$c(e.split("="), 2), r = t[0], o = t[1];
                                n[r] = decodeURIComponent(o);
                            }), n.expires_in && (n.expires_in = parseInt(n.expires_in)), n;
                        }(t.join("")), o = r.state, a = r.code, s = r.error, u = r.error_description, !(l = this.transactionManager.get())) throw new Error("Invalid state");
                        if (this.transactionManager.remove(), s) throw new $c5aa5a6035c47210$export$cf0c46b07324e9c5(s, u, o, l.appState);
                        if (!l.code_verifier || l.state && l.state !== o) throw new Error("Invalid state");
                        return f = {
                            audience: l.audience,
                            scope: l.scope,
                            baseUrl: this.domainUrl,
                            client_id: this.options.client_id,
                            code_verifier: l.code_verifier,
                            grant_type: "authorization_code",
                            code: a,
                            auth0Client: this.options.auth0Client,
                            useFormData: this.options.useFormData,
                            timeout: this.httpTimeoutMs
                        }, void 0 !== l.redirect_uri && (f.redirect_uri = l.redirect_uri), [
                            4,
                            $c5aa5a6035c47210$var$fa(f, this.worker)
                        ];
                    case 1:
                        return d = i.sent(), [
                            4,
                            this._verifyIdToken(d.id_token, l.nonce, l.organizationId)
                        ];
                    case 2:
                        return h = i.sent(), [
                            4,
                            this.cacheManager.set($c5aa5a6035c47210$var$n($c5aa5a6035c47210$var$n($c5aa5a6035c47210$var$n($c5aa5a6035c47210$var$n({}, d), {
                                decodedToken: h,
                                audience: l.audience,
                                scope: l.scope
                            }), d.scope ? {
                                oauthTokenScope: d.scope
                            } : null), {
                                client_id: this.options.client_id
                            }))
                        ];
                    case 3:
                        return i.sent(), this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
                            daysUntilExpire: this.sessionCheckExpiryDays,
                            cookieDomain: this.options.cookieDomain
                        }), this._processOrgIdHint(h.claims.org_id), [
                            2,
                            {
                                appState: l.appState
                            }
                        ];
                }
            });
        });
    }, e.prototype.checkSession = function(e) {
        return $c5aa5a6035c47210$var$o(this, void 0, void 0, function() {
            var t;
            return $c5aa5a6035c47210$var$i(this, function(n) {
                switch(n.label){
                    case 0:
                        if (!this.cookieStorage.get(this.isAuthenticatedCookieName)) {
                            if (!this.cookieStorage.get("auth0.is.authenticated")) return [
                                2
                            ];
                            this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
                                daysUntilExpire: this.sessionCheckExpiryDays,
                                cookieDomain: this.options.cookieDomain
                            }), this.cookieStorage.remove("auth0.is.authenticated");
                        }
                        n.label = 1;
                    case 1:
                        return n.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]), [
                            4,
                            this.getTokenSilently(e)
                        ];
                    case 2:
                        return n.sent(), [
                            3,
                            4
                        ];
                    case 3:
                        if (t = n.sent(), !$c5aa5a6035c47210$var$Kc.includes(t.error)) throw t;
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    }, e.prototype.getTokenSilently = function(e) {
        return void 0 === e && (e = {}), $c5aa5a6035c47210$var$o(this, void 0, void 0, function() {
            var t, o, c, a, s = this;
            return $c5aa5a6035c47210$var$i(this, function(i) {
                switch(i.label){
                    case 0:
                        return t = $c5aa5a6035c47210$var$n($c5aa5a6035c47210$var$n({
                            audience: this.options.audience,
                            ignoreCache: !1
                        }, e), {
                            scope: $c5aa5a6035c47210$var$ha(this.defaultScope, this.scope, e.scope)
                        }), o = t.ignoreCache, c = $c5aa5a6035c47210$var$r(t, [
                            "ignoreCache"
                        ]), [
                            4,
                            (u = function() {
                                return s._getTokenSilently($c5aa5a6035c47210$var$n({
                                    ignoreCache: o
                                }, c));
                            }, l = "".concat(this.options.client_id, "::").concat(c.audience, "::").concat(c.scope), f = $c5aa5a6035c47210$var$Ga[l], f || (f = u().finally(function() {
                                delete $c5aa5a6035c47210$var$Ga[l], f = null;
                            }), $c5aa5a6035c47210$var$Ga[l] = f), f)
                        ];
                    case 1:
                        return a = i.sent(), [
                            2,
                            e.detailedResponse ? a : a.access_token
                        ];
                }
                var u, l, f;
            });
        });
    }, e.prototype._getTokenSilently = function(e) {
        return void 0 === e && (e = {}), $c5aa5a6035c47210$var$o(this, void 0, void 0, function() {
            var t, c, a, s, u, l, f, d, h;
            return $c5aa5a6035c47210$var$i(this, function(p) {
                switch(p.label){
                    case 0:
                        return t = e.ignoreCache, c = $c5aa5a6035c47210$var$r(e, [
                            "ignoreCache"
                        ]), t ? [
                            3,
                            2
                        ] : [
                            4,
                            this._getEntryFromCache({
                                scope: c.scope,
                                audience: c.audience || "default",
                                client_id: this.options.client_id
                            })
                        ];
                    case 1:
                        if (a = p.sent()) return [
                            2,
                            a
                        ];
                        p.label = 2;
                    case 2:
                        return [
                            4,
                            (y = function() {
                                return $c5aa5a6035c47210$var$Pa.acquireLock("auth0.lock.getTokenSilently", 5e3);
                            }, v = 10, void 0 === v && (v = 3), $c5aa5a6035c47210$var$o(void 0, void 0, void 0, function() {
                                var e;
                                return $c5aa5a6035c47210$var$i(this, function(t) {
                                    switch(t.label){
                                        case 0:
                                            e = 0, t.label = 1;
                                        case 1:
                                            return e < v ? [
                                                4,
                                                y()
                                            ] : [
                                                3,
                                                4
                                            ];
                                        case 2:
                                            if (t.sent()) return [
                                                2,
                                                !0
                                            ];
                                            t.label = 3;
                                        case 3:
                                            return e++, [
                                                3,
                                                1
                                            ];
                                        case 4:
                                            return [
                                                2,
                                                !1
                                            ];
                                    }
                                });
                            }))
                        ];
                    case 3:
                        if (!p.sent()) return [
                            3,
                            15
                        ];
                        p.label = 4;
                    case 4:
                        return p.trys.push([
                            4,
                            ,
                            12,
                            14
                        ]), window.addEventListener("pagehide", this._releaseLockOnPageHide), t ? [
                            3,
                            6
                        ] : [
                            4,
                            this._getEntryFromCache({
                                scope: c.scope,
                                audience: c.audience || "default",
                                client_id: this.options.client_id
                            })
                        ];
                    case 5:
                        if (a = p.sent()) return [
                            2,
                            a
                        ];
                        p.label = 6;
                    case 6:
                        return this.options.useRefreshTokens ? [
                            4,
                            this._getTokenUsingRefreshToken(c)
                        ] : [
                            3,
                            8
                        ];
                    case 7:
                        return u = p.sent(), [
                            3,
                            10
                        ];
                    case 8:
                        return [
                            4,
                            this._getTokenFromIFrame(c)
                        ];
                    case 9:
                        u = p.sent(), p.label = 10;
                    case 10:
                        return s = u, [
                            4,
                            this.cacheManager.set($c5aa5a6035c47210$var$n({
                                client_id: this.options.client_id
                            }, s))
                        ];
                    case 11:
                        return p.sent(), this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
                            daysUntilExpire: this.sessionCheckExpiryDays,
                            cookieDomain: this.options.cookieDomain
                        }), l = s.id_token, f = s.access_token, d = s.oauthTokenScope, h = s.expires_in, [
                            2,
                            $c5aa5a6035c47210$var$n($c5aa5a6035c47210$var$n({
                                id_token: l,
                                access_token: f
                            }, d ? {
                                scope: d
                            } : null), {
                                expires_in: h
                            })
                        ];
                    case 12:
                        return [
                            4,
                            $c5aa5a6035c47210$var$Pa.releaseLock("auth0.lock.getTokenSilently")
                        ];
                    case 13:
                        return p.sent(), window.removeEventListener("pagehide", this._releaseLockOnPageHide), [
                            7
                        ];
                    case 14:
                        return [
                            3,
                            16
                        ];
                    case 15:
                        throw new $c5aa5a6035c47210$export$66d311bf29d5c89c;
                    case 16:
                        return [
                            2
                        ];
                }
                var y, v;
            });
        });
    }, e.prototype.getTokenWithPopup = function(e, t) {
        return void 0 === e && (e = {}), void 0 === t && (t = {}), $c5aa5a6035c47210$var$o(this, void 0, void 0, function() {
            return $c5aa5a6035c47210$var$i(this, function(r) {
                switch(r.label){
                    case 0:
                        return e.audience = e.audience || this.options.audience, e.scope = $c5aa5a6035c47210$var$ha(this.defaultScope, this.scope, e.scope), t = $c5aa5a6035c47210$var$n($c5aa5a6035c47210$var$n({}, $c5aa5a6035c47210$var$Fc), t), [
                            4,
                            this.loginWithPopup(e, t)
                        ];
                    case 1:
                        return r.sent(), [
                            4,
                            this.cacheManager.get(new $c5aa5a6035c47210$var$pa({
                                scope: e.scope,
                                audience: e.audience || "default",
                                client_id: this.options.client_id
                            }))
                        ];
                    case 2:
                        return [
                            2,
                            r.sent().access_token
                        ];
                }
            });
        });
    }, e.prototype.isAuthenticated = function() {
        return $c5aa5a6035c47210$var$o(this, void 0, void 0, function() {
            return $c5aa5a6035c47210$var$i(this, function(e) {
                switch(e.label){
                    case 0:
                        return [
                            4,
                            this.getUser()
                        ];
                    case 1:
                        return [
                            2,
                            !!e.sent()
                        ];
                }
            });
        });
    }, e.prototype.buildLogoutUrl = function(e) {
        void 0 === e && (e = {}), null !== e.client_id ? e.client_id = e.client_id || this.options.client_id : delete e.client_id;
        var t = e.federated, n = $c5aa5a6035c47210$var$r(e, [
            "federated"
        ]), o = t ? "&federated" : "";
        return this._url("/v2/logout?".concat($c5aa5a6035c47210$var$ta(n))) + o;
    }, e.prototype.logout = function(e) {
        var t = this;
        void 0 === e && (e = {});
        var n = e.localOnly, o = $c5aa5a6035c47210$var$r(e, [
            "localOnly"
        ]);
        if (n && o.federated) throw new Error("It is invalid to set both the `federated` and `localOnly` options to `true`");
        var i = function() {
            if (t.cookieStorage.remove(t.orgHintCookieName, {
                cookieDomain: t.options.cookieDomain
            }), t.cookieStorage.remove(t.isAuthenticatedCookieName, {
                cookieDomain: t.options.cookieDomain
            }), !n) {
                var e = t.buildLogoutUrl(o);
                window.location.assign(e);
            }
        };
        if (this.options.cache) return this.cacheManager.clear().then(function() {
            return i();
        });
        this.cacheManager.clearSync(), i();
    }, e.prototype._getTokenFromIFrame = function(e) {
        return $c5aa5a6035c47210$var$o(this, void 0, void 0, function() {
            var t, o, c, a, s, u, l, f, d, h, p, y, v, m, b, g, w;
            return $c5aa5a6035c47210$var$i(this, function(i) {
                switch(i.label){
                    case 0:
                        return t = $c5aa5a6035c47210$var$ea($c5aa5a6035c47210$var$$c()), o = $c5aa5a6035c47210$var$ea($c5aa5a6035c47210$var$$c()), c = $c5aa5a6035c47210$var$$c(), [
                            4,
                            $c5aa5a6035c47210$var$na(c)
                        ];
                    case 1:
                        a = i.sent(), s = $c5aa5a6035c47210$var$oa(a), u = $c5aa5a6035c47210$var$r(e, [
                            "detailedResponse"
                        ]), l = this._getParams(u, t, o, s, e.redirect_uri || this.options.redirect_uri || window.location.origin), (f = this.cookieStorage.get(this.orgHintCookieName)) && !l.organization && (l.organization = f), d = this._authorizeUrl($c5aa5a6035c47210$var$n($c5aa5a6035c47210$var$n({}, l), {
                            prompt: "none",
                            response_mode: "web_message"
                        })), i.label = 2;
                    case 2:
                        if (i.trys.push([
                            2,
                            6,
                            ,
                            7
                        ]), window.crossOriginIsolated) throw new $c5aa5a6035c47210$export$7d465be8efa67280("login_required", "The application is running in a Cross-Origin Isolated context, silently retrieving a token without refresh token is not possible.");
                        return h = e.timeoutInSeconds || this.options.authorizeTimeoutInSeconds, [
                            4,
                            (S = d, k = this.domainUrl, _ = h, void 0 === _ && (_ = 60), new Promise(function(e, t) {
                                var n = window.document.createElement("iframe");
                                n.setAttribute("width", "0"), n.setAttribute("height", "0"), n.style.display = "none";
                                var r, o = function() {
                                    window.document.body.contains(n) && (window.document.body.removeChild(n), window.removeEventListener("message", r, !1));
                                }, i = setTimeout(function() {
                                    t(new $c5aa5a6035c47210$export$66d311bf29d5c89c), o();
                                }, 1e3 * _);
                                r = function(n) {
                                    if (n.origin == k && n.data && "authorization_response" === n.data.type) {
                                        var c = n.source;
                                        c && c.close(), n.data.response.error ? t($c5aa5a6035c47210$export$7d465be8efa67280.fromPayload(n.data.response)) : e(n.data.response), clearTimeout(i), window.removeEventListener("message", r, !1), setTimeout(o, 2e3);
                                    }
                                }, window.addEventListener("message", r, !1), window.document.body.appendChild(n), n.setAttribute("src", S);
                            }))
                        ];
                    case 3:
                        if (p = i.sent(), t !== p.state) throw new Error("Invalid state");
                        return y = e.scope, v = e.audience, m = $c5aa5a6035c47210$var$r(e, [
                            "scope",
                            "audience",
                            "redirect_uri",
                            "ignoreCache",
                            "timeoutInSeconds",
                            "detailedResponse"
                        ]), [
                            4,
                            $c5aa5a6035c47210$var$fa($c5aa5a6035c47210$var$n($c5aa5a6035c47210$var$n($c5aa5a6035c47210$var$n({}, this.customOptions), m), {
                                scope: y,
                                audience: v,
                                baseUrl: this.domainUrl,
                                client_id: this.options.client_id,
                                code_verifier: c,
                                code: p.code,
                                grant_type: "authorization_code",
                                redirect_uri: l.redirect_uri,
                                auth0Client: this.options.auth0Client,
                                useFormData: this.options.useFormData,
                                timeout: m.timeout || this.httpTimeoutMs
                            }), this.worker)
                        ];
                    case 4:
                        return b = i.sent(), [
                            4,
                            this._verifyIdToken(b.id_token, o)
                        ];
                    case 5:
                        return g = i.sent(), this._processOrgIdHint(g.claims.org_id), [
                            2,
                            $c5aa5a6035c47210$var$n($c5aa5a6035c47210$var$n({}, b), {
                                decodedToken: g,
                                scope: l.scope,
                                oauthTokenScope: b.scope,
                                audience: l.audience || "default"
                            })
                        ];
                    case 6:
                        throw "login_required" === (w = i.sent()).error && this.logout({
                            localOnly: !0
                        }), w;
                    case 7:
                        return [
                            2
                        ];
                }
                var S, k, _;
            });
        });
    }, e.prototype._getTokenUsingRefreshToken = function(e) {
        return $c5aa5a6035c47210$var$o(this, void 0, void 0, function() {
            var t, o, c, a, s, u, l, f, d;
            return $c5aa5a6035c47210$var$i(this, function(i) {
                switch(i.label){
                    case 0:
                        return e.scope = $c5aa5a6035c47210$var$ha(this.defaultScope, this.options.scope, e.scope), [
                            4,
                            this.cacheManager.get(new $c5aa5a6035c47210$var$pa({
                                scope: e.scope,
                                audience: e.audience || "default",
                                client_id: this.options.client_id
                            }))
                        ];
                    case 1:
                        return (t = i.sent()) && t.refresh_token || this.worker ? [
                            3,
                            4
                        ] : this.useRefreshTokensFallback ? [
                            4,
                            this._getTokenFromIFrame(e)
                        ] : [
                            3,
                            3
                        ];
                    case 2:
                        return [
                            2,
                            i.sent()
                        ];
                    case 3:
                        throw new $c5aa5a6035c47210$var$Mc(e.audience || "default", e.scope);
                    case 4:
                        o = e.redirect_uri || this.options.redirect_uri || window.location.origin, a = e.scope, s = e.audience, u = $c5aa5a6035c47210$var$r(e, [
                            "scope",
                            "audience",
                            "ignoreCache",
                            "timeoutInSeconds",
                            "detailedResponse"
                        ]), l = "number" == typeof e.timeoutInSeconds ? 1e3 * e.timeoutInSeconds : null, i.label = 5;
                    case 5:
                        return i.trys.push([
                            5,
                            7,
                            ,
                            10
                        ]), [
                            4,
                            $c5aa5a6035c47210$var$fa($c5aa5a6035c47210$var$n($c5aa5a6035c47210$var$n($c5aa5a6035c47210$var$n($c5aa5a6035c47210$var$n($c5aa5a6035c47210$var$n({}, this.customOptions), u), {
                                audience: s,
                                scope: a,
                                baseUrl: this.domainUrl,
                                client_id: this.options.client_id,
                                grant_type: "refresh_token",
                                refresh_token: t && t.refresh_token,
                                redirect_uri: o
                            }), l && {
                                timeout: l
                            }), {
                                auth0Client: this.options.auth0Client,
                                useFormData: this.options.useFormData,
                                timeout: this.httpTimeoutMs
                            }), this.worker)
                        ];
                    case 6:
                        return c = i.sent(), [
                            3,
                            10
                        ];
                    case 7:
                        return ((f = i.sent()).message.indexOf("Missing Refresh Token") > -1 || f.message && f.message.indexOf("invalid refresh token") > -1) && this.useRefreshTokensFallback ? [
                            4,
                            this._getTokenFromIFrame(e)
                        ] : [
                            3,
                            9
                        ];
                    case 8:
                        return [
                            2,
                            i.sent()
                        ];
                    case 9:
                        throw f;
                    case 10:
                        return [
                            4,
                            this._verifyIdToken(c.id_token)
                        ];
                    case 11:
                        return d = i.sent(), [
                            2,
                            $c5aa5a6035c47210$var$n($c5aa5a6035c47210$var$n({}, c), {
                                decodedToken: d,
                                scope: e.scope,
                                oauthTokenScope: c.scope,
                                audience: e.audience || "default"
                            })
                        ];
                }
            });
        });
    }, e.prototype._getEntryFromCache = function(e) {
        var t = e.scope, r = e.audience, c = e.client_id;
        return $c5aa5a6035c47210$var$o(this, void 0, void 0, function() {
            var e, o, a, s, u;
            return $c5aa5a6035c47210$var$i(this, function(i) {
                switch(i.label){
                    case 0:
                        return [
                            4,
                            this.cacheManager.get(new $c5aa5a6035c47210$var$pa({
                                scope: t,
                                audience: r,
                                client_id: c
                            }), 60)
                        ];
                    case 1:
                        return (e = i.sent()) && e.access_token ? (o = e.id_token, a = e.access_token, s = e.oauthTokenScope, u = e.expires_in, [
                            2,
                            $c5aa5a6035c47210$var$n($c5aa5a6035c47210$var$n({
                                id_token: o,
                                access_token: a
                            }, s ? {
                                scope: s
                            } : null), {
                                expires_in: u
                            })
                        ]) : [
                            2
                        ];
                }
            });
        });
    }, e;
}(), $c5aa5a6035c47210$export$1f44aaf2ec115b54 = function() {};
function $c5aa5a6035c47210$export$2e2bcd8739ae039(e) {
    return $c5aa5a6035c47210$var$o(this, void 0, void 0, function() {
        var t;
        return $c5aa5a6035c47210$var$i(this, function(n) {
            switch(n.label){
                case 0:
                    return [
                        4,
                        (t = new $c5aa5a6035c47210$export$b50978e389d6e1d5(e)).checkSession()
                    ];
                case 1:
                    return n.sent(), [
                        2,
                        t
                    ];
            }
        });
    });
}


// @TODO use uuid to generate the notifications ids
// it will be better and there will be less change of id repetition
const $e75b18aae82f997e$var$notifications = document.getElementById('notifications');
const $e75b18aae82f997e$var$hide_after_delay = (id, hide_delay)=>setTimeout(()=>{
        const alert_node = document.querySelector(`#${id}`);
        const alert = bootstrap.Alert.getOrCreateInstance(alert_node);
        alert.close();
    }, hide_delay);
const $e75b18aae82f997e$var$add_notification = (id, type, message, action_button = '')=>$e75b18aae82f997e$var$notifications.innerHTML += `
  <div id="${id}" class="alert alert-${type} alert-dismissible fade show mt-2" role="alert">
    <span>${message}</span>
    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    ${action_button}
  </div>
`;
const $e75b18aae82f997e$export$fe7c49d056ea1d88 = (message, hide_delay, action_button = '')=>{
    const id = `notification_success_${Date.now()}`;
    $e75b18aae82f997e$var$add_notification(id, 'success', message, action_button);
    if (Number.isFinite(hide_delay)) $e75b18aae82f997e$var$hide_after_delay(id, hide_delay);
};
const $e75b18aae82f997e$export$a3bc9b8ed74fc = (message, hide_delay, action_button = '')=>{
    const id = `notification_error_${Date.now()}`;
    $e75b18aae82f997e$var$add_notification(id, 'danger', message, action_button);
    if (Number.isFinite(hide_delay)) $e75b18aae82f997e$var$hide_after_delay(id, hide_delay);
};
const $e75b18aae82f997e$export$caccbb2cffa74094 = ()=>$e75b18aae82f997e$var$notifications.innerHTML = '';


let $8a78e832e9175edf$var$auth0 = null;
const [$8a78e832e9175edf$var$client_id, $8a78e832e9175edf$var$domain, $8a78e832e9175edf$var$audience] = [
    "mR5pYsgw9913IgT8sH3mVVotYLyumNwt",
    "action-station.au.auth0.com",
    "https://actionstation-api"
];
const $8a78e832e9175edf$var$initialise_auth = async ()=>$8a78e832e9175edf$var$auth0 = await (0, $c5aa5a6035c47210$export$2e2bcd8739ae039)({
        client_id: $8a78e832e9175edf$var$client_id,
        domain: $8a78e832e9175edf$var$domain,
        audience: $8a78e832e9175edf$var$audience
    });
const $8a78e832e9175edf$var$get_error = (search_params)=>{
    const type = search_params.get('error');
    if (!type) return null;
    return {
        type: type,
        message: search_params.get('error_description')
    };
};
const $8a78e832e9175edf$var$clear_session = ()=>{
    sessionStorage.removeItem('access_token');
    sessionStorage.removeItem('user');
};
const $8a78e832e9175edf$export$a0973bcfe11b05c9 = async ()=>{
    if (!$8a78e832e9175edf$var$auth0) await $8a78e832e9175edf$var$initialise_auth();
    $8a78e832e9175edf$var$clear_session();
    await $8a78e832e9175edf$var$auth0.logout({
        returnTo: window.location.origin
    });
};
const $8a78e832e9175edf$export$61bb00ddedae72e4 = async ()=>{
    if (!$8a78e832e9175edf$var$auth0) await $8a78e832e9175edf$var$initialise_auth();
    const search_params = new URLSearchParams(location.search);
    const auth0_error = $8a78e832e9175edf$var$get_error(search_params);
    if (auth0_error) throw new Error(auth0_error.message || '', {
        cause: auth0_error
    });
    const is_callback = search_params.get('code') && search_params.get('state');
    if (!await $8a78e832e9175edf$var$auth0.isAuthenticated() && !is_callback) {
        $8a78e832e9175edf$var$clear_session();
        (0, $e75b18aae82f997e$export$a3bc9b8ed74fc)('Please login to the Admin App');
        return $8a78e832e9175edf$var$auth0.loginWithRedirect({
            redirect_uri: location.origin,
            appState: {}
        });
    }
    if (is_callback) {
        const { appState: appState } = await $8a78e832e9175edf$var$auth0.handleRedirectCallback();
        window.history.replaceState({}, document.title, '/');
    }
    if (!sessionStorage.access_token || !sessionStorage.user) {
        sessionStorage.access_token = await $8a78e832e9175edf$var$auth0.getTokenSilently();
        sessionStorage.user = JSON.stringify(await $8a78e832e9175edf$var$auth0.getUser());
    }
};



const $e415eb1f4a0744b8$var$spinner = document.getElementById('spinner');
var $e415eb1f4a0744b8$export$2e2bcd8739ae039 = {
    display () {
        $e415eb1f4a0744b8$var$spinner.classList.add('d-flex');
        $e415eb1f4a0744b8$var$spinner.classList.remove('d-none');
    },
    hide () {
        $e415eb1f4a0744b8$var$spinner.classList.remove('d-flex');
        $e415eb1f4a0744b8$var$spinner.classList.add('d-none');
    }
};


const $96e14f2a7c3555e4$var$api_endpoint = "https://admin-api.actionstation.nz";
const $96e14f2a7c3555e4$var$request = async (method, path, data = '')=>{
    (0, $e75b18aae82f997e$export$caccbb2cffa74094)();
    (0, $e415eb1f4a0744b8$export$2e2bcd8739ae039).display();
    const body = data === '' ? null : JSON.stringify(data);
    try {
        const response = await fetch(`${$96e14f2a7c3555e4$var$api_endpoint}${path}`, {
            method: method,
            body: body,
            mode: 'cors',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${sessionStorage.access_token}`,
                'Content-Type': 'application/json'
            }
        });
        const { status: status, statusText: statusText } = response;
        if (response.status !== 200) throw new Error(`${status} ${statusText}`, {
            cause: response
        });
        const json = response.json();
        (0, $e415eb1f4a0744b8$export$2e2bcd8739ae039).hide();
        return json;
    } catch (error) {
        (0, $e415eb1f4a0744b8$export$2e2bcd8739ae039).hide();
        throw error;
    }
};
var $96e14f2a7c3555e4$export$2e2bcd8739ae039 = {
    post: (path, data)=>$96e14f2a7c3555e4$var$request('POST', path, data),
    'delete': (path)=>$96e14f2a7c3555e4$var$request('DELETE', path),
    get: (path)=>$96e14f2a7c3555e4$var$request('GET', path)
};



const $820877bea407f5fe$export$740318eb18b4f384 = (to, subject, body)=>{
    return `${"https://mail.google.com/mail/u/0/?view=cm&fs=1&tf=1"}&to=${to}&su=${subject}&body=${body}`;
};


const $a2556f7a9c7c255d$var$GENERIC_ERROR_MESSAGE = 'We had an error in our system. Please try again.';
async function $a2556f7a9c7c255d$export$7de37b76abf5a084(event) {
    event.preventDefault();
    const email = document.getElementById('member_delete_email').value.toLowerCase();
    try {
        const report = await (0, $96e14f2a7c3555e4$export$2e2bcd8739ae039).delete(`/members?email=${email}`);
        const systems = [];
        for(const key in report)// check if the value is true and then add it to systems
        if (report[key] === true) systems.push(key);
        if (systems.length === 0) return (0, $e75b18aae82f997e$export$a3bc9b8ed74fc)(`Member ${email} does not exist in any of our systems.`);
        const systems_to_delete = systems.join(', ');
        const gmail_body = `
    ${email}
    %0A%0A
    ${systems_to_delete}
    `;
        const asana_task_gmail_url = (0, $820877bea407f5fe$export$740318eb18b4f384)(`${"x%2B1132193236560400@mail.asana.com"},${"joe@actionstation.org.nz"}`, `Member%20delete ${email} `, gmail_body);
        const action_button = `
    <div class="d-flex" id="assign_task_button">
      <a href="${asana_task_gmail_url}" target="_blank" type="button" class="btn btn-secondary ms-auto">Assign to Tech Team</a>
    </div>
    `;
        (0, $e75b18aae82f997e$export$fe7c49d056ea1d88)(`Member ${email} needs to be deleted from ${systems_to_delete}.`, null, action_button);
    } catch (e) {
        console.error(e);
        (0, $e75b18aae82f997e$export$a3bc9b8ed74fc)($a2556f7a9c7c255d$var$GENERIC_ERROR_MESSAGE);
    }
}
async function $a2556f7a9c7c255d$export$b2956332a07d6aed(event) {
    event.preventDefault();
    let old_email = document.getElementById('member_merge_old_email').value.toLowerCase();
    let new_email = document.getElementById('member_merge_new_email').value.toLowerCase();
    const data = {
        old_email: old_email,
        new_email: new_email
    };
    try {
        const { instructions: instructions } = await (0, $96e14f2a7c3555e4$export$2e2bcd8739ae039).post('/members/merge', data);
        let instructions_html = '';
        let instructions_text = '';
        for(const source in instructions){
            if (instructions[source].length === 0) continue;
            instructions_html += `
      <p>${source}</p>
      <pre>${instructions[source].join('\n')}</pre>
      `;
            instructions_text += `${source}, `;
        }
        if (instructions_text === '') return (0, $e75b18aae82f997e$export$a3bc9b8ed74fc)('There are no accounts to merge');
        // After we do all the checks above, we assume the api call went well
        // and we build the notification message for the user
        const gmail_body = `
    ${old_email}
    %0A%0A
    ${instructions_text.slice(0, -2)}
    `;
        const asana_task_gmail_url = (0, $820877bea407f5fe$export$740318eb18b4f384)(`${"x%2B1132193236560400@mail.asana.com"},${"joe@actionstation.org.nz"}`, `Member%20merge ${new_email} `, gmail_body);
        const action_button = `
    <div class="d-flex" id="assign_task_button">
      <a href="${asana_task_gmail_url}" target="_blank" type="button" class="btn btn-secondary ms-auto">Assign to Tech Team</a>
    </div>
    `;
        (0, $e75b18aae82f997e$export$fe7c49d056ea1d88)(`
      <p><strong>Merge Instructions</strong></p>
      ${instructions_html}
    `, null, action_button);
    } catch (e) {
        console.error(e);
        (0, $e75b18aae82f997e$export$a3bc9b8ed74fc)($a2556f7a9c7c255d$var$GENERIC_ERROR_MESSAGE);
    }
}




function $c068f8eec561c6ff$var$date_greater_than(date_string_1, date_string_2) {
    const date1 = new Date(date_string_1);
    const date2 = new Date(date_string_2);
    return date1 > date2;
}
async function $c068f8eec561c6ff$export$cb27ed49b76102f3(event) {
    event.preventDefault();
    const from = document.getElementById('run_odr_from').value;
    const to = document.getElementById('run_odr_to').value;
    if ($c068f8eec561c6ff$var$date_greater_than(from, to)) return (0, $e75b18aae82f997e$export$a3bc9b8ed74fc)('The "From" date needs to be the same or earlier than the "To" date.');
    const data = {
        from: from,
        to: to
    };
    try {
        const response_data = await (0, $96e14f2a7c3555e4$export$2e2bcd8739ae039).post('/donations', data);
        const status_code = response_data.StatusCode;
        if (status_code !== 202) return (0, $e75b18aae82f997e$export$a3bc9b8ed74fc)(`Something went wrong. Please try again. Status code: ${status_code}.`);
        (0, $e75b18aae82f997e$export$fe7c49d056ea1d88)('The ODR process has been scheduled to run. You will receive an email soon.', 2000);
    } catch (error) {
        console.log(error);
        error('Something went wrong. Please try again.');
    }
}




const $10be65cfb5457bdb$var$GENERIC_ERROR_MESSAGE = 'We had an error in our system. Please try again.';
async function $10be65cfb5457bdb$export$a950f7ffc902bb70(event) {
    event.preventDefault();
    const date = new Date();
    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    if (month < 10) month = `0${month}`;
    try {
        const id = await (0, $96e14f2a7c3555e4$export$2e2bcd8739ae039).get(`/donors/monthly/latest?month=${month}&year=${year}`);
        window.open(`https://identity.actionstation.org.nz/lists/${id}`);
    } catch (e) {
        if (e.cause.status === 404) (0, $e75b18aae82f997e$export$a3bc9b8ed74fc)(`Can't find the list for ${month}/${year}. Please contact Tech team`);
        else (0, $e75b18aae82f997e$export$a3bc9b8ed74fc)($10be65cfb5457bdb$var$GENERIC_ERROR_MESSAGE);
    }
}




const $48adcfa9889e9efb$var$GENERIC_ERROR_MESSAGE = 'We had an error in our system. Please try again.';
async function $48adcfa9889e9efb$export$23b1b67f7baa49f1(event) {
    event.preventDefault();
    const date = new Date();
    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    if (month < 10) month = `0${month}`;
    try {
        const id = await (0, $96e14f2a7c3555e4$export$2e2bcd8739ae039).get(`/donors/lost/monthly/latest?month=${month}&year=${year}`);
        window.open(`https://identity.actionstation.org.nz/lists/${id}`);
    } catch (e) {
        if (e.cause.status === 404) (0, $e75b18aae82f997e$export$a3bc9b8ed74fc)(`Can't find the list for ${month}/${year}. Please contact Tech team`);
        else (0, $e75b18aae82f997e$export$a3bc9b8ed74fc)($48adcfa9889e9efb$var$GENERIC_ERROR_MESSAGE);
    }
}





const $02c2268973ed0f7e$var$GENERIC_ERROR_MESSAGE = 'We had an error in our system. Please try again.';
async function $02c2268973ed0f7e$export$98b863ab427f4a04(event) {
    event.preventDefault();
    const staff_email = document.getElementById('offboarding_staff_email').value;
    const authorisation_key = document.getElementById('offboarding_auth_key').value;
    const data = {
        staff_email: staff_email,
        authorisation_key: authorisation_key
    };
    try {
        const response = await (0, $96e14f2a7c3555e4$export$2e2bcd8739ae039).post('/offboarding', data);
        let offboarded_html = '';
        let manual_offboarding_html = '';
        let offboard_instructions_text = '';
        console.log(response);
        for(const source in response)if (!response[source]) {
            manual_offboarding_html += `<p>${source}</p>`;
            offboard_instructions_text += `${source}, `;
        } else offboarded_html += `<p>${source}</p>`;
        const gmail_body = `
      ${staff_email}
      %0A%0A
      ${offboard_instructions_text.slice(0, -2)}
    `;
        const asana_task_gmail_url = (0, $820877bea407f5fe$export$740318eb18b4f384)(`${"x%2B1132193236560400@mail.asana.com"},${"joe@actionstation.org.nz"}`, `Manually%20offboard ${staff_email} `, gmail_body);
        const action_button = `
      <div class="d-flex" id="assign_task_button">
        <a href="${asana_task_gmail_url}" target="_blank" type="button" class="btn btn-secondary ms-auto">Assign to Tech Team</a>
      </div>
    `;
        (0, $e75b18aae82f997e$export$fe7c49d056ea1d88)(`
       <p><strong>Offboarded Correctly from:</strong></p>
        ${offboarded_html}
        <p><strong>Needs Manual Offboarding from:</strong></p>
        ${manual_offboarding_html}
      `, null, action_button);
    } catch (e) {
        if (e.cause) {
            const error_object = await e.cause.json();
            return (0, $e75b18aae82f997e$export$a3bc9b8ed74fc)(error_object.message);
        }
        (0, $e75b18aae82f997e$export$a3bc9b8ed74fc)($02c2268973ed0f7e$var$GENERIC_ERROR_MESSAGE);
    }
}



function $35da740d59af89ba$var$ready(fn) {
    if (document.readyState != 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
}
// when the document is ready, do this
$35da740d59af89ba$var$ready(async ()=>{
    try {
        await (0, $8a78e832e9175edf$export$61bb00ddedae72e4)();
        if (!sessionStorage.user || !sessionStorage.access_token) return;
        const logout_button = document.getElementById('logout');
        logout_button.addEventListener('click', (0, $8a78e832e9175edf$export$a0973bcfe11b05c9));
        const logged_in = document.getElementById('logged_in');
        logged_in.classList.remove('d-none');
        const member_delete_form = document.getElementById('member_delete_form');
        member_delete_form.addEventListener('submit', (0, $a2556f7a9c7c255d$export$7de37b76abf5a084));
        const member_merge_form = document.getElementById('member_merge_form');
        member_merge_form.addEventListener('submit', (0, $a2556f7a9c7c255d$export$b2956332a07d6aed));
        const run_odr_form = document.getElementById('run_odr_form');
        run_odr_form.addEventListener('submit', (0, $c068f8eec561c6ff$export$cb27ed49b76102f3));
        const get_latest_regular_donors_form = document.getElementById('get_latest_regular_donors_form');
        get_latest_regular_donors_form.addEventListener('submit', (0, $10be65cfb5457bdb$export$a950f7ffc902bb70));
        const get_latest_lost_donors_form = document.getElementById('get_latest_lost_donors_form');
        get_latest_lost_donors_form.addEventListener('submit', (0, $48adcfa9889e9efb$export$23b1b67f7baa49f1));
        const hr_offboard_form = document.getElementById('hr_offboard_form');
        hr_offboard_form.addEventListener('submit', (0, $02c2268973ed0f7e$export$98b863ab427f4a04));
        // activate the first tab
        document.querySelector('#v-pills-members-tab').classList.add('active');
        document.querySelector('#v-pills-members').classList.add('active');
    } catch (e) {
        // @TODO when showing the error, provide a link to refresh the app
        return (0, $e75b18aae82f997e$export$a3bc9b8ed74fc)(e.message);
    }
});


//# sourceMappingURL=admin-app.7084fa47.js.map
